import axios from 'axios'
import EXIF from 'exif-js'
import HorizontalMsg from '@/components/templates/HorizontalMsg.vue'
import Alert from '@/components/templates/Alert.vue'

//export const window.advMixin = {
export const advMixin = {
//var advMixin = {
    data() {
        let inter_ind = {
            agora: 0,
            alterar: 0,
            anos_atras: 0,
            ativar_pagina: 0,
            ativa: 0,
            atras: 0,
            avaliacao: 0,
            avalie_nos: 0,
            bairro: 0,
            bemvindo: 0,
            bombeiros: 0,
            cadastre: 0,
            cadastro_alteracoes: 0,
            cancelar: 0,
            caracteres: 0,
            categorias: 0,
            cep_nao: 0,
            cep: 0,
            cidade: 0,
            comentario_caracteres: 0,
            comentario_escreva: 0,
            comentarios: 0,
            como_chegar: 0,
            complemento: 0,
            comprar: 0,
            configuracoes: 0,
            contato: 0,
            continuar: 0,
            criar_pagina: 0,
            desativada: 0,
            desativar_pagina: 0,
            descricao: 0,
            dias_atras: 0,
            digitar_endereco: 0,
            editar_pagina: 0,
            editar: 0,
            em_analise: 0,
            email_invalido: 0,
            entrar_auto: 0,
            entrar: 0,
            entre_apple: 0,
            entre_face: 0,
            entre_google: 0,
            enviar_resposta: 0,
            enviar: 0,
            esconder_endereco: 0,
            esporte: 0,
            esqueceu_senha: 0,
            estabelecimento_nao: 0,
            estado: 0,
            excluir_conta: 0,
            excluir_pagina: 0,
            excluir: 0,
            expedicao_p1: 0,
            expedicao_p2: 0,
            expedicao_p3: 0,
            expedicao_p4: 0,
            expedicao_p5: 0,
            expedicao: 0,
            fale_advice_1: 0,
            fale_advice_2: 0,
            fale_advice_3: 0,
            favor_login: 0,
            favor_preencha: 0,
            favor_senha: 0,
            favor_verifique: 0,
            favoritos: 0,
            fechar: 0,
            formal: 0,
            funcionamento: 0,
            horario_funcionamento: 0,
            inserir_foto: 0,
            ligar: 0,
            li_concordo_com: 0,
            mensagem: 0,
            mensagens: 0,
            meses_atras: 0,
            min_atras: 0,
            minha_conta: 0,
            minhas_paginas: 0,
            nenhum_estabelecimento: 0,
            nenhum_resultado: 0,
            nome: 0,
            nome_invalido: 0,
            nome_pagina: 0,
            nossas_redes: 0,
            numero: 0,
            ola: 0,
            os: 0,
            patrocinado: 0,
            parceiros: 0,
            pesquisar: 0,
            pilares: 0,
            policia: 0,
            politica_privacidade: 0,
            praia: 0,
            procurar: 0,
            quem_somos_p1: 0,
            quem_somos_p2: 0,
            quem_somos_p3: 0,
            quem_somos_p4: 0,
            quem_somos_p5: 0,
            quem_somos_p6: 0,
            quem_somos_p7: 0,
            quem_somos_p8: 0,
            quem_somos_p9: 0,
            quem_somos_p10: 0,
            quem_somos_p11: 0,
            quem_somos_p12: 0,
            quem_somos: 0,
            visao: 0,
            remover: 0,
            reservar: 0,
            responda_comentario: 0,
            responder: 0,
            responsavel: 0,
            resposta: 0,
            respostas: 0,
            resultado_busca: 0,
            rodoviaria_estadual: 0,
            rodoviaria_federal: 0,
            rua: 0,
            sair: 0,
            samu: 0,
            seg_atras: 0,
            selecione_imagem: 0,
            semanas_atras: 0,
            senha_atual: 0,
            senha_confirma: 0,
            senha_errada_2: 0,
            senha_errada_3: 0,
            senha_errada: 0,
            senha_nova: 0,
            senha_nova_confirma: 0,
            senha: 0,
            sua_avaliacao: 0,
            seu_guia_turistico: 0,
            tabua_mares: 0,
            telefone: 0,
            telefone_invalido: 0,
            telefone_warning: 0,
            telefones_uteis: 0,
            tem_certeza_remover: 0,
            texto_cookies_inicio: 0,
            texto_parabens_adv: 0,
            texto_usuario_existente_p1: 0,
            texto_usuario_existente_p2: 0,
            texto_usuario_cadastrado_p1: 0,
            texto_usuario_cadastrado_p2: 0,
            ticket_medio: 0,
            todas_cidades: 0,
            traje: 0,
            trocar_foto_perfil: 0,
            usuario_nao_cadastrado: 0,
            utilize_pelo_menos: 0,
            ver: 0
        };
        let inter_pt = [
            'Agora',
            'Alterar',
            ' anos atrás',
            'Ativar Página',
            'ATIVA',
            'atrás',
            'Avaliação: ',
            'Avalie-nos',
            'Bairro',
            'Falta pouco para você fazer\nparte do espírito Advice.\nFaça seu cadastro!',
            'Bombeiros',
            'Cadastre-se',
            'Cadastro - Alterações',
            'Cancelar',
            ' caracteres',
            'Categorias',
            'CEP não encontrado.',
            'CEP',
            'Cidade',
            'Escreva um comentário com mais caracteres.',
            'Escreva um comentário',
            'Comentários',
            'Como Chegar?',
            'Complemento',
            'Comprar',
            'Configurações',
            'Contato',
            'Continuar',
            'Criar Página',
            'DESATIVADA',
            'Desativar Página',
            'Descrição',
            ' dias atrás',
            'Digitar Endereço',
            'Editar Página',
            'Editar',
            'EM ANÁLISE',
            'E-mail inválido.',
            'Entrar Automaticamente',
            'Entrar',
            'Entrar com a Apple',
            'Entrar com o Facebook',
            'Entrar com o Google',
            'Enviar Resposta',
            'Enviar',
            'Esconder Endereço',
            'Esporte',
            'Esqueceu a senha?',
            'Estabelecimento não cadastrado.',
            'Estado',
            'Excluir Conta',
            'Excluir Página',
            'EXCLUIR',
            'A Expedição Advice Nissan Frontier faz parte de um projeto ousado e inovador, que consiste em registrar, mapear e divulgar todos os destinos turísticos da Paraíba. Para esse grande feito, contamos com o apoio da Carneiro Nissan, que desde o início acreditou no Advice Paraíba, uma ferramenta criada com a intuito de desenvolver o turismo da Paraíba através da tecnologia, que a cada dia se torna mais presente em nossas vidas.',
            'Para alimentar todo nosso banco de imagens e de dados, iniciamos a Expedição Advice, que a bordo da Nissan Frontier, percorre todo o estado, capturando imagens deslumbrantes, através do trabalho brilhante do fotógrafo Marco Pimentel, que sempre foi apaixonado pela Paraíba e é um dos idealizadores desse grande projeto.',
            'Existe algo especial em nossa terra. Nossa cultura, nossa história, as belezas naturais que nos rodeiam, e toda a hospitalidade do nosso povo. O Advice Paraíba vem para consolidar o nosso Estado como ponto obrigatório nos roteiros do turismo brasileiro.',
            'É com enorme satisfação que contamos o apoio da Carneiro Nissan, a concessionária que mais entende de Nissan na Paraíba e se orgulha de ser a líder em vendas de Frontier no Brasil. A picape com DNA japonês, que foi pensada para superar a variedade de terrenos e desafios apresentados em um país como o nosso.',
            'Com este importante apoio sabemos que conseguiremos cumprir essa missão de colocar na vitrine todo o nosso potencial turístico.',
            'Expedição Advice Nissan',
            'Fale com o Advice!',
            'Ficamos felizes em te ouvir',
            'Envie para nós a sua mensagem',
            'Por favor faça login ou cadastre-se.',
            'Por favor preencha todos os campos',
            'Por favor confirme sua senha',
            'Por favor, verifique seu e-mail, e valide o seu cadastro.',
            'Favoritos',
            'FECHAR',
            'Formal',
            'Funcionamento',
            'Horário Funcionamento',
            'Inserir Foto',
            'Ligar',
            'Li e concordo com a',
            'Mensagem',
            'Mensagens',
            ' meses atrás',
            ' min atrás',
            'Minha Conta',
            'Minhas Páginas',
            'Ainda não temos nenhum estabelecimento cadastrado nessa categoria.',
            'Nenhum resultado encontrado.',
            'Nome Completo',
            'Nome Inválido.',
            'Nome da Página',
            'Nossas Redes',
            'Número',
            'Olá ',
            'Os ',
            'Patrocinado',
            'Parceiros',
            'Pesquisar',
            '4 Pilares',
            'Polícia',
            'Política de Privacidade',
            'Praia',
            'Procurar',
            'Viajar é aprender. É crescer. Viajar é a mais divertida forma de se enriquecer. Promovendo a alegria e ótimos momentos.',
            'É assim que percebemos o valor da visita e da despedida. Nós, do Advice Paraíba, temos muito orgulho de criar algo que possa contribuir para uma viagem espetacular, não somente para os viajantes como também para todas pessoas que de alguma forma faz esse importante mercado se desenvolver.',
            'Buscamos extrair as mais preciosas dicas nativas, com praticidade e objetividade.',
            'A Paraíba é uma terra magnífica, com muitos recursos históricos e paisagens naturais exuberantes. Essa ferramenta colaborativa é um facilitador de navegação, um presente para todos os paraibanos, que se orgulham e sabem divulgar o melhor do nosso Estado.',
            'Promover o turismo:',
            'Vivemos um momento único para o turismo mundial. Os reflexos da pandemia, nos fez reaprender e a arte de viajar. Seguindo as tendências, percebemos a necessidade de balancear os impactos e nos adaptar a uma nova forma de fazer turismo.',
            'Conectar pessoas:',
            'Através de nossa rede de usuários, destinos e páginas interativas. Mantendo um canal aberto para o compartilhamento de experiências, conselhos e opiniões. Disponibilizando a nossa plataforma para uma comunicação direta e produtiva para integrar comunidades de diversos setores.',
            'Organizar as informações:',
            'O que fazemos é organizar o nosso próprio material de mídia, com texto, imagens e vídeos, e organiza-los de maneira que todos possam achar o que desejam em menos tempo e mais praticidade.',
            'Criar oportunidades:',
            'Empresas dos setores gastronômico, da hotelaria, prestadores de serviços, artistas plásticos e artesãos, poderão divulgar gratuitamente os seus serviços e produtos. Criando suas páginas e interagindo com os usuários, conseguindo assim, um ambiente saudável de negócios.',
            'Visão Advice',
            'Visão',
            'Remover',
            'Reservar',
            'Responda o comentário',
            'RESPONDER',
            'Responsável',
            'Resposta',
            'Respostas ',
            'Resultado Busca',
            'Rodoviária Estadual',
            'Rodoviária Federal',
            'Rua',
            'Sair',
            'SAMU',
            ' seg atrás',
            'Selecione uma imagem',
            ' semanas atrás',
            'Senha Atual',
            'Confirmar Senha',
            'Sua senha tem que ter no mínimo 8 caracteres',
            'Senhas não conferem',
            'Usuário ou senha incorretos. Tente novamente.',
            'Senha Nova',
            'Confirmar Nova Senha',
            'Senha',
            'Sua Avaliação',
            'SEU GUIA TURÍSTICO NA PARAÍBA',
            'Tábua das Marés',
            'Telefone',
            'Telefone Inválido',
            'Seu telefone e e-mail não ficarão visíveis aos demais usuários.',
            'Telefones Úteis',
            'Tem certeza que deseja remover a sua conta?',
            'Utilizamos cookies para oferecer melhor experiência, melhorar o desempenho, analisar como você interage em nosso aplicativo e personalizar conteúdo. Ao utilizar este aplicativo, você concorda com o uso de cookies e com a nossa',
            'Parabéns! Agora você é um Advicer!<br> Navegue e usufrua o melhor do turismo da Paraíba.',
            'Usuário já existente ',
            'Faça seu login.',
            'Agora acesse seu e-mail:',
            'E valide o seu cadastro.',
            'Ticket Médio',
            'Todas as Cidades',
            'Traje',
            'Trocar a foto do perfil',
            'Aguarde, seu cadastro esta sendo realizado.',
            'Utilize pelo menos ',
            'Ver ',
        ];
        let inter_en = [
            'Now',
            'Change',
            ' years ago',
            'Activate Page',
            'ACTIVE',
            'ago',
            'Evaluation: ',
            'Rate us',
            'District',
            'You need to be a part of\nthe Advice spirit.\nMake your registration!',
            'Firemen',
            'Register',
            'Registration - Changes',
            'Cancel',
            ' characters',
            'Categories',
            'Zip not found.',
            'ZIP',
            'City',
            'Write a comment with more characters.',
            'Write a comment',
            'Comments',
            'How to get?',
            'Complement',
            'Purchase',
            'Settings',
            'Contact',
            'Next',
            'Create Page',
            'OFF',
            'Disable Page',
            'Description',
            ' days ago',
            'Type Address',
            'Edit Page',
            'Edit',
            'IN ANALYSIS',
            'Invalid e-mail.',
            'Sign in automatically',
            'Login',
            'Sign in with Apple',
            'Sign in with Facebook',
            'Sign in with Google',
            'Submit Reply',
            'Submit',
            'Hide Address',
            'Sport',
            'Forgot password?',
            'Establishment not registered.',
            'State',
            'Delete Account',
            'Delete Page',
            'DELETE',
            'The Advice Nissan Frontier Expedition is part of a bold and innovative project, which consists of registering, mapping and publicizing all tourist destinations in Paraíba. For this great achievement, we have the support of Carneiro Nissan, which from the beginning believed in Advice Paraíba, a tool created with the aim of developing tourism in Paraíba through technology, which is becoming more present in our lives every day.',
            'To feed our entire database of images and data, we started the Advice Expedition, which aboard the Nissan Frontier, travels across the state, capturing stunning images, through the brilliant work of photographer Marco Pimentel, who has always been in love with Paraíba and is a of the creators of this great project.',
            'There is something special about our land. Our culture, our history, the natural beauty that surrounds us, and all the hospitality of our people. Advice Paraíba comes to consolidate our State as a mandatory point in Brazilian tourism itineraries.',
            'It is with great satisfaction that we have the support of Carneiro Nissan, the dealership that most understands Nissan in Paraíba and is proud to be the leader in Frontier sales in Brazil. The pickup truck with Japanese DNA, designed to overcome the variety of terrain and challenges presented in a country like ours.',
            'With this important support, we know that we will be able to fulfill this mission of displaying all our tourist potential.',
            'Nissan Expedition Advice',
            'Talk to Advice!',
            'We are happy to hear from you',
            'Send us your message',
            'Please login or register.',
            'Please fill in all fields',
            'Please confirm your password',
            'Please check your email, and validate your registration.',
            'Favorites',
            'CLOSE',
            'Formal',
            'Operation',
            'Opening Hours',
            'Insert Photo',
            'Call',
            'I read and agree with',
            'Message',
            'Posts',
            ' months ago',
            ' min ago',
            'My Account',
            'My Pages',
            'We do not have any registered establishments in this category yet.',
            'No results found.',
            'Full Name',
            'Invalid Name.',
            'Page Name',
            'Our Networks',
            'Number',
            'Hello ',
            'The ',
            'Sponsored',
            'Partners',
            'Search',
            '4 Pillars',
            'Police',
            'Privacy Policy',
            'Beach',
            'Search',
            'Traveling is learning. It\'s growing. Traveling is the most fun way to get rich. Promoting joy and great times.',
            'That\'s how we realize the value of the visit and the farewell. We, at Advice Paraíba, are very proud to create something that can contribute to a spectacular trip, not only for travelers but also for everyone who somehow makes this important market develop.',
            'We seek to extract the most precious native tips, with practicality and objectivity.',
            'Paraíba is a magnificent land, with many historical resources and exuberant natural landscapes. This collaborative tool is a navigation facilitator, a gift to all Paraíba, who are proud and know how to better publicize our state.',
            'Promote tourism:',
            'We live in a unique moment for world tourism. The reflections of the pandemic made us relearn and the art of traveling. Following trends, we realized the need to balance impacts and adapt to a new way of doing tourism.',
            'Connect people:',
            'Through our network of users, destinations and interactive pages. Keeping an open channel for sharing experiences, advice and opinions.',
            'Organize the information:',
            'What we do is organize our own media material, with text, images and videos, and organize them so that everyone can find what they want in less time and with more convenience.',
            'Create opportunities:',
            'Companies from the gastronomic, hotel, service providers, plastic artists and artisans sectors will be able to publicize their services and products free of charge. Creating your pages and interacting with users, thus achieving a healthy business environment.',
            'Advice Vision',
            'Vision',
            'Remove',
            'Reserve',
            'Reply to comment',
            'ANSWER',
            'Responsible',
            'Answer',
            'Answers ',
            'Search Result',
            'State Highway',
            'Federal Highway',
            'Street',
            'Logout',
            'SAMU',
            ' sec ago',
            'Select an image',
            ' weeks ago',
            'Current password',
            'Confirm password',
            'Your password must be at least 8 characters',
            'Passwords do not match',
            'Incorrect username or password. Try again.',
            'New Password',
            'Confirm New Password',
            'Password',
            'Your Evaluation',
            'YOUR TOUR GUIDE IN PARAÍBA',
            'Tide Table',
            'Phone',
            'Invalid Phone',
            'Your phone and email will not be visible to other users.',
            'Useful Phones',
            'Are you sure you want to remove your account?',
            'We use cookies to provide you with a better experience, improve performance, analyze how you interact with our app and personalize content. By using this application, you agree to the use of cookies and to our',
            'Congratulations! You are now an Advicer! Browse and enjoy the best of Paraíba tourism.',
            'User already exist ',
            'Please login.',
            'Now access your email:',
            'And validate your registration.',
            'Average Ticket',
            'All Cities',
            'Costume',
            'Change profile picture',
            'Wait, your registration is being carried out.',
            'Use at least ',
            'View ',
        ];
        let inter_es = [
            'Ahora',
            'Cambiar',
            ' años atrás',
            'Activar página',
            'ACTIVO',
            'atrás',
            'Evaluación: ',
            'Nos califica',
            'Barrio',
            'Debes ser parte del espíritu\nde asesoramiento.\n¡Haz tu registro!',
            'Bomberos',
            'Registrarse',
            'Registro - Cambios',
            'Cancelar',
            ' caracteres',
            'Categorías',
            'Zip no encontrado.',
            'ZIP',
            'Ciudad',
            'Escribe un comentario con más caracteres.',
            'Escribe un comentario',
            'Comentarios',
            'Como llegar?',
            'Complemento',
            'Compra',
            'Configuraciones',
            'Contacto',
            'Seguir',
            'Crear página',
            'APAGADO',
            'Desactivar página',
            'Descripción',
            ' dias atras',
            'Escriba la dirección',
            'Editar Página',
            'Editar',
            'EN ANÁLISIS',
            'E-mail inválido.',
            'Sesión automáticamente',
            'Iniciar',
            'Iniciar sesión usando Apple',
            'Iniciar sesión usando Facebook',
            'Iniciar sesión usando Google',
            'Enviar Respuesta',
            'Enviar',
            'Ocultar Dirección',
            'Deporte',
            'Olvido la contraseña?',
            'Establecimiento no registrado.',
            'Estado',
            'Eliminar Cuenta',
            'Eliminar página',
            'ELIMINAR',
            'El Advice Nissan Frontier Expedition es parte de un proyecto audaz e innovador, que consiste en registrar, cartografiar y dar a conocer todos los destinos turísticos de Paraíba. Para este gran logro, contamos con el apoyo de Carneiro Nissan, que desde un principio creyó en Advice Paraíba, una herramienta creada con el objetivo de desarrollar el turismo en Paraíba a través de la tecnología, que cada día está más presente en nuestras vidas.',
            'Para alimentar toda nuestra base de datos de imágenes y datos, iniciamos la Expedición Advice, que a bordo del Nissan Frontier, recorre el estado capturando imágenes impactantes, a través del brillante trabajo del fotógrafo Marco Pimentel, quien siempre ha estado enamorado de Paraíba y es uno de los creadores de este gran proyecto.',
            'Hay algo especial en nuestra tierra. Nuestra cultura, nuestra historia, la belleza natural que nos rodea y toda la hospitalidad de nuestra gente. Asesoramiento Paraíba viene a consolidar nuestro Estado como un punto obligado en los itinerarios turísticos brasileños.',
            'Con gran satisfacción contamos con el apoyo de Carneiro Nissan, el concesionario que más entiende a Nissan en Paraíba y se enorgullece de ser el líder en ventas de Frontier en Brasil. La camioneta con ADN japonés, diseñada para superar la variedad de terrenos y desafíos que se presentan en un país como el nuestro.',
            'Con este importante apoyo sabemos que podremos cumplir con esta misión de desplegar todo nuestro potencial turístico.',
            'Expedición Advice Nissan',
            '¡Habla con Advice!',
            'Estamos contentos de tener noticias sobre ti',
            'Envíanos tu mensaje',
            'Por favor, inicie sesión o regístrese.',
            'Por favor rellena todos los campos',
            'Por favor, confirme su contraseña',
            'Por favor revise su correo electrónico y valide su registro.',
            'Marcadores',
            'CERCA',
            'Formal',
            'Operación',
            'Horario de Apertura',
            'Insertar foto',
            'Llamar',
            'Leo y estoy de acuerdo con',
            'Mensaje',
            'Mensajes',
            ' hace meses',
            ' hace min',
            'Mi Cuenta',
            'Mis Paginas',
            'Aún no tenemos establecimientos registrados en esta categoría.',
            'Ningún resultado encontrado.',
            'Nombre Completo',
            'Nombre Inválido.',
            'Nombre de la Página',
            'Nuestras Redes',
            'Número',
            'Hola ',
            'Los ',
            'Patrocinado',
            'Socios',
            'Buscar',
            '4 Pilares',
            'Policía',
            'Política de privacidad',
            'Playa',
            'Buscar',
            'Viajar es aprender. Está creciendo. Viajar es la forma más divertida de hacerse rico. Promoviendo la alegría y los grandes momentos.',
            'Así nos damos cuenta del valor de la visita y la despedida. Nosotros, en Advice Paraíba, estamos muy orgullosos de crear algo que pueda contribuir a un viaje espectacular, no solo para los viajeros sino también para todos los que de alguna manera hacen que este importante mercado se desarrolle.',
            'Buscamos extraer los consejos nativos más preciados, con practicidad y objetividad.',
            'Paraíba es una tierra magnífica, con muchos recursos históricos y exuberantes paisajes naturales. Esta herramienta colaborativa es un facilitador de navegación, un regalo para todos los Paraíba, que estamos orgullosos y sabemos dar a conocer mejor nuestro estado.',
            'Promocionar el turismo:',
            'Vivimos un momento único para el turismo mundial. Los reflejos de la pandemia nos hicieron reaprender y el arte de viajar. Siguiendo las tendencias, nos dimos cuenta de la necesidad de equilibrar los impactos y adaptarnos a una nueva forma de hacer turismo.',
            'Conecta personas:',
            'A través de nuestra red de usuarios, destinos y páginas interactivas. Mantener un canal abierto para compartir experiencias, consejos y opiniones.',
            'Organiza la información:',
            'Lo que hacemos es organizar nuestro propio material multimedia, con texto, imágenes y videos, y organizarlos para que todos puedan encontrar lo que buscan en menos tiempo y con más comodidad.',
            'Crear oportunidades:',
            'Empresas de los sectores gastronómico, hotelero, prestadores de servicios, artistas plásticos y artesanos podrán dar a conocer sus servicios y productos de forma gratuita. Creando sus páginas e interactuando con los usuarios, logrando así un entorno empresarial saludable.',
            'Visión Advice',
            'Visión',
            'Eliminar',
            'Reserva',
            'Responder al comentario',
            'RESPONDER',
            'Responsable',
            'Respuesta',
            'Respuestas ',
            'Resultado de búsqueda',
            'Carretera Estatal',
            'Carretera Federal',
            'Calle',
            'Cerrar Sesión',
            'SAMU',
            ' hace seg',
            'Seleccionar una imagen',
            ' hace semanas',
            'Contraseña Actual',
            'Confirmar Contraseña',
            'Tu contraseña debe tener al menos 8 caracteres',
            'Las contraseñas no coinciden',
            'Usuario o contraseña incorrectos. Inténtalo de nuevo.',
            'Nueva Contraseña',
            'Confirmar Nueva Contraseña',
            'Contraseña',
            'Su Evaluación',
            'TU GUÍA TURÍSTICO EN PARAÍBA',
            'Tabla de Mareas',
            'Teléfono',
            'teléfono Inválido',
            'Su teléfono y correo electrónico no serán visibles para otros usuarios.',
            'Teléfonos útiles',
            '¿Está seguro de que desea eliminar su cuenta?',
            'Usamos cookies para brindarle una mejor experiencia, mejorar el rendimiento, analizar cómo interactúa con nuestra aplicación y personalizar el contenido. Al utilizar esta aplicación, acepta el uso de cookies y nuestra',
            '¡Felicidades! ¡Ahora eres un asesor! Navega y disfruta de lo mejor del turismo en Paraíba.',
            'Usuario ya existente ',
            'Por favor Iniciar sesión.',
            'Ahora accede a tu correo electrónico:',
            'Y valida tu registro.',
            'Billete Medio',
            'Todas las ciudades',
            'Disfraz',
            'Cambiar foto de perfil',
            'Espere, se está realizando su registro.',
            'Usa al menos ',
            'Ver ',
        ];
        
        // Função para obter o texto traduzido e a imagem correspondente
        function getInterText(index) {
            switch (this.user.idioma) {
                case 0:
                    return inter_pt[index];
                case 1:
                    return inter_en[index];
                case 2:
                    return inter_es[index];
                default:
                    return inter_pt[index];
            }
        }

        function getReserveImage() {
            switch (this.user.idioma) {
                case 0:
                    return "/static/imgs/reservarportesp.png";
                case 1:
                    return "/static/imgs/reserving.png";
                case 2:
                    return "/static/imgs/reservares.png";
                default:
                    return "/static/imgs/reservarportesp.png";
            }
        }

        // auto increment inter keys list
        var count=0;
        for(var key in inter_ind){
            inter_ind[key] = count;
            count++;
        }

        return {
            actionFunction: function() {},
            // baseUrlImg: 'http://localhost:8082/ADVICE_SERVER/',
            baseUrlImg: 'https://advice.domm.com.br:8445/ADVICE_SERVER/',

            //baseUrlApi: 'http://localhost:8082/AdviceServer/restapi/search/',
            // baseUrlApi: 'https://localhost:8443/AdviceServer/restapi/search/', // esse

            // baseUrlApi: 'http://advice.domm.com.br:8087/AdviceServer/restapi/search/',

            baseUrlApi: 'https://advice.domm.com.br:8445/AdviceServer/restapi/search/',// esse
            hasTranslate: false,
            config2: {
                // endfor: 4,
                // incfor: 5,
                endfor: 9,
                incfor: 10
            },
            titlePage: 'Criar Página',
            // internacionalizacao
            inter_ind: inter_ind,
            inter_pt: inter_pt,
            inter_en: inter_en,
            inter_es: inter_es,
            // imgMaxWidth: 640,
            // imgMaxHeight: 480,
            passoIndex: 0,
            maxTries: 5,
            anunciosTries: 0,
            stabsCatsTries: 0,
            passo: [
                {
                    done: true,
                    valid: false,
                },
                {
                    done: false,
                    valid: false,
                },
                {
                    done: false,
                    valid: false,
                },
                {
                    done: false,
                    valid: false,
                },
            ],
            valid: {
                nome: true,
                descricao: true,
                categorias: true,
                rua: true,
                bairro: true,
                cidade: true,
                estado: true,
                horario: true,
                email: true,
                tel: true,
                pass1: true,
                pass2: true,
                captcha: false,
                enterAuto: false,
                termos: false,
                errorSubmit: false
            },
            new_user: {
                nome: "",
                email: "",
                fone: "",
                foto: "",
                pass: "",
                sucess: false,
                tipo: 0,
                showMsg1: true,
                showMsg2: true,
                showMsg3: true,
                currentTab: 1,
                deleted: false
            },
            cookies_geral: {
                showCookies: true
            },
            show10Mais: false,
            topQuant: 10,
            minSearchLen: 3,
            imgMaxWidth: 800,
            imgMaxHeight: 800,
            textAlert: 'Empty 2',
            showAlert: false,
            showConfirm: false,
            showGoToTop: false,
            showLogin: false,
            showGetPhone: false,
            showResponder: -1,
            showResponder2: -1,
            showRespComments: -1,
            showCriacaoPg: false,
            senhaErrada: false,
            userNaoCadastrado: false,
            showPopupEscritorio: false,
            showAvaliacao: false,
            renderDescription: true,
            renderCommentaries: true,
            avaliacao: 0,
            favType: 0,
            GoogleAuth: null,
            loading: {
                anuncios: false,
                cats: false,
                estabs: false,
                commentaries: false,
                user: false,
                avaliacao: false,
                favorito: false,
                form: false,
                like: false,
                face: false,
                google: false,
                apple: false,
                phone: false,
                desc: false
            },
            // idCat: 67, // Patrocinados
            // idCat: 53, // Destaques
            // idCat: 62, // Turisticos
            idCat: 0, // Turisticos
            cityIndex: 0,
            catIndex: 0,
            subCatIndex: 0,
            city_full: [],
            subCatText: '',
            cat: {},
            cat_back: {},
            cats_full: [
                // {
                //     "id":67,
                //     "apareceListagem":false,
                //     "dtAlteracao":"Aug 9, 2020 11:19:28 AM",
                //     "imgPath":"67.png",
                //     "imgPath2":"67_2.png",
                //     "nome":"Patrocinados",
                //     "nomeEn":"Sponsored",
                //     "nomeEs":"Patrocinado",
                //     "cor":"#FFFFFF",
                //     "cor2":"#2566AE",
                //     "deleted":false,
                //     "alimentacao":false,
                //     "ordem":1,
                //     "md5Img":"1f801285437d069ac6ecb7255545da4e"
                // },
                {
                    "id": 53,
                    "apareceListagem": true,
                    "dtAlteracao": "Apr 15, 2021 9:01:58 PM",
                    "imgPath": "53.png",
                    "imgPath2": "53_2.png",
                    "nome": "Destaques",
                    "nomeEn": "Highlights",
                    "nomeEs": "Destacar",
                    "cor": "#929497",
                    "cor2": "",
                    "deleted": false,
                    "alimentacao": false,
                    "ordem": 0,
                    "md5Img": "a99474d1a87d5e238a93c5e3d77ef370"
                },
                {
                    "id": 62,
                    "apareceListagem": true,
                    "dtAlteracao": "Apr 15, 2021 9:01:31 PM",
                    "imgPath": "62.png",
                    "imgPath2": "62_2.png",
                    "nome": "Turísticos",
                    "nomeEn": "Touristic",
                    "nomeEs": "Turístico",
                    "cor": "#00A551",
                    "cor2": "",
                    "deleted": false,
                    "alimentacao": false,
                    "ordem": 1,
                    "md5Img": "7c05cfb3e6889e00b60bbf83ac10d2ee"
                },
                {
                    "id": 73,
                    "apareceListagem": true,
                    "dtAlteracao": "Apr 15, 2021 9:01:39 PM",
                    "imgPath": "73.png",
                    "imgPath2": "73_2.png",
                    "nome": "Praias",
                    "nomeEn": "Beaches",
                    "nomeEs": "Playas",
                    "cor": "#A2238D",
                    "cor2": "",
                    "deleted": false,
                    "alimentacao": false,
                    "ordem": 2,
                    "md5Img": "dacccb0b865d0d5634669d53e66b6873"
                },
                {
                    "id": 56,
                    "apareceListagem": true,
                    "dtAlteracao": "Apr 15, 2021 9:01:48 PM",
                    "imgPath": "56.png",
                    "imgPath2": "56_2.png",
                    "nome": "Restaurantes",
                    "nomeEn": "Restaurants",
                    "nomeEs": "Restaurantes",
                    "cor": "#0071BB",
                    "cor2": "",
                    "deleted": false,
                    "alimentacao": true,
                    "ordem": 3,
                    "md5Img": "f09fb5b97607e0b47cf209b604daf14c"
                },
                {
                    "id": 57,
                    "apareceListagem": true,
                    "dtAlteracao": "Aug 9, 2020 11:20:57 AM",
                    "imgPath": "57.png",
                    "imgPath2": "57_2.png",
                    "nome": "Bares",
                    "nomeEn": "Bars",
                    "nomeEs": "Barras",
                    "cor": "#47A4AD",
                    "cor2": "",
                    "deleted": false,
                    "alimentacao": true,
                    "ordem": 4,
                    "md5Img": "4b559d154f7beca474a2669e52f20f24"
                },
                {
                    "id": 58,
                    "apareceListagem": true,
                    "dtAlteracao": "Sep 16, 2021 1:07:48 PM",
                    "imgPath": "58.png",
                    "imgPath2": "58_2.png",
                    "nome": "Lanches",
                    "nomeEn": "Snack bars",
                    "nomeEs": "Barras de merienda",
                    "cor": "#006D38",
                    "cor2": "",
                    "deleted": false,
                    "alimentacao": true,
                    "ordem": 5,
                    "md5Img": "6ff0032dcfa241b1e1b071aeec8d4e3f"
                },
                {
                    "id": 74,
                    "apareceListagem": true,
                    "dtAlteracao": "Sep 17, 2021 4:49:57 PM",
                    "imgPath": "74.png",
                    "imgPath2": "74_2.png",
                    "nome": "Cafeterias",
                    "nomeEn": "Coffee Shop",
                    "nomeEs": "Cafeterías",
                    "cor": "",
                    "cor2": "",
                    "deleted": false,
                    "alimentacao": true,
                    "ordem": 6,
                    "md5Img": "771b67d0bbe808fb69bd563c7b276770"
                },
                {
                    "id": 75,
                    "apareceListagem": true,
                    "dtAlteracao": "Sep 16, 2021 1:08:36 PM",
                    "imgPath2": "75_2.png",
                    "nome": "Gelados",
                    "nomeEn": "Ice cream",
                    "nomeEs": "Helados",
                    "cor": "",
                    "cor2": "",
                    "deleted": false,
                    "alimentacao": true,
                    "ordem": 7
                },
                {
                    "id": 63,
                    "apareceListagem": true,
                    "dtAlteracao": "Sep 16, 2021 12:55:05 PM",
                    "imgPath": "63.png",
                    "imgPath2": "63_2.png",
                    "nome": "Hospedagem",
                    "nomeEn": "Accommodation",
                    "nomeEs": "Alojamiento",
                    "cor": "#FCB713",
                    "cor2": "",
                    "deleted": false,
                    "alimentacao": false,
                    "ordem": 8,
                    "md5Img": "801de42cfcb05b6f269475e1344f8094"
                },
                {
                    "id": 59,
                    "apareceListagem": true,
                    "dtAlteracao": "Sep 17, 2021 7:14:38 PM",
                    "imgPath": "59.png",
                    "imgPath2": "59_2.png",
                    "nome": "Entretenimento",
                    "nomeEn": "Entertainment",
                    "nomeEs": "Entretenimiento",
                    "cor": "#F48120",
                    "cor2": "",
                    "deleted": false,
                    "alimentacao": false,
                    "ordem": 9,
                    "md5Img": "f3bdc8a47e8635a8b87123f85b8cd593"
                },
                {
                    "id": 77,
                    "apareceListagem": true,
                    "dtAlteracao": "Sep 17, 2021 7:14:54 PM",
                    "imgPath2": "77_2.png",
                    "nome": "Passeios",
                    "nomeEn": "Tours",
                    "nomeEs": "Excursiones",
                    "cor": "",
                    "cor2": "",
                    "deleted": false,
                    "alimentacao": false,
                    "ordem": 10
                },
                {
                    "id": 70,
                    "apareceListagem": true,
                    "dtAlteracao": "Sep 17, 2021 7:14:27 PM",
                    "imgPath": "70.png",
                    "imgPath2": "70_2.png",
                    "nome": "Cultura e Artes",
                    "nomeEn": "Culture and Arts",
                    "nomeEs": "Cultura y Artes",
                    "cor": "#00ADEE",
                    "cor2": "",
                    "deleted": false,
                    "alimentacao": false,
                    "ordem": 11,
                    "md5Img": "a6f0ca806a663b180fcff856319d1e46"
                },
                {
                    "id": 72,
                    "apareceListagem": true,
                    "dtAlteracao": "Sep 16, 2021 1:00:05 PM",
                    "imgPath": "72.png",
                    "imgPath2": "72_2.png",
                    "nome": "Aventura",
                    "nomeEn": "Adventure",
                    "nomeEs": "Aventuras",
                    "cor": "#A2238D",
                    "cor2": "",
                    "deleted": false,
                    "alimentacao": false,
                    "ordem": 13,
                    "md5Img": "a3be0ef3512b7c60dbf067d09de0fe31"
                },
                {
                    "id": 64,
                    "apareceListagem": true,
                    "dtAlteracao": "Sep 16, 2021 1:16:56 PM",
                    "imgPath": "64.png",
                    "imgPath2": "64_2.png",
                    "nome": "Fitness",
                    "nomeEn": "Fitness",
                    "nomeEs": "Fitness",
                    "cor": "#AF1116",
                    "cor2": "",
                    "deleted": false,
                    "alimentacao": false,
                    "ordem": 17,
                    "md5Img": "b2c053717dd59b7241b041de242096b6"
                },
                {
                    "id": 68,
                    "apareceListagem": false,
                    "dtAlteracao": "Sep 16, 2021 12:53:04 PM",
                    "imgPath": "68.png",
                    "imgPath2": "68_2.png",
                    "nome": "Serviços",
                    "nomeEn": "Services",
                    "nomeEs": "Servicios",
                    "cor": "#EB008B",
                    "cor2": "",
                    "deleted": false,
                    "alimentacao": false,
                    "ordem": 23,
                    "md5Img": "591be0307d7b865c859abe3c4760a07f"
                },
                {
                    "id": 66,
                    "apareceListagem": false,
                    "dtAlteracao": "Sep 16, 2021 12:52:55 PM",
                    "imgPath": "66.png",
                    "imgPath2": "66_2.png",
                    "nome": "Emergência",
                    "nomeEn": "Emergency",
                    "nomeEs": "Emergencia",
                    "cor": "#EC1C24",
                    "cor2": "",
                    "deleted": false,
                    "alimentacao": false,
                    "ordem": 25,
                    "md5Img": "bee2c17a480ef85357444951cd3d3132"
                }
            ],
            cats_sub: [
                {
                    fatherId: 73, // Praia
                    subs: [
                        'Urbanas',
                        'Litoral Norte',
                        'Litoral Sul'
                    ],
                    subs_en: [
                        'Urban',
                        'North Coast',
                        'South Coast'
                    ],
                    subs_es: [
                        'Urbano',
                        'Costa Norte',
                        'Costa Sur'
                    ]
                },
                {
                    fatherId: 62, // Turisticos
                    subs: [
                        'Piscinas Naturais',
                        'Interior',
                        'Histórico'
                    ],
                    subs_en: [
                        'Natural Pools',
                        'Country',
                        'Historic'
                    ],
                    subs_es: [
                        'Piscinas Naturales',
                        'Interior',
                        'Histórico'
                    ]
                }
            ],
            commentTx: '',
            commentRespTx: '',
            lastCep: '',
            loadingCep: false,
            traje: [
                {
                    texto: inter_ind.praia,
                    status: false,
                    id: 52,
                },
                {
                    texto: inter_ind.esporte,
                    status: false,
                    id: 1,
                },
                {
                    texto: inter_ind.formal,
                    status: false,
                    id: 53,
                },
            ],
            anuncios: [],
            // anuncios: [
            //     {
            //         id: 0,
            //         titulo: 'Paraíba Travel',
            //         link: 'http://www.paraibatravel.com.br/',
            //         imgPath: "e7h99d7lha.jpg",
            //         photos: [
            //             {
            //                 id: 1,
            //                 file: 'e7h99d7lha.jpg'
            //             }
            //         ],
            //         valor: 100,
            //         ativo: true,
            //         estabs: [721,732]
            //     },
            //     {
            //         id: 0,
            //         titulo: 'Parrachos Pitimbu',
            //         link: 'https://brasilpasseios.com.br/',
            //         imgPath: "p59ww1fgj7.jpg",
            //         photos: [
            //             {
            //                 id: 1,
            //                 file: 'p59ww1fgj7.jpg'
            //             }
            //         ],
            //         valor: 150,
            //         ativo: true,
            //         estabs: [721,732]
            //     }
            // ],
            telefoneUteis: [
                {
                    nome: inter_ind.policia,
                    tel: "190"
                },
                {
                    nome: inter_ind.samu,
                    tel: "192"
                },
                {
                    nome: inter_ind.bombeiros,
                    tel: "193"
                },
                {
                    nome: inter_ind.rodoviaria_federal,
                    tel: "191"
                },
                {
                    nome: inter_ind.rodoviaria_estadual,
                    tel: "198"
                }
            ],
            user: {
                nome: "",
                email: "",
                fone: "",
                foto: "",
                pass: "",
                sucess: false,
                tipo: 0,
                idioma: 0,
                showMsg1: true,
                showMsg2: true,
                showMsg3: true,
                currentTab: 1
            },
            editing: [
                {
                    texto: '',
                    status: false,
                    show: false,
                },
                {
                    texto: '',
                    status: false,
                    show: false,
                },
                {
                    texto: '',
                    status: false,
                    show: false,
                },
                {
                    texto: '',
                    status: false,
                    show: false,
                },
                {
                    texto: '',
                    status: false,
                    show: false,
                },
            ],
            photos: [

            ],
            commentaries: [
                // {
                //     id: 1,
                //     idEstabelecimento: 1,
                //     idUsuario: 1,
                //     userPhoto: 'static/imgs/advice_seta.png',
                //     userName: 'Pedro',
                //     estabName: 'Tratoria',
                //     type: 1,
                //     texto: 'teste de comentario',
                //     // joia: true
                // },
                // {
                //     id: 2,
                //     idEstabelecimento: 1,
                //     idUsuario: 1,
                //     userPhoto: 'static/imgs/ic_brasil.jpg',
                //     userName: 'Maria',
                //     estabName: 'Pizzaria',
                //     type: 1,
                //     texto: 'teste de comentario 2',
                //     // joia: true
                // },
            ],
            userAgent: 0,
            estab: {
                "id": -1,
                "descricao2": "Descricao Padrao",
                "telresponsavel": "(83) 98888-8888",
                "cep": "58037-700",
                "rua_num": "Rua padrão",
                "numero": "100",
                "bairro": "Bairro Padrão",
                "cidade": "João Pessoa",
                "estado": "PB",
                "complemento": "",
                "exibir": true,
                "nome": "Estabelecimento Padrao",
                "nomeSimple": "padrao",
                "telefones": "(83) 98888-8888",
                "email": "",
                "video_link": "",
                "site": "",
                "site2": "",
                "subcat": "",
                "avaliacao": 0,
                "investimento": 0,
                "horario": "",
                "deleted": false,
                "ativo": true,
                "aprovado": true,
                "tbCategoriaEstabelecimentos": [
                    {
                        "nome": "Turísticos",
                        "nomeEn": "Turísticos",
                        "nomeEs": "Turísticos",
                        "id": 62
                    },
                    {
                        "nome": "Praias",
                        "nomeEn": "Praias",
                        "nomeEs": "Praias",
                        "id": 73
                    },
                    {
                        "nome": "Restaurantes",
                        "nomeEn": "Restaurantes",
                        "nomeEs": "Restaurantes",
                        "id": 56
                    },
                    {
                        "nome": "Bares",
                        "nomeEn": "Bares",
                        "nomeEs": "Bares",
                        "id": 57
                    },
                    {
                        "nome": "Lanches",
                        "nomeEn": "Lanches",
                        "nomeEs": "Lanches",
                        "id": 58
                    },
                    {
                        "nome": "Cafeterias",
                        "nomeEn": "Cafeterias",
                        "nomeEs": "Cafeterias",
                        "id": 74
                    },
                    {
                        "nome": "Gelados",
                        "nomeEn": "Gelados",
                        "nomeEs": "Gelados",
                        "id": 75
                    }
                ],
                "tbTrajeEstabelecimentos": [],
                "tbFotos": [
                    {
                        "id": 2145,
                        "file": "rd7209h06w.jpg",
                        "ordem": 0
                    }
                ],
                "tbComentarios": [],
                "tbLocal": {
                    "id": 1,
                    "nome": "Advice Paraíba",
                    "dtAlteracao": "Jun 9, 2018 6:40:45 PM"
                },
                "idUsuario": 5,
                "tbSituacaoEstabelecimento": {
                    "id": 1,
                    "nome": "Normal"
                },
                "responsavel": "undefined"
            },
            new_estab: {
                id: -1,
                aprovado: false,
                ativo: true,
                nome: '',
                descricao: '',
                horario: '',
                responsavel: '',
                cep: '',
                rua: '',
                numero: '',
                bairro: '',
                cidade: '',
                complemento: '',
                estado: '',
                telefone: '',
                site: '',
                email: '',
                ticket: 0,
                categorias: [],
                traje: [],
                photos: [],
                usermail: '',
                avaliacao: 0,
            },
            profilePicture: null,
            profileSrc: '/static/imgs/ic_profile2.png',
            imgType: 2, // 2 = XGA
            // photosIndex: 0,
            currentTab: 3,
            barra_pat: [
                // {
                //     imgPath: "static/imgs/pat_grafica3.png",
                //     imgPathW: "static/imgs/pat_grafica4.png",
                //     url: "http://www.graficasantamarta.com.br"
                // },
                {
                    imgPath: "/static/imgs/pat_manaira7.png",
                    imgPathW: "/static/imgs/pat_manaira7.png",
                    url: "http://www.manairashopping.com.br"
                },
                {
                    imgPath: "/static/imgs/pat_jcarneiro5_1.png",
                    imgPathW: "/static/imgs/pat_jcarneiro4.png",
                    url: "http://www.jcarneiro.com.br"
                },
                {
                    imgPath: "/static/imgs/pat_mangabeira2.png",
                    imgPathW: "/static/imgs/pat_mangabeira2.png",
                    url: "https://mangabeirashopping.com.br"
                },
                {
                    imgPath: "/static/imgs/pat_m3.png",
                    imgPathW: "/static/imgs/pat_m3.png",
                    url: "https://m3locadoradeveiculos.com.br"
                }
                // {
                //     imgPath: "static/imgs/pat_elizabeth2.png",
                //     url: "http://www.ceramicaelizabeth.com.br"
                // },
                // {
                //     imgPath: "static/imgs/pat_luck2.png",
                //     url: "http://www.luckreceptivo.com.br"
                // }
            ],
            msg_erros: [

            ],
            textoTeste: 'jojao.da.nara123@gMail.coM.br',
            loginGoogle: null,
            loginFace: null,
            loginApple: null,
            qMaxFotos: 15,
            modoMosaico: false,
            ads: [
                {
                    nome: 'Lave-me JP',
                    img: '/static/imgs/adv/adv_lave.jpg',
                    link: 'https://www.instagram.com/lavemejp/'
                },
                {
                    nome: 'M3 Locadora de Veículos',
                    img: '/static/imgs/adv/adv_m3veiculos.jpg',
                    link: 'https://m3locadoradeveiculos.com.br'
                },
                {
                    nome: 'Gold Strike Boliche',
                    img: '/static/imgs/adv/adv_strike.jpg',
                    link: 'https://www.instagram.com/bolichegoldstrike/'
                },
                {
                    nome: 'Estaleiro Restaurante',
                    img: '/static/imgs/adv/adv_estaleiro.gif',
                    link: 'https://www.instagram.com/estaleirorestaurante/'
                }
            ]
        }
    },

    components: {
        HorizontalMsg: HorizontalMsg,
        Alert: Alert
    },

    // directives: {
    //     focus: {
    //         inserted(el) {
    //             console.log('chamando o directives::focus::inserted ');
    //             el.focus();
    //         }
    //     }
    // },

    methods: {
        getInitials(user) {
            let nomes = user.nome.split(' ')
            let initials
            if (nomes.length == 1) {
                initials = nomes[0][0]
            } else {
                initials = nomes[0][0] + nomes[nomes.length - 1][0]
            }
            console.log("initials: " + initials.toUpperCase())
            return initials.toUpperCase();
        },
        isAdIndex(stabIndex) {
            if (stabIndex == 3) {
                return true;
            } else {
                let i;
                // de 4 em 4 (7, 11, 15, 19, etc
                for (i = 7; i < this.estabs.length; i += 4) {
                    if (stabIndex == i)
                        return true;
                    else if (stabIndex < i)
                        return false;
                }
                return false;
            }
        },
        getAdIndex(stabIndex) {
            // console.log('getAdIndex::stabIndex' + stabIndex)
            // console.log('getAdIndex::return' + ((stabIndex - 2) / 4))
            return ((stabIndex - 3) / 4) % this.ads.length;
        },
        addAdvertisements() {
            if (this.estabs.length > 2)
                this.estabs.splice(2, 0, this.ads[0]);
            if (this.estabs.length > 7)
                this.estabs.splice(7, 0, this.ads[1]);
            if (this.estabs.length > 10)
                this.estabs.splice(10, 0, this.ads[2]);
        },
        showConfirmMsg(msg, newActionFunction) {
            this.textAlert = msg;
            this.showConfirm = true
            this.actionFunction = newActionFunction
        },
        showAlertMsg(msg) {
            this.textAlert = msg;
            this.showAlert = true
        },
        closeAlert () {
            // console.log('advMixin::closeAlert')
            this.showAlert = false
            this.showConfirm = false
        },
        getYear () {
            return new Date().getFullYear();
        },
        getLastName (link) {
            let pos = link.lastIndexOf('/')
            if (pos > 0) {
                return link.substring(pos + 1)
            } else {
                return link
            }
        },
        getEstab (simpleName) {
            for (let j = 0; j < this.estabs_full.length; j++) {
                if (this.estabs_full[j].nomeSimple === simpleName) {
                    return this.estabs_full[j]
                }
            }
            return {}
        },
        cpAnuncio (anun) {
            var tmp = {
                id: anun.id,
                titulo: anun.titulo,
                descricao: anun.descricao,
                telefone: anun.telefone,
                link: anun.link,
                valor: anun.valor,
                estabs: anun.estabs,
                photos: anun.photos,
                tipo: anun.tipo,
                ativo: anun.ativo,
                deleted: anun.deleted,
                localid: anun.localid,
                ownerid: anun.ownerid
            }

            return tmp
        },
        truncateAnuncio (anun) {
            // 1 === Anuncio Advice
            if (anun.tipo === 1) {
                let tmpAnun = this.cpAnuncio(anun)
                tmpAnun.photos = []
                return tmpAnun
            } else {
                return anun
            }
        },
        getAnunciosDecoded (anuncios, id) {
            console.log('getAnunciosDecoded:anuncios ', anuncios)
            var tmpAnuncios = []
            for (let i = 0; i < anuncios.length; i++) {
                if (id === undefined || anuncios[i].estabs.includes(id)) {
                    // 0 === Anúncio Externo
                    if (anuncios[i].tipo === 0) {
                        tmpAnuncios.push(anuncios[i])
                    }
                    // 1 === Anúncio Advice
                    else {
                        let simpleName = this.getLastName(anuncios[i].link);
                        // console.log('simple name: ', simpleName);

                        let stab = this.getEstab(simpleName)

                        // console.log('stab: ', stab)

                        let anuncio = {
                            id: anuncios[i].id,
                            link: anuncios[i].link,
                            valor: anuncios[i].valor,
                            estabs: anuncios[i].estabs,
                            ativo: anuncios[i].ativo,
                            tipo: anuncios[i].tipo,
                            titulo: stab.nome,
                            photos: stab.tbFotos
                        }
                        tmpAnuncios.push(anuncio)
                    }
                }
            }
            return tmpAnuncios
        },
        hasAnuncios(idEstab) {
            for (let i = 0; i < this.anuncios.length; i++) {
                if (this.anuncios[i].estabs.includes(idEstab))
                    return true;
            }

            return false;
        },
        catAlbuns(albuns) {
            let vec = []

            for (let j = 0; j < albuns.length; j++)
            {
                for (let i = 0; i < albuns[j].fotos.length; i++)
                {
                    vec.push(albuns[j].fotos[i])
                }
            }
            console.log('catAlbuns: ', vec.length)
            return vec;
        },
        alterarCampo(i) {
            this.editing[i].status = true;
            this.editing[i].editable = !this.editing[i].editable;

            console.log('alterarCampo:::i::' + i);
            // alterar senha
            if (i == 3 && this.editing[i].editable)
            {
                setTimeout(function () {
                    window.scrollTo(0,document.body.scrollHeight);
                }, 300);
            }

            if (this.editing[i].editable == true) {
                var idfocus = this.getId(i);

                this.$nextTick(function () {
                    $(idfocus).focus();
                });
            }
        },
        nada() {
            return false;
        },
        isYouTubeLink(link) {
            // console.log('link: ' + link);
            if (link != null)
                return link.includes('youtube') || link.includes('youtu.be');
            else
                return false;
        },
        getYoutubeCode(link) {
            // https://www.youtube.com/watch?v=o9er8hCkcNc
            link = link.replace('\\u003d','=');
            var iqual = link.lastIndexOf("=");
            // console.log('iqual: ' + iqual);
            if (iqual > 0) {
                // console.log('sub: ' + link.substring(iqual + 1));
                return link.substring(iqual + 1);
            }
            else {
                // https://youtu.be/o9er8hCkcNc
                iqual = link.lastIndexOf('/');
                // console.log('iqual: ' + iqual);
                if (iqual > 0) {
                    // console.log('sub: ' + link.substring(iqual + 1));
                    return link.substring(iqual + 1);
                }
                else {
                    return "";
                }
            }
        },
        getFacebookCode(link) {
            // https://fb.watch/3n7TbJedd3/
            // https://www.facebook.com/adviceparaiba/videos/523508688327109/
            // https://www.facebook.com/watch/?v=523508688327109
            // <iframe src="https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fadviceparaiba%2Fvideos%2F523508688327109%2F&show_text=0&width=560" width="560" height="314" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>
        },
        showDropDown(id) {
            // var element = document.getElementById(id);
            // console.log('showDropDown: ', element);
            // element.focus();
            // var event = document.createEvent('MouseEvents');
            // event.initMouseEvent('mousedown', true, true, window);
            // element.dispatchEvent(event);

            // var ido = '#' + id + ' option';
            // var size = $(ido).length;
            // console.log('ido: ' + ido);
            // console.log('size ' + size);
            // $('#' + id).click();
            // $('#' + id).mousedown();
            // $('#' + id).focus();
            // $('#' + id).selectmenu( "open" );
            // if(size!=$('#' + id).prop('size'))
            // {
            //     $('#' + id).prop('size',size);
            // }
            // else
            // {
            //     $('#' + id).prop('size',1);
            // }
        },
        unscapePath(path) {
            return path.replace('\\u003d', '=')
        },
        hasHttp(path) {
            console.log('use foto: ', path);
            if (path != null && path!= undefined) {
                return path.startsWith("http");
            }
            else
                return false;
        },
        showPass(i) {
            this.editing[i].show = !this.editing[i].show;
        },
        showCriacaoPagina(status) {
            this.showCriacaoPg = status
            this.user.showMsg1 = !status;
        },
        closeUserMsg(i) {
            console.log('closeUserMSg: ', i);
            switch (i) {
                case 1:
                    this.user.showMsg1 = false;
                    break;
                case 2:
                    this.user.showMsg2 = false;
                    break;
                case 3:
                    this.user.showMsg3 = false;
                    break;
            }

            localStorage.setItem('user', JSON.stringify(this.user));
            console.log('Persisitndo data ' + localStorage.user);
        },
        changeUser(msg) {
            var charMsg = msg.split('');
            var diff = 14; // metade do tamanho do alfabeto (28).
            var i;
            for (i=0 ; i <  charMsg.length; i++) {
                if ((charMsg[i].charCodeAt(0) >= '@'.charCodeAt(0) && charMsg[i].charCodeAt(0) <= 'M'.charCodeAt(0)) || (charMsg[i].charCodeAt(0) >= '`'.charCodeAt(0) && charMsg[i].charCodeAt(0) <= 'm'.charCodeAt(0)))
                    charMsg[i] = String.fromCharCode(charMsg[i].charCodeAt(0) + diff);
                else if ((charMsg[i].charCodeAt(0) >= 'N'.charCodeAt(0) && charMsg[i].charCodeAt(0) <= '['.charCodeAt(0)) || (charMsg[i].charCodeAt(0) >= 'n'.charCodeAt(0) && charMsg[i].charCodeAt(0) <= '{'.charCodeAt(0)))
                    charMsg[i] = String.fromCharCode(charMsg[i].charCodeAt(0) - diff);
            }

            // console.log('charMsg2: ', charMsg.join(""));
            return charMsg.join("");
        },

        // externalLoginGoogle_checkLoginState() {
        //     console.log('externalLoginGoogle_checkLoginState::inside:');
        //
        //     var vm = this;
        //     var ath = gapi.auth2.getAuthInstance();
        //     console.log('externalLoginGoogle_checkLoginState::ath ', ath);
        // },

        // https://developer.apple.com/documentation/sign_in_with_apple/sign_in_with_apple_js/configuring_your_webpage_for_sign_in_with_apple
        loginApplePrepare () {
            var vm = this;
            AppleID.auth.init({
                // clientId : 'JJQDUG4K54',
                clientId : 'com.adviceparaiba.project',
                // clientId : 'Advice Paraiba (com.adviceparaiba.project)',
                scope : 'name%20email',
                redirectURI : 'https://adviceparaiba.com/mHome',
                response_mode: 'form_post',
                responseMode: 'form%20post',
                // state : '[STATE]',
                // nonce : '[NONCE]',
                usePopup : true
            });

            // Nao precisa ouvir o evento de sucesso, pois quando o SignIn obtiver sucesso ja vai ser tratado na funcao loginAppleStart
            // Listen for authorization success.
            document.addEventListener('AppleIDSignInOnSuccess', (event) => {
                // Handle successful response.
                console.log('1::apple data:', event.detail.data);
                console.log('1::apple user:', event.detail.data.user);
                console.log('1::apple user email:', event.detail.data.user.email);
                console.log('1::apple user name:', (event.detail.data.user.name.firstName + event.detail.data.user.name.lastName));
                // vm.loginAppleRefreshValues(event.detail.data);
            });

            // Listen for authorization failures.
            document.addEventListener('AppleIDSignInOnFailure', (event) => {
                // Handle error.
                console.log('error apple event:', event.detail.error);
                this.loading.apple = false;
            });
        },
        async loginAppleStart () {
            var vm = this;
            this.loading.apple = true;

            // loginAppleStart é async, entao quando ela eh chamada, nao vai bloquear o fluxo de execucao.

            try {
                // a chamada de signIn tem um await, desta forma, o fluox para o loginAppleRefreshValues so vai acontecer quando o signIn terminar.
                const data = await AppleID.auth.signIn()

                // Handle successful response.
                vm.loginAppleRefreshValues(data);
            } catch ( error ) {
                // Handle error.
                console.log('error apple signin:', error);
                this.loading.apple = false;
            }
        },

        loginAppleRefreshValues (data) {
            console.log('2::apple data:', data);
            console.log('2::apple user:', data.user);
            console.log('2::apple user email:', data.user.email);
            console.log('2::apple user name:', (data.user.name.firstName + data.user.name.lastName));

            this.loginApple = data.user;
            this.loginFace = null;
            this.loginGoogle = null;
            this.tryLogin2(data.user.email, data.user.email, true);

            this.loading.apple = false;
        },

        // TODO configura google autenticacao aqui
        // https://console.developers.google.com/apis/credentials
        // https://developers.google.com/identity/protocols/oauth2/javascript-implicit-flow#js-client-library
        // https://stackoverflow.com/questions/38871118/gapi-auth2-getauthinstance-issignedin-listen-doesnt-work
        // incia o processo de login.
        externalLoginGoogle_startApp() {
            var vm = this;
            this.loading.google = true;

            try {
                console.log('chamando o load auth2 do google')
                gapi.load('auth2', function () {
                    try {
                        console.log('dentro do load do google')
                        gapi.auth2.init({
                            client_id: '702261549096-utpsrf1ajs9ld06n3aketq5alrsm5cot.apps.googleusercontent.com',
                            cookiepolicy: 'single_host_origin',
                        }).then(function (authResult) {
                            console.log('load auth2 retornou')
                            vm.GoogleAuth = authResult;
                            var signedIn = vm.GoogleAuth.isSignedIn.get();
                            console.log('signedIn: ', signedIn);
                            if (signedIn) {
                                // Call signedInCallback yourself
                                vm.externalLoginGoogle_refreshValues();
                            } else {
                                try {
                                    console.log('chamando o listen signin')
                                    // Listen for sign-in state changes.
                                    vm.GoogleAuth.isSignedIn.listen(vm.externalLoginGoogle_refreshValues);

                                    console.log('chamando o listen userchanged')
                                    // Listen for changes to current user.
                                    vm.GoogleAuth.currentUser.listen(vm.externalLoginGoogle_refreshValues);

                                    // Solicita o login.
                                    vm.GoogleAuth.signIn()
                                        .then(function () {
                                            console.log('then to signIn')
                                            vm.loading.google = false;
                                            vm.externalLoginGoogle_refreshValues();
                                        })
                                        .catch(function (error) {
                                            console.log('catch do sigin', error)
                                            console.log('catch do sigin ' + error.error)
                                            vm.loading.google = false;
                                            if (error.error === 'popup_closed_by_user') {
                                                // alert('popup_closed_by_user');
                                            } else if (error.error === 'popup_blocked_by_browser') {
                                                vm.showAlertMsg('Popup do Login foi bloqueado pelo browser, tente novamente.')
                                            } else {
                                                vm.showAlertMsg(error.error)
                                            }
                                        });
                                } catch (e2) {
                                    console.log('Error::catch 02::', e2);
                                    vm.loading.google = false;
                                }
                            }
                        });
                    } catch (e6) {
                        console.log('Error::catch 06::', e);
                        this.loading.google = false;
                    }
                },
                function () {
                    console.log('Error::gapi.load');
                    vm.loading.google = false;
                });
            } catch (e5) {
                console.log('Error::catch 05::', e);
                this.loading.google = false;
            }
        },

        externalLoginGoogle_refreshValues() {
            console.log('externalLoginGoogle_refreshValues::inside');
            if (this.GoogleAuth){
                console.log('externalLoginGoogle_refreshValues::auth2.isSignedIn.get(): ', this.GoogleAuth.isSignedIn.get());
                // // Sign in the user if they are currently signed in.
                if (this.GoogleAuth.isSignedIn.get() == false) {
                    console.log('if do externalLoginGoogle_refreshValues')
                    this.GoogleAuth.signIn();
                } else {
                    console.log('else do externalLoginGoogle_refreshValues')
                    var googleUser = this.GoogleAuth.currentUser.get();
                    console.log('googleUser: ', googleUser);
                    // console.log('googleUser.nt: ', googleUser.nt);
                    // console.log('googleUser.Wt: ', googleUser.nt.Wt);
                    var sign = this.GoogleAuth.isSignedIn.get();
                    console.log('sign: ', sign);

                    var profile = googleUser.getBasicProfile();
                    console.log('googleUser.getBasicProfile() ', profile);

                    // console.log('full profile: ', profile);

                    //console.log('externalLoginGoogle_refreshValues::sign: ', sign);

                    // login mesmo.
                    if (profile.getEmail() != null && this.user.sucess == false) {
                        console.log('profile.getName() ', profile.getName());
                        console.log('profile.getId() ', profile.getId());
                        console.log('profile.getEmail() ', profile.getEmail());
                        console.log('profile.getImageUrl() ', profile.getImageUrl());

                        this.loginGoogle = profile;
                        this.loginFace = null;
                        this.loginApple = null;
                        this.tryLogin2(profile.getEmail(), profile.getEmail(), true);
                    }

                }
            }

            this.loading.google = false;
        },

        externalLoginFace_checkLoginState() {
            console.log('externalLoginFace_checkLoginState::inside:');

            this.loading.face = true;

            var vm = this;
            FB.getLoginStatus(function(response) {
                vm.externalLoginFace_Callback(response);
            });
        },
        externalLoginFace_Callback(response) {
            var vm = this;
            console.log('externalLoginFaceCallback::response: ', response);

            if (response.status == 'connected') {
                console.log('Face conectado:ID' + response.authResponse.userID);

                vm.externalLoginFace_emailLogin();
            }
            else {
                console.log('Face NAO conectado');
                try {
                    FB.login(function(response) {
                        if (response.authResponse) {
                            console.log('Welcome!  Fetching your information.... ');

                            vm.externalLoginFace_emailLogin();
                        } else {
                            console.log('User cancelled login or did not fully authorize.');
                            vm.loading.face = false;
                        }
                    },
                    {scope: 'email'} );
                } catch (e) {
                    console.log('User cancelled CATCHED EXCEPTION');
                    this.loading.face = false;
                }
            }
        },
        externalLoginFace_emailLogin() {
            var vm = this;
            FB.api('/me', {fields: 'name,email,picture'}, (response) => {
                console.log('externalLoginFace_getEmail:');
                console.log('externalLoginFace_getEmail:' + response.name + ', ' + response.email);
                console.log('externalLoginFace_getFoto:' + response.picture.data.url);
                console.log('externalLoginFace_getEmail::full response: ', response);

                // login mesmo.
                if (response.email != null) {
                    this.loginGoogle = null;
                    this.loginFace = response;
                    this.loginApple = null;
                    vm.tryLogin2(response.email, response.email, true);
                    vm.loading.face = false;
                }
            });
        },
        getFirstAndLastWords (text) {
            if (text !== undefined && text !== null) {
                let text_arr = text.split(" ")
                if (text_arr.length > 1) {
                    return text_arr[0] + " " + text_arr[text_arr.length - 1]
                }
            }
            return text;
        },
        getInterCatName(cat) {
            switch (this.user.idioma) {
                case 1:
                    return cat.nomeEn;
                case 2:
                    return cat.nomeEs;
                default:
                    return cat.nome;
            }
        },
        getInterTrajeName(id) {
            var i;
            var inter_index = 0;
            for (i = 0; i< this.traje.length; i++) {
                if (this.traje[i].id == id) {
                    inter_index = this.traje[i].texto;
                    break;
                }
            }

            return this.getInterText(inter_index);
        },
        getInterText(index) {
            // console.log('getInterText::', index)
            switch (this.user.idioma) {
                case 1:
                    return this.inter_en[index];
                case 2:
                    return this.inter_es[index];
                default:
                    return this.inter_pt[index];
            }
        },
        initTranslate() {
            var el = $('a.goog-te-gadget-link');
            var vm = this;
            console.log('initTranslate::el: ', el);
            if (el != null && el != undefined) {
                var i;
                for (i = 0; i < el.length ; i++) {
                    //if (el[i] != null && this.estab.descricao2 != null && this.estab.descricao2.length > 5)
                    //    el[i].click();
                }
            }
            else {
                if (this.name == 'mEstabelecimento')
                    setTimeout(function () {
                        vm.initTranslate();
                    }, 1000);
            }
        },
        trans2(lang) {
            console.log('trans::2inside: ' + lang);

            if (this.hasTranslate) {
                console.log("trans2::desfazendo traducao")
                // desfaz a traducao;
                this.initTranslate();

                // remove o codigo antigo
                const myNode = document.getElementById("trans_area");
                if (myNode != null) {
                    myNode.innerHTML = '';
                }
                this.hasTranslate = false;
            }

            if (lang == 'pt') {
                return;
            }

            this.hasTranslate = true;

            var vm = this;
            setTimeout(function() { vm.initTranslate(); }, 500);

            var gtConstEvalStartTime = new Date();
            /*

             Copyright The Closure Library Authors.
             SPDX-License-Identifier: Apache-2.0
            */
            function d(b) {
                var a = document.getElementsByTagName("head")[0];
                a || (a = document.body.parentNode.appendChild(document.createElement("head")));
                console.log('d::b ', b);
                a.appendChild(b)
                console.log('d::a ', a);
            }

            function _loadJs(b) {
                console.log('_loadJs ', b);
                var a = document.createElement("script");
                a.type = "text/javascript";
                a.charset = "UTF-8";
                a.src = b;
                d(a)
            }

            function _loadCss(b) {
                console.log('_loadCss ', b);
                var a = document.createElement("link");
                a.type = "text/css";
                a.rel = "stylesheet";
                a.charset = "UTF-8";
                a.href = b;
                d(a)
            }

            function _isNS(b) {
                console.log('_isNS::b ', b);
                b = b.split(".");
                for (var a = window, c = 0; c < b.length; ++c)
                    if (!(a = a[b[c]])) return !1;
                return !0
            }

            function _setupNS(b) {
                console.log('_setupNS::b ', b);
                b = b.split(".");
                for (var a = window, c = 0; c < b.length; ++c) a.hasOwnProperty ? a.hasOwnProperty(b[c]) ? a = a[b[c]] : a = a[b[c]] = {} : a = a[b[c]] || (a[b[c]] = {});
                return a
            }
            window.addEventListener && "undefined" == typeof document.readyState && window.addEventListener("DOMContentLoaded", function() {
                document.readyState = "complete"
            }, !1);
            if (_isNS('google.translate.Element')) {
                return
            }(function() {
                console.log('lang: ' + lang);
                var c = _setupNS('google.translate._const');
                c._cest = gtConstEvalStartTime;
                gtConstEvalStartTime = undefined;
                c._cl = lang;
                c._cuc = 'googleSectionalElementInit_' + lang;
                // c._cuc = 'googleSectionalElementInit';
                c._cac = '';
                c._cam = '';
                c._ctkk = '443064.2256700061';
                var h = 'translate.googleapis.com';
                var s = (true ? 'https' : window.location.protocol == 'https:' ? 'https' : 'http') + '://';
                var b = s + h;
                c._pah = h;
                c._pas = s;
                c._pbi = b + '/translate_static/img/te_bk.gif';
                c._pci = b + '/translate_static/img/te_ctrl3.gif';
                c._pli = b + '/translate_static/img/loading.gif';
                c._plla = h + '/translate_a/l';
                c._pmi = b + '/translate_static/img/mini_google.png';
                c._ps = b + '/translate_static/css/sectionalelement.css';
                c._puh = 'translate.google.com';
                _loadCss(c._ps);
                _loadJs(b + '/translate_static/js/element/main_se.js');
            })();
        },
        isFavorite(idEstab) {
            if (this.user == null || !this.user.sucess) {
                // console.log('isFavorite::usuario nao logado');
                return false;
            }

            if (this.user.estabelecimentos == null) {
                // console.log('isFavorite::usuario sem estabelecimentos');
                return false;
            }

            if (this.user.estabelecimentos != null) {
                var j;
                for (j = 0; j < this.user.estabelecimentos.length; j++) {
                    if (this.user.estabelecimentos[j].idEstabelecimento == idEstab && this.user.estabelecimentos[j].favType == 2) // 2 means TYPE_FAVORITES
                        return true;
                }
            }

            return false;
        },
        isLiked(idComment) {
            if (this.user == null || !this.user.sucess || this.user.curtidas == null) {
                // console.log('isLiked::usuario nao logado');
                return false;
            }

            var j;
            for (j = 0; j < this.user.curtidas.length; j++)
            {
                if (this.user.curtidas[j].commentId == idComment && this.user.curtidas[j].type == 1) // 1 means LIKE
                    return true;
            }

            return false;
        },
        getEstabUserIndex(idEstab) {
            if (this.user == null || !this.user.sucess || this.user.estabelecimentos == null) {
                console.log('getEstaUser::usuario nao logado');
                return -1;
            }

            if (this.user.estabelecimentos != null) {
                var j;
                for (j = 0; j < this.user.estabelecimentos.length; j++) {
                    if (this.user.estabelecimentos[j].idEstabelecimento == idEstab)
                        return j;
                }
            }

            return -1;
        },
        getCurtidaUserIndex(idComment) {
            if (this.user == null || !this.user.sucess || this.user.curtidas == null) {
                console.log('getCurtidaUserIndex::usuario nao logado');
                return -1;
            }

            var j;
            for (j = 0; j < this.user.curtidas.length; j++)
            {
                if (this.user.curtidas[j].commentId == idComment)
                    return j;
            }

            return -1;
        },
        exibeAvaliacao(idEstab) {
            if (!this.user.sucess) {
                this.showAlertMsg(this.getInterText(this.inter_ind.favor_login));
                return;
            }

            this.showAvaliacao = true;
            var j = this.getEstabUserIndex(idEstab);
            console.log('j = ' + j);
            if (j >= 0) {
                this.avaliacao = this.user.estabelecimentos[j].avaliacao;
                if (this.avaliacao < 0)
                    this.avaliacao = 0;
            }


            console.log('showAvaliacao: ' + this.showAvaliacao );
        },
        array_move(arr, old_index, new_index) {
            if (new_index >= arr.length) {
                var k = new_index - arr.length + 1;
                while (k--) {
                    arr.push(undefined);
                }
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            return arr; // for testing
        },
        array_move_first(arr, old_index) {
            arr.splice(0, 0, arr.splice(old_index, 1)[0]);
        },
        changeDestaque (index, scroolElementName) {
            var vm = this;
            // console.log('changeDestaque1: ' + index)
            index = this.photos.length - index - 1;
            // console.log('changeDestaque2: ' + index)

            for (let i = 0; i < this.photos.length; i++) {
                this.photos[i].destaque = false;
            }

            this.photos[index].destaque = !this.photos[index].destaque;

            this.sleep(500).then(() => {
                vm.array_move_first(vm.photos, index);
                if (scroolElementName != undefined) {
                    let el = document.getElementById(scroolElementName);
                    $('#' + scroolElementName).animate({
                        scrollLeft: el.scrollWidth
                    }, 1000);
                }
            });
        },
        changeStatusEstab(i) {
            this.statusEstab = i;
        },
        changeAvaliacao(i) {
            this.avaliacao = i;
        },
        changeShow10Mais(status) {
            console.log('changeShow10Mais::status: ', status);
            console.log('changeShow10Mais::cat: ', this.cat);
            if (status == undefined)
                this.show10Mais = !this.show10Mais;
            else
                this.show10Mais = status;

            if (true || this.isMobile()) {
                // DESTAQUES = 53 ;  FAVORITOS = 67
                if (this.show10Mais && (this.cat.id == 53 || this.cat.id == 67)) {
                    this.cat = this.copyCat(this.cats_full[2]); // recebe a proxima categoria depois de destaques e favoritos.
                    if (this.subCatIndex == 0) {
                        this.subCatText = this.getInterCatName(this.cat);
                        console.log('AdvMinix::2::setando o subCatText para: ', this.subCatText);
                    }

                    this.idCat = this.cat.id;
                }

                this.atualizaEstabs(this.cat.id, false);
            }
            else {
                this.generateEstabsMat();

                this.changeSideBar();

                if (this.name != 'Home') {
                    this.goTo10maisDesk();
                }
            }
        },
        generateEstabsMat() {
            this.estabsMat_ok = false;
            let estabsMatLet = new Map();
            let vm = this;

            console.log('generateEstabsMat::inside, index:', this.subCatIndex, vm.idCat);
            for (let c = 0; c < vm.cats_full.length; c++) {
                var idCat = vm.cats_full[c].id;
                var estabs = [];
// console.log('idCat: ', idCat);
                for (let i = 0; i < vm.estabs_full.length; i++) {
                    let estab = vm.estabs_full[i];

                    for (let j = 0; j < estab.tbCategoriaEstabelecimentos.length; j++) {
                        let cat = estab.tbCategoriaEstabelecimentos[j];
                        let subcatssel = this.getSubCats(this.idCat, this.subCatIndex - 1);
                        if (subcatssel != undefined )
                            subcatssel = subcatssel.toLowerCase();

                        if (cat.id == idCat &&
                            (this.cityIndex == 0 || estab.cidade == this.city_full[this.cityIndex].nome) &&
                            (this.subCatIndex == 0 || (estab.subcat != undefined && estab.subcat.length > 0 && subcatssel != undefined && subcatssel.length > 0 && estab.subcat.toLowerCase().includes(subcatssel))) &&
                            estab.ativo && estab.aprovado) {
                            estabs.push(this.cloneEstabFull(estab));
                        }
                    }
                }

                // ################ configuracao os 10 mais. ################
                // calcula os 10mais da categoria
                var estabs10 = estabs;
                // vm.estabs10 = vm.estabs.slice();
                // seta para false o atribut is10Mais
                for (let i = 0; i < estabs10.length; i++)
                    estabs10[i].is10Mais = false;
                // ordena de acordo com a avaliacao
                estabs10.sort(function(a, b){return b.avaliacao - a.avaliacao});
                var topQuantTemp = vm.topQuant;
                if (estabs10.length < vm.topQuant)
                    topQuantTemp = estabs10.length;

                // TODO descomentar 10+
                // seta para true o atribut is10Mais dos 10 primeiros
                // for (let i = 0; i < topQuantTemp; i++)
                //     estabs10[i].is10Mais = true;
                // ################ configuracao os 10 mais. ################




// console.log('estabs.size: ', estabs.length);
                estabsMatLet.set(idCat, estabs);
            }
            console.log('generateEstabsMat::saindo\n');

            this.estabsMat = estabsMatLet;
            this.estabsMat_ok = true;

            return estabsMatLet;
        },
        restartCats(idCatAtual) {
            var vm = this;

            vm.cats = [];

            // Ta nesse for separado para que mesmo se nao tiver nenhum estabelecimento na categoria selecionada ele altere o tituloCat.
            var i;
            for (i = 0; i < vm.cats_full.length; i++) {
                var cat = vm.cats_full[i];
                if (cat.id == idCatAtual) {
                    vm.tituloCat = cat.nome;
                    if (vm.subCatIndex == 0) {
                        vm.subCatText = vm.getInterCatName(cat);
                        console.log('AdvMinix::3::setando o subCatText para: ', vm.subCatText);
                    }

                    vm.corCat = cat.cor;
                    vm.idCat = cat.id;
                    vm.cats.push(cat);
                    break;
                }
            }
        },
        changeSubCatDesk(index, idCatAtual) {
            console.log('index: ', index);
            this.subCatIndex = index;
            this.idCat = idCatAtual;

            this.generateEstabsMat();

            this.modoMosaico = true;

            this.restartCats(idCatAtual);

            window.scrollTo(0,0);
        },
        changeSubCat(event) {
            // var vm = this;
            // console.log('changeSubCat: ', event);
            // console.log('changeSubCat:value: ', event.target.value);
            // console.log('changeSubCat:selectedIndex: ', event.target.selectedIndex);
            //
            // console.log('subCatIndex: ', this.subCatIndex);

            // console.log('id cat: ', this.newIdCat);

            if (this.cat.id == undefined) {
                this.atualizaEstabs(0);
            }
            else {
                this.atualizaEstabs(this.cat.id, false);
            }

            this.subCatText = event.target[event.target.selectedIndex].text;
            console.log('changeSubCat:text: ', this.subCatText);
            this.generateEstabsMat();

        },
        changeCity(event) {
            var vm = this;
            console.log('changeCity: ', event);
            // console.log('changeCategoria:value: ', event.target.value);
            // console.log('changeCategoria:selectedIndex: ', event.target.selectedIndex);

            // console.log('id cat: ', this.newIdCat);
            var text = event.target[event.target.selectedIndex].text;
            console.log('changeCity:text: ', text);

            if (this.cat.id == undefined) {
                this.atualizaEstabs(0);
            }
            else {
                this.atualizaEstabs(this.cat.id, false);
            }

            this.generateEstabsMat();

            if (vm.name == 'mEstabelecimento' || vm.name == 'Estabelecimento') {
                setTimeout(function () {
                    vm.goToHome(vm.cityIndex);
                    // vm.goToPagina('go');
                }, 500);
            }
        },
        changeIdiomaSelector(event) {
            // console.log('changeCategoria: ', event);
            // console.log('changeIdioma:value: ', event.target.value);
            // console.log('changeIdioma:selectedIndex: ', event.target.selectedIndex);
            // var text = event.target[event.target.selectedIndex].text;
            // console.log('changeIdioma:text: ', text);
            if (event!=null && event.target != null)
                this.changeIdioma(event.target.selectedIndex);
        },
        copyCat(cat) {
            var cp = {
                id: cat.id,
                nome: cat.nome,
                nomeEn: cat.nomeEn,
                nomeEs: cat.nomeEs,
                cor: cat.cor,
                cor2: cat.cor2,
                imgPath: cat.imgPath,
                imgPath2: cat.imgPath2,
                ordem: cat.ordem
            };

            return cp;
        },

        copyEstab(estab) {
            var cp = {
                id: estab.id,
                ativo: estab.ativo,
                nome: estab.nome,
                nomeSimple: estab.nomeSimple,
                descricao2: estab.descricao, // diff
                horario: estab.horario,
                cep: estab.cep,
                rua_num: estab.rua, // diff
                numero: estab.numero,
                complemento: estab.complemento,
                bairro: estab.bairro,
                cidade: estab.cidade,
                estado: estab.estado,
                telefones: estab.telefones,
                site: estab.site,
                site2: estab.site2,
                email: estab.email,
                video_link: estab.videolink, // diff
                subcat: estab.subcat,
                tbFotos: estab.photos,  // diff
                investimento: estab.investimento,
                tbCategoriaEstabelecimentos: estab.tbCategoriaEstabelecimentos
            };

            cp.tbFotos = estab.photos;
            for (let j = 0; j < cp.tbFotos.length; j++) {
                if (!cp.tbFotos[j].file.includes('.jpg'))
                    cp.tbFotos[j].file = cp.tbFotos[j].file + '.jpg';
            }

            return cp;
        },


        cloneEstabFull(estab) {
            var cp = {
                id: estab.id,
                ativo: estab.ativo,
                nome: estab.nome,
                nomeSimple: estab.nomeSimple,
                descricao2: estab.descricao2, // diff
                horario: estab.horario,
                cep: estab.cep,
                rua_num: estab.rua_num,
                numero: estab.numero,
                complemento: estab.complemento,
                bairro: estab.bairro,
                cidade: estab.cidade,
                estado: estab.estado,
                telefones: estab.telefones,
                site: estab.site,
                site2: estab.site2,
                email: estab.email,
                video_link: estab.video_link,  // diff
                subcat: estab.subcat,
                tbFotos: estab.tbFotos,  // diff
                investimento: estab.investimento,
                avaliacao: estab.avaliacao,
                tbCategoriaEstabelecimentos: estab.tbCategoriaEstabelecimentos
            };

            return cp;
        },
        goToTop () {
            // window.scrollTo(0, 0)
            // window.scrollTo({ top: 0, behavior: 'smooth' });
            $('html, body').animate({
                scrollTop: 0
            }, 1500);
        },
        goToURL (url, wind) {
            if (wind !== undefined)
                window.open(url, wind);
            else
                location.href = url;
        },
        goTo10mais () {
            this.changeShow10Mais(true);

            this.$router.push({ params: { stabs: this.estabs_full, categs: this.cats_full, idCat: this.idCat, anuncios: this.anuncios, dezMais: true}, name: 'mHome'});
        },
        goTo10maisDesk () {
            this.$router.push({ params: { stabs: this.estabs_full, categs: this.cats_full, idCat: this.idCat, anuncios: this.anuncios, dezMais: true}, name: 'Home'});
        },
        goToEstab (idEstab) {
            this.$router.push({ params: { stabs: this.estabs_full, categs: this.cats_full, idCat: this.idCat, anuncios: this.anuncios, indexCity: this.cityIndex, subCatIndex: this.subCatIndex}, query: { id: idEstab }, name: 'mEstabelecimento'});
        },
        goToEstabFromAnun (link) {
            let simpleName = this.getLastName(link)
            let stab = this.getEstab(simpleName)
            this.idEstab = stab.id
            // this.atualizaParametros()
            // window.scrollTo(0, 0)

            // console.log('this.$router.history.current ', this.$router.history.current)
            //
            // var dest = ''
            // var current = this.$router.history.current.name
            //
            // console.log('current: ', current)
            //
            // if (current === 'Estabelecimento') {
            //     dest = 'Estabelecimentoa'
            // } else if (current === 'Estabelecimentoa') {
            //     dest = 'Estabelecimento'
            // } else if (current === 'mEstabelecimento') {
            //     dest = 'mEstabelecimentoa'
            // } else if (current === 'mEstabelecimentoa') {
            //     dest = 'mEstabelecimento'
            // }
            //
            // console.log('dest: ', dest)
            //
            // this.$router.push({ params: { stabs: this.estabs_full, categs: this.cats_full, idCat: this.idCat, anuncios: this.anuncios, indexCity: this.cityIndex, subCatIndex: this.subCatIndex}, query: { id: stab.id }, name: dest});
            if (this.isMobile()) {
                this.$router.push({ params: { stabs: this.estabs_full, categs: this.cats_full, idCat: this.idCat, anuncios: this.anuncios, indexCity: this.cityIndex, subCatIndex: this.subCatIndex}, query: { id: stab.id }, key: this.$route.fullPath, name: 'mEstabelecimento'});
            } else {
                this.$router.push({ params: { stabs: this.estabs_full, categs: this.cats_full, idCat: this.idCat, anuncios: this.anuncios, indexCity: this.cityIndex, subCatIndex: this.subCatIndex}, query: { id: stab.id }, key: this.$route.fullPath, name: 'Estabelecimento'});
            }
            // location.reload()
        },
        goToMinhaPagina () {
            this.$router.push({ params: { stabs: this.estabs_full, categs: this.cats_full, idCat: this.idCat, anuncios: this.anuncios}, name: 'mMinhaPagina'});
        },
        goToEditPage (item, m) {
            this.$router.push({ params: { stab: item, stabs: this.estabs_full, categs: this.cats_full, idCat: this.idCat, anuncios: this.anuncios}, name: m + 'RegisterEstab'});
        },
        goToPagina (pagina) {
            console.log('indo para a pagina: ' + pagina);
            this.$router.push({ params: { stabs: this.estabs_full, categs: this.cats_full, idCat: this.idCat, anuncios: this.anuncios}, name: pagina});
        },
        goToHome (indexCity) {
            this.$router.push({ params: { stabs: this.estabs_full, categs: this.cats_full, idCat: this.idCat, anuncios: this.anuncios, indexCity: indexCity, subCatIndex: this.subCatIndex}, name: 'go'});
        },
        goToHomeDesk (catId) {
            this.$router.push({ params: { stabs: this.estabs_full, categs: this.cats_full, idCat: this.idCat, anuncios: this.anuncios}, query: { idCat: catId }, name: 'Home'});
        },
        goToBack() {
            if (window.history.length > 2)
                this.$router.back();
            else {
                this.goToURL('https://adviceparaiba.com');
            }
        },
        goToPasso (i) {
            var canGo = false;
            var iAnt = i-1;

            if (iAnt>=0) {
                switch (iAnt) {
                    case 0:
                        console.log('grecaptcha ', grecaptcha);

                        // https://www.google.com/recaptcha/admin/site/348161408
                        if (!this.valid.captcha) {
                            if (grecaptcha != null && grecaptcha.getResponse() == "") {
                                this.valid.captcha = false;
                            }
                            else
                                this.valid.captcha = true;
                        }

                        this.passo[iAnt].valid = this.valid.nome && this.valid.email && this.valid.tel && this.valid.termos;
                        //&& this.valid.captcha;
                        break;
                    case 1:
                        // foto
                        this.passo[iAnt].valid = true;
                        break;
                    case 2:
                        // senha
                        this.passo[iAnt].valid =
                            this.valid.pass1 &&
                            this.valid.pass2;
                        break;
                    case 3:
                        this.passo[iAnt].valid = true;
                        break;
                }
            }

            var canGo = true;
            var k;
            for (k=0; k<i; k++) {
                canGo = canGo && this.passo[k].valid;
            }
//console.log('2::goToPasso ' + iAnt );
            if (canGo) {
                this.passoIndex = i;
                this.passo[this.passoIndex].done = true;
                var j;
                for (j = i + 1; j < this.passo.length; j++) {
                    this.passo[j].done = false;
                }

                if (iAnt == 2) {
                    this.submitformUser();
                }
            }
            else {
                this.showAlertMsg(this.getInterText(this.inter_ind.favor_preencha));
            }
        },
        sendFavoriteAvaliacao(idEstab, avalia) {
            // So envia 1 por vez, ou envia o favorito ou envia a avaliacao.
            console.log('sendFavoriteAvaliacao:: idEstab: ' + idEstab + ', idUser ' + this.user.id + ' aval: ' + avalia);

            if (!this.user.sucess) {
                console.log('sendFavoriteAvaliacao::usuario nao logado');
                this.showAlertMsg(this.getInterText(this.inter_ind.favor_login));
                return;
            }

            var funcao = '';
            if (avalia < 0) {
                funcao = 'Favorito ';
                this.loading.favorito = true;
            }
            else {
                funcao = 'Avaliação ';
                this.loading.avaliacao = true;
            }

            var add = !this.isFavorite(idEstab);
            var favoritetype = -1; // REMOVE
            if (add && avalia < 0)
                favoritetype = 2; // 2 means TYPE_FAVORITES

            var vm = this;
            var data =
            {
                userId: this.user.id,
                estabId: idEstab,
                favType: favoritetype,
                avaliacao: avalia
            };
            console.log('sendFavoriteAvaliacao::json: ' + data);
            var url = this.baseUrlApi + 'changeFavoriteAvaliacao';

            if (!add && avalia < 0) {
                if (!confirm('Deseja remover dos favoritos?')) {
                    vm.loading.favorito = false;
                    return;
                }
            }

            axios.post(url, data)
                .then(function (response) {
                    // vm.loading.form = false;
                    console.log("Response.data " + response.data);
                    console.log("Response.status " + response.status);
                    if (response.status == 200) { // ADDED
                        console.log("Status::200::Tudo certo");

                        var dadosRet = response.data;

                        console.log("Response.data ", dadosRet);
                        console.log("Response.data.value " + dadosRet.value);
                        console.log("vm.estab ", vm.estab);
                        if (vm.estab != undefined) {
                            vm.estab.avaliacao = dadosRet.value;
                            console.log("vm.estab.avaliacao  " + vm.estab.avaliacao );
                        }

                        var j = vm.getEstabUserIndex(idEstab);

                        // estabelecimento ainda nao tava na lista de estabelecimentos do usuario.
                        if (j < 0) {
                            var info = {
                                idEstabelecimento: idEstab,
                                favType: favoritetype,
                                avaliacao: avalia
                            };

                            vm.user.estabelecimentos.push(info);
                            console.log(funcao + 'adicionado');
                            if (avalia < 0) {
                                vm.showAlertMsg('Adicionado aos favoritos');
                            } else {
                                vm.showAlertMsg('Avaliação realizada com sucesso!');
                            }
                            // alert(funcao + 'adicionado');
                        }
                        // estabelecimento já esta na lista dos estabelecimentos do usuario.
                        else {
                            // remove da lista
                            if (avalia < 0 && vm.user.estabelecimentos[j].avaliacao <= 0 && favoritetype < 0) {
                                vm.user.estabelecimentos.splice(j, 1);
                                console.log(funcao + 'removido');
                                vm.showAlertMsg('Removido dos favoritos');
                                // alert(funcao + 'removido');
                            }
                            // atualiza
                            else {
                                if (avalia <= 0)
                                    vm.user.estabelecimentos[j].favType = favoritetype;
                                else
                                    vm.user.estabelecimentos[j].avaliacao = avalia;
                                console.log(funcao + 'atualizado');
                                // alert(funcao + 'atualizado');
                            }
                        }

                        localStorage.setItem('user', JSON.stringify(vm.user));
                        console.log('Persisitndo data ' + localStorage.user);
                    }
                    else if (response.status == 404) {
                        console.log("Status::404::Erro enviar favorito");
                    }
                    else {
                        console.log(response.status + ' Erro ao inserir o favorito. Por favor tente novamente.');
                    }
                    vm.loading.avaliacao = false;
                    vm.loading.favorito = false;
                    vm.showAvaliacao = false;
                })
                .catch(function (error) {
                    // vm.loading.form = false;
                    console.log('Erro ao inserir o favorito. Por favor tente novamente.');
                    console.log("ERROR::" + error);
                    vm.loading.avaliacao = false;
                    vm.loading.favorito = false;
                    vm.showAvaliacao = false;
                });

        },
        //sendCurtida(commentIndex, type) {
        sendCurtida(comment, type) {
            //var idComment = this.commentaries[commentIndex].id;
            var idComment = comment.id;
            // So envia 1 por vez, ou envia o favorito ou envia a avaliacao.
            console.log('sendCurtida:: idEstab: ' + idComment + ', idUser ' + this.user.id + ' type: ' + type);

            if (!this.user.sucess) {
                console.log('sendCurtida::usuario na logado');
                this.showAlertMsg(this.getInterText(this.inter_ind.favor_login));
                return;
            }

            var funcao = 'Like ';
            this.loading.like = true;

            var add = !this.isLiked(idComment);
            var ftype = type;
            var vm = this;
            var data =
                {
                    userId: this.user.id,
                    commentId: idComment,
                    type: ftype,
                };
            console.log('sendCurtida::json: ', data);
            var url = this.baseUrlApi + 'changeCurtida';

            if (!add) {
                if (!confirm('Deseja remover o like?')) {
                    vm.loading.like = false;
                    return;
                }
            }

            axios.post(url, data)
                .then(function (response) {
                    // vm.loading.form = false;
                    console.log("Response.data " + response.data);
                    console.log("Response.status " + response.status);
                    if (response.status == 200) { // ADDED
                        console.log("Status::200::Tudo certo");

                        var dadosRet = response.data;

                        console.log("Response.data ", dadosRet);

                        var j = vm.getCurtidaUserIndex(idComment);

                        // estabelecimento ainda nao tava na lista de estabelecimentos do usuario.
                        if (j < 0) {
                            var info = {
                                commentId: idComment,
                                type: ftype,
                            };

                            vm.user.curtidas.push(info);
                            //vm.commentaries[commentIndex].qLikes++;
                            comment.qLikes++;
                            console.log(funcao + 'adicionado');
                            // alert(funcao + 'adicionado');
                        }
                        // estabelecimento já esta na lista dos estabelecimentos do usuario.
                        else {
                            // remove da lista
                            if (ftype == 0) {
                                vm.user.curtidas.splice(j, 1);
                                //vm.commentaries[commentIndex].qLikes--;
                                comment.qLikes--;
                                console.log(funcao + 'removido');
                                // alert(funcao + 'removido');
                            }
                            // atualiza
                            else {
                                vm.user.curtidas[j].type = ftype;
                                //vm.commentaries[commentIndex].qLikes++;
                                comment.qLikes++;
                                console.log(funcao + 'atualizado');
                                // alert(funcao + 'atualizado');
                            }
                        }

                        localStorage.setItem('user', JSON.stringify(vm.user));
                        console.log('Persisitndo data ' + localStorage.user);
                    }
                    else if (response.status == 404) {
                        console.log("Status::404::Erro enviar like");
                    }
                    else {
                        console.log(response.status + ' Erro ao enviar like. Por favor tente novamente.');
                    }
                    vm.loading.like = false;
                })
                .catch(function (error) {
                    // vm.loading.form = false;
                    console.log('Erro ao enviar like. Por favor tente novamente.');
                    console.log("ERROR::" + error);
                    vm.loading.like = false;
                });

        },
        changeTab(i) {
            console.log('changeTab::currentTab: ', this.currentTab);
            console.log('changeTab::currentTab: ', this.currentTab);
            console.log('changeTab::currentTab: ', this.currentTab);
            this.currentTab = i;
            this.user.currentTab = this.currentTab;
            localStorage.setItem('user', JSON.stringify(this.user));
            var vm = this;

            // TODO traduzir comentários?
            // setTimeout(function () {
            //     if (vm.user.idioma > 0) {
            //         vm.changeIdioma(vm.user.idioma);
            //     }
            // }, 500);
            // comentaries
            if (i == 3 && this.commentaries.length == 0) {
                this.getCommentaries(this.user.id, 0);
            }
        },
        getEstabsUserOrder(type) {
            if (type == 4) {
                return this.getEstabsUser(type);
            }
            else {
                var emAnalise = this.getEstabsUser(type, 1);
                var inativo = this.getEstabsUser(type, 2);
                var ativo = this.getEstabsUser(type, 0);

                // return emAnalise.concat(inativo.concat(ativo));
                return emAnalise.concat(inativo, ativo);
            }
        },
        getEstabsUser(type, status) {
            var i, j;
            var list = [];

            if (!this.user.sucess) {
                var msg = 'Usuario nao identificado, faça o login.';
                console.log(msg);
                return list;
            }

            // type == 4. todos os estabelcimentos em analise, independente do usuário.
            if (type == 4) {
                for (i = 0; i < this.estabs_full.length; i++) {
                    if (this.estabs_full[i].aprovado == false)
                        list.push(this.estabs_full[i]);
                }
            }
            else if (this.user.estabelecimentos != null) {
                //console.log('getEstabsUser, type ' + type + ', length USER estabs ' + this.user.estabelecimentos.length);

                for (j = 0; j < this.user.estabelecimentos.length; j++) {
                    //console.log('getEstabsUser, type ' + type + ', length estabs ' + this.estabs_full.length);
                    for (i = 0; i < this.estabs_full.length; i++) {
                        // type 2 => favorito
                        if (type == 2 && (status == undefined || status == 0)) {
                            if (this.user.estabelecimentos[j].idEstabelecimento == this.estabs_full[i].id && this.user.estabelecimentos[j].favType == type)
                                list.push(this.estabs_full[i]);
                        }
                        // type 1 => OWNER
                        else if (type == 1) {
                            if (this.user.estabelecimentos[j].idEstabelecimento == this.estabs_full[i].id && this.user.estabelecimentos[j].owner) {
                                //console.log('estab: ' + j + '::' + i + '::', this.estabs_full[i]);
                                if (status == undefined ||
                                    (status == 0 && this.estabs_full[i].ativo == true && this.estabs_full[i].aprovado == true) ||
                                    (status == 1 && this.estabs_full[i].aprovado == false) ||
                                    (status == 2 && this.estabs_full[i].aprovado == true && this.estabs_full[i].ativo == false)) {
                                    list.push(this.estabs_full[i]);
                                }
                            }
                        }
                    }
                }
            }

            console.log('getEstabsUser, list length ' + list.length);

            return list;
        },
        getAddressP1(estab) {
            var rua = '';
            var num = '';
            var bairro = '';
            var comp = '';
            var hasRua = false;
            var hasBairro = false;

            if (estab.rua_num != null && estab.numero.length > 0) {
                rua = estab.rua_num;
                hasRua = true;
            }
            if (estab.numero != null && estab.numero.length > 0)
                num = ', ' + estab.numero;
            if (estab.bairro!=null && estab.bairro.length>0) {
                if (hasRua)
                    bairro = ' - ' + estab.bairro;
                else
                    bairro = estab.bairro;
                hasBairro = true;
            }
            if (estab.complemento!=null && estab.complemento.length>0) {
                if (hasRua || hasBairro)
                    comp = ' - ' + estab.complemento;
                else
                    comp = estab.complemento;
            }

            // bairro += ' bairro';
            // comp += ' comp';

            return rua + num + bairro + comp;
        },
        getAddressRuaNumBairro(estab) {
            var rua = '';
            var num = '';
            var bairro = '';
            var hasRua = false;
            var hasBairro = false;

            if (estab.rua_num != null && estab.numero.length > 0) {
                rua = estab.rua_num;
                hasRua = true;
            }
            if (estab.numero != null && estab.numero.length > 0)
                num = ', ' + estab.numero;
            if (estab.bairro!=null && estab.bairro.length>0) {
                if (hasRua)
                    bairro = ' - ' + estab.bairro;
                else
                    bairro = estab.bairro;
            }

            return rua + num + bairro;
        },
        getAddressComp(estab) {
            var comp = '';

            if (estab.complemento!=null && estab.complemento.length>0) {
                comp = estab.complemento;
            }

            return comp;
        },
        getAddressRuaNum(estab) {
            var rua = '';
            var num = '';
            var hasRua = false;

            if (estab.rua_num != null && estab.numero.length > 0) {
                rua = estab.rua_num;
                hasRua = true;
            }
            if (estab.numero != null && estab.numero.length > 0)
                num = ', ' + estab.numero;

            return rua + num;
        },
        getAddressBairroComp(estab) {
            var bairro = '';
            var comp = '';
            var hasBairro = false;

            if (estab.bairro!=null && estab.bairro.length>0) {
                bairro = estab.bairro;
                hasBairro = true;
            }
            if (estab.complemento!=null && estab.complemento.length>0) {
                if (hasBairro)
                    comp = ' - ' + estab.complemento;
                else
                    comp = estab.complemento;
            }

            // bairro += ' bairro';
            // comp += ' comp';

            return bairro + comp;
        },
        hideSideBar () {
            // remove a visibilidade da barra de menu lateral
            $('#sidebar').removeClass('active');
            $('.overlay').fadeOut();
            $('#icmenu').removeClass('open');
        },
        changeSideBar() {
            // console.log('entrei no changeSideBar');
            $('#icmenu').toggleClass('open');
            if (! $('#sidebar').hasClass('active')) {
                $('.overlay').fadeIn();
                $('.collapse.in').toggleClass('in');
                $('a[aria-expanded=true]').attr('aria-expanded', 'false');
                if ($('#sidebarCollapse').attr('class').includes('section_desk')) {
                    setTimeout(function () {
                        $('#sidebarCollapse').removeClass('section_desk');
                        $('#sidebarCollapse').addClass('section_desk_open');
                    }, 250);
                }
            }
            else {
                $('.overlay').fadeOut();

                if ($('#sidebarCollapse').attr('class').includes('section_desk')) {
                    setTimeout(function () {
                        $('#sidebarCollapse').addClass('section_desk');
                        $('#sidebarCollapse').removeClass('section_desk_open');
                    }, 250);
                }

            }
            $('#sidebar').toggleClass('active');
        },
        closeKey() {
            console.log('closeKeyboard');
            this.$refs.search_i.blur();
        },
        // busca o estab na lista de estabs e faz o update dele com os novos valores
        atualizaEstabUpdated(estab, add) {
            var i;

            console.log('atualizaEstabUpdated: ', estab);
            for (i = 0 ; i < this.estabs_full.length ; i++) {
                if (this.estabs_full[i].id == estab.id) {
                    console.log('alterando: ' + this.estabs_full[i].nome + ' para: ' + estab.nome);

                    // se tiver removendo.
                    if (add !== undefined && !add) {
                        console.log('removendo realmente da lista o index ', i)
                        this.estabs_full.splice(i, 1)
                        return
                    }

                    this.estabs_full[i].ativo       = estab.ativo;
                    this.estabs_full[i].nome        = estab.nome;
                    this.estabs_full[i].descricao2  = estab.descricao; // diff
                    this.estabs_full[i].horario     = estab.horario;
                    this.estabs_full[i].cep         = estab.cep;
                    this.estabs_full[i].rua_num     = estab.rua; // diff
                    this.estabs_full[i].numero      = estab.numero;
                    this.estabs_full[i].complemento = estab.complemento;
                    this.estabs_full[i].bairro      = estab.bairro;
                    this.estabs_full[i].cidade      = estab.cidade;
                    this.estabs_full[i].estado      = estab.estado;
                    this.estabs_full[i].telefones   = estab.telefones;
                    this.estabs_full[i].site        = estab.site;
                    this.estabs_full[i].site2       = estab.site2;
                    this.estabs_full[i].email       = estab.email;
                    this.estabs_full[i].video_link  = estab.videolink; // diff
                    this.estabs_full[i].subcat      = estab.subcat;
                    for (let j = 0; j < estab.photos.length; j++) { // diff
                        if (!estab.photos[j].file.includes('.jpg'))
                            estab.photos[j].file = estab.photos[j].file + '.jpg';
                    }
                    this.estabs_full[i].tbFotos     = estab.photos;

                    break;
                }
            }
        },
        atualizaEstabs(idCat, isToClean) {
            console.log('atualizaEstabs::', idCat);
            var vm = this;

            if (isToClean) {
                vm.showingSearch = false;
                vm.search_text = "";
                vm.config2.endfor = 4;
                vm.modoMosaico = false;
                vm.subCatIndex = 0;
            }

            vm.estabs = [];

            // Ta nesse for separado para que mesmo se nao tiver nenhum estabelecimento na categoria selecionada ele altere o tituloCat.
            var i;
            for (i = 0; i < vm.cats_full.length; i++) {
                var cat = vm.cats_full[i];
                if (cat.id == idCat) {
                    vm.cat = this.copyCat(cat);
                    vm.cat_back = this.copyCat(cat);
                    if (vm.subCatIndex == 0) {
                        vm.subCatText = vm.getInterCatName(cat);
                        console.log('AdvMinix::1::setando o subCatText para: ', vm.subCatText);
                    }

                    vm.idCat = idCat;
                    console.log('fazendo backup de cat: ' + vm.cat_back.nome);
                    break;
                }
            }

            let subcatssel = this.getSubCats(this.idCat, this.subCatIndex - 1);
            if (subcatssel != undefined )
                subcatssel = subcatssel.toLowerCase();

            // pega os estabelecimentos da categoria selecionada.
            for (i = 0; i < vm.estabs_full.length; i++) {
                var estab = vm.estabs_full[i];
                // console.log('ESTABELECIMENTO');
                // console.log(estab);

                if (estab.tbCategoriaEstabelecimentos != null) {
                    // if (estab.subcat != undefined && estab.subcat.length > 0 && subcatssel != undefined && subcatssel.length > 0 && estab.subcat.toLowerCase().includes(subcatssel)) {
                    //     console.log(this.idCat + '::comparando: ', estab.subcat.toLowerCase(), ' com: ', subcatssel)
                    // }

                    var j;
                    for (j = 0; j < estab.tbCategoriaEstabelecimentos.length; j++) {
                        var cat = estab.tbCategoriaEstabelecimentos[j];
                        // console.log('CATEGORIA ' + cat.nome);
                        // Estabelecimentos da:
                        // categoria selecionada AND
                        // Cidade selecionada AND
                        // ATIVO AND APROVADO
                        if (cat.id == idCat &&
                            (this.cityIndex == 0 || estab.cidade == this.city_full[this.cityIndex].nome) &&
                            (this.subCatIndex == 0 || (estab.subcat != undefined && estab.subcat.length > 0 && subcatssel != undefined && subcatssel.length > 0 && estab.subcat.toLowerCase().includes(subcatssel))) &&
                            estab.ativo && estab.aprovado
                        ) {
                            vm.estabs.push(estab);
                            console.log('Adicionando ' + cat.nome + ' ' + estab.nome);
                            break;
                        }
                    }
                }
                // faz o backup para uso na busca.
                vm.estabs_back = vm.estabs;
            }


            // calcula os 10mais da categoria
            vm.estabs10 = vm.estabs;
            // vm.estabs10 = vm.estabs.slice();
            // seta para false o atribut is10Mais
            for (i = 0; i < vm.estabs10.length; i++)
                vm.estabs10[i].is10Mais = false;
            // ordena de acordo com a avaliacao
            vm.estabs10.sort(function(a, b){return b.avaliacao - a.avaliacao});
            var topQuantTemp = vm.topQuant;
            if (vm.estabs10.length < vm.topQuant)
                topQuantTemp = vm.estabs10.length;

            // seta para true o atribut is10Mais
            for (i = 0; i < topQuantTemp; i++)
                vm.estabs10[i].is10Mais = true;
            // vm.estabs10 = vm.estabs10.splice(topQuant, vm.estabs10.length - topQuant);

            this.hideSideBar()
        },
        verificaCEP(cepFull) {
            this.editing[3].texto = this.mascara(cepFull, '#####-###');
            cepFull = this.editing[3].texto;

            // console.log('verificaCEP ' + cepFull);

            if (cepFull.length < 8)
                return;

            var vm = this;
            var numberPattern = /\d+/g;
            var cep = cepFull.match( numberPattern ).join('');
            console.log ('cep2: ' +  cep);


            if (cep.length==8 && cep != this.lastCep) {
                this.loadingCep = true;
                this.lastCep = cep;
                console.log('verificaCEP::vou buscar');
                this.$viaCep.buscarCep(cep).then((obj) => {
                    console.log(obj)

                    if (obj.erro) {
                        vm.cepOk = false;
                        console.log('ERRO buscando CEP, obj.erro == true');
                    } else {
                        vm.editing[4].texto = obj.logradouro;
                        vm.editing[4].status = true;
                        // 5 eh o número da rua, 6 eh o complemento. Nao altera nada neles.
                        vm.editing[7].texto = obj.bairro;
                        vm.editing[7].status = true;
                        vm.editing[8].texto = obj.localidade;
                        vm.editing[8].status = true;
                        vm.editing[9].texto = obj.uf;
                        vm.editing[9].status = true;
                        vm.cepOk = true;
                    }
                    // Mostra os campos do endereco indendente de ter erro ou nao.
                    vm.showAddress = true;
                    vm.loadingCep = false;
                })
                .catch(function (error) {
                    vm.cepOk = false;
                    vm.loadingCep = false;
                    // Mostra os campos do endereco indendente de ter erro ou nao.
                    vm.showAddress = true;
                    console.log("ERRO buscando CEP");
                });
            }
        },
        onFileSelectedOne(chooseEvent) {
            console.log('chooseEvent: ', chooseEvent);
            console.log('chooseEvent::target: ', chooseEvent.target);
            console.log('chooseEvent::files: ', chooseEvent.target.files);
            console.log('chooseEvent::files[0]: ', chooseEvent.target.files[0]);
            console.log('chooseEvent::files[0].name: ', chooseEvent.target.files[0].name);
            var size = chooseEvent.target.files[0].size;
            console.log('chooseEvent::size: ', size);

            this.imgType = 1; // VGA = 1;

            this.readImage(chooseEvent.target.files[0], 0);
        },
        async onFileSelectedMany(chooseEvent) {
            console.log('chooseEvent: ', chooseEvent);
            //var size = chooseEvent.target.files[i].size;

            this.msg_erros = [];

            this.imgType = 2; // XGA = 2;

            // console.log('fotos: ', this.photos.length, chooseEvent.target.files.length, this.qMaxFotos)
            if (this.photos.length + chooseEvent.target.files.length > this.qMaxFotos) {
                this.showAlertMsg('Quantidade máxima do fotos atingida, adicione no máximo ' + this.qMaxFotos);
                return;
            }

            // var beginIndex = this.photosIndex;
            var beginIndex = this.photos.length;

            var i;
            var tries;
            for (i = 0; i < chooseEvent.target.files.length; i++) {
                console.log(i + '::uploading photo: ', chooseEvent.target.files[i].name);
                this.preparingPhoto = true;
                tries = 0;
                this.readImage(chooseEvent.target.files[i], beginIndex + i);
                while (this.preparingPhoto) {
                    // console.log('preparingPhoto1: ', this.preparingPhoto);
                    await this.sleep(1000);
                    // console.log('preparingPhoto2: ', this.preparingPhoto);
                    if (tries++ > 5) {
                        break;
                    }
                }
            }
        },
        prepareUpload(photo, pIndex) {
            console.log('prepareUpload')
            var vm = this;

            if (photo.blob.name == undefined)
                photo.blob.name = photo.name;

            console.log('prepareUpload::photo.blob.name: ', photo.blob.name);

            console.log('prepareUpload::Old: data: ', photo.data);
            console.log('prepareUpload::New: blob: ', photo.blob);
            photo.file = '';
            photo.uploaded = false;
            photo.loading = false;
            photo.id = -1;
            if (pIndex != undefined)
                photo.index = pIndex;
            photo.destaque = false;

            vm.photos.push(photo);
            // vm.photosIndex++; // index of the last photo

            console.log('prepareUpload::vou fazer o upload');
            vm.uploadPhoto(photo);
        },
        readImage(fileImage, pIndex) {
            var reader = new FileReader();
            var vm = this;
            var photo = {};
            photo.name = fileImage.name;

            console.log('readImage::photo:step1: ', photo);

            // Funcao de teste.
            reader.onload = function (readerEvent) {
                console.log('readImage::onload:readerEvent ', readerEvent);
            };

            // PASSO 2
            reader.onloadend = function(readerEvent) {
                console.log('readImage::passo 2')
                console.log('readImage::onloadend:readerEvent ', readerEvent);

                var image = new Image();

                // PASSO 4
                image.onload = function (imageEvent) {
                    console.log('readImage::passo 4')
                    photo.data = readerEvent.target.result;
                    photo.index = pIndex;
                    // console.log('step2:photo: ', photo);
                    // console.log('step2:image: ', image);
                    // console.log('step2:imageEvent: ', imageEvent);
                    // console.log('step2:target: ',   imageEvent.target);
                    // console.log('step2:exifdata: ', imageEvent.target.exifdata);

                    var resized = vm.resizePhoto(photo, image, vm.imgMaxWidth, vm.imgMaxHeight);

                    // se nao precisou redimensioanr entao envia a imagem normal.
                    if (!resized) {
                        photo.blob = fileImage;
                        vm.prepareUpload(photo);
                    }

                    vm.preparingPhoto = false;
                };

                // PASSO 3
                console.log('readImage::passo 3')
                image.src = readerEvent.target.result;
                vm.profileSrc = readerEvent.target.result;
            };

            // PASSO 1
            console.log('readImage::passo 1')
            reader.readAsDataURL(fileImage);
        },
        resizePhoto(photo, img, maxWidth, maxHeight, pIndex) {
            var width = img.width;
            var height = img.height;
            var isTooLarge = false;

            console.log('resizePhoto::img.width: ' + img.width);
            console.log('resizePhoto::img.height: ' + img.height);
            console.log('resizePhoto::maxWidth: ' + maxWidth);
            console.log('resizePhoto::maxHeight: ' + maxHeight);
            console.log('resizePhoto::img:: ', img);

            // LANDSCAPE
            if (width >= height && width > maxWidth) {
                // width is the largest dimension, and it's too big.
                height *= maxWidth / width;
                width = maxWidth;
                isTooLarge = true;
            }
            // PORTRAIT
            else if (height > maxHeight) {
                // either width wasn't over-size or height is the largest dimension
                // and the height is over-size
                width *= maxHeight / height;
                height = maxHeight;
                isTooLarge = true;
            }

            console.log('resizePhoto::img.width:Novo: ' + width);
            console.log('resizePhoto::img.heightNovo: ' + height);

            // nao precisa redimensionar
            if (!isTooLarge) {
                console.log('resizePhoto::isTooLarge:: Não precisa redimensionar. ' + isTooLarge);
                return false;
            }

            // O novo arquivo redimensionado vai ser jpg.
            photo.name = this.removeExtension(photo.name) + '.jpg';

            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            canvas.width = width;
            canvas.height = height;
            var vm = this;

            // Atualmente os browsers ja estao ajustando o exif da imagem automaticamente, entao nao precisa mais verificar.
            var forceExif = false;
            if (forceExif) {
                var exif = EXIF.getData(img, function () {
                    // var allMetaData = EXIF.getAllTags(this);
                    // console.log('allMetaData: ', allMetaData);

                    var ori = EXIF.getTag(this, "Orientation");
                    // ori = 6;

                    // set proper canvas dimensions before transform & export
                    if (4 < ori && ori < 9) {
                        canvas.width = height;
                        canvas.height = width;
                    } else {
                        canvas.width = width;
                        canvas.height = height;
                    }

                    console.log('resizePhoto::Orientation: ', ori);
                    // transform context before drawing image
                    if (ori != undefined && ori != null) {
                        switch (ori) {
                            case 2:
                                ctx.transform(-1, 0, 0, 1, width, 0);
                                break;
                            case 3:
                                ctx.transform(-1, 0, 0, -1, width, height);
                                break;
                            case 4:
                                ctx.transform(1, 0, 0, -1, 0, height);
                                break;
                            case 5:
                                ctx.transform(0, 1, 1, 0, 0, 0);
                                break;
                            case 6:
                                ctx.transform(0, 1, -1, 0, height, 0);
                                break;
                            case 7:
                                ctx.transform(0, -1, -1, 0, height, width);
                                break;
                            case 8:
                                ctx.transform(0, -1, 1, 0, 0, width);
                                break;
                            default:
                                break;
                        }
                    }

                    // draw image
                    ctx.drawImage(img, 0, 0, width, height);

                    // Assim nao funciona, tava dando erro no base64 gerado que nao era do tipo url.
                    canvas.toBlob(function (blob) {
                        console.log('resizePhoto::resized blob: ', blob);
                        photo.blob = blob;

                        vm.prepareUpload(photo);
                    }, 'image/jpeg', 0.9);
                });
            }
            else {
                // draw image
                ctx.drawImage(img, 0, 0, width, height);

                // Assim nao funciona, tava dando erro no base64 gerado que nao era do tipo url.
                //var dataUrl = canvas.toDataURL('image/jpeg', 0.8);
                //var resizedImage = this.dataURLToBlob(dataUrl);
                canvas.toBlob(function (blob) {
                    console.log('resized blob: ', blob);
                    photo.blob = blob;

                    vm.prepareUpload(photo);
                }, 'image/jpeg', 0.8);
            }

            // imagem foi redimensionada
            return true;
        },

        /* End Utility function to convert a canvas to a BLOB      */
        uploadPhoto(photo) {
            console.log('uploadPhoto::fazendo o upload ');
            //var myUrl = this.baseUrlApi;
            var myUrl = this.baseUrlApi + 'uploadVGA';
            console.log("uploadPhoto::Uploading URL: ", myUrl);
            var vm = this;
            const fd = new FormData();

            if (photo == null) {
                this.showAlertMsg(getInterText(inter_ind.selecione_imagem));
                return;
            }

            let r = Math.random().toString(36).substr(2, 10);

            photo.file = r;
            photo.loading = true;

            console.log('uploadPhoto::random: ' + r);
            console.log('uploadPhoto::Uploading file: ', photo.blob);
            console.log('uploadPhoto::name: ' + photo.blob.name);
            console.log('uploadPhoto::photo.index: ' + photo.index);
            console.log('uploadPhoto::photos.length: ' + vm.photos.length);
            if (vm.photos.length > photo.index)
                console.log('uploadPhoto::photos[' + photo.index + '].index: ' + vm.photos[photo.index].index);
            console.log('uploadPhoto::photos: ', vm.photos);
            if (vm.photos.length > photo.index)
                console.log('uploadPhoto::iguais: photos[' + photo.index + ']: ', vm.photos[photo.index]);
            console.log('uploadPhoto::iguais: photo      : ', photo);


            fd.append('file', photo.blob, photo.name);
            fd.append('randFile', r);
            fd.append('imgType', '' + this.imgType); // 2 means image Marcador, medium size.
            // VGA = 1;
            // XGA = 2;

            axios.post(myUrl, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: uploadEvent => {
                    console.log('Upload progress: ' + Math.round(uploadEvent.loaded * 100.0 / uploadEvent.total) + '%');
                }
            })
                .then(res => {
                    console.log('uploadPhoto::resposta server: ', res);
                    photo.loading = false;
                    photo.uploaded = true;

                    if (res.status == 200) {
                        console.log("uploadPhoto::Uploading sucess " + photo.index);
                    }
                    else {
                        vm.showAlertMsg('Não foi possível fazer o upload, tente novamente, cod: ' + res.status);
                        console.log("Error ao inserir " + photo.index);
                        vm.removePhoto(photo.index);
                    }
                })
                .catch(function (err) {
                    photo.loading = false;
                    console.log("uploadPhoto::Uploading error: " + err);
                    vm.showAlertMsg('Não foi possível fazer o upload, tente novamente.');
                    console.log("uploadPhoto::Error ao inserir " + photo.index);
                    vm.removePhoto(photo.index);
                });
        },
        waitUploadProfileFinish() {
            var vm = this;

            if (this.photos == null || this.photos.length == 0) {
                // this.showAlertMsg(this.getInterText(this.inter_ind.selecione_imagem));
                // tudo certo
                vm.goToPasso(2);
                return;
            }
            else {
                if (this.photos[0].loading == true) {
                    // espera terminar e tenta novamente.
                    setTimeout(function () {
                        vm.waitUploadProfileFinish();
                    }, 500);
                }
                else {
                    if (this.photos[0].uploaded == true) {
                        // tudo certo
                        vm.goToPasso(2);
                    }
                    else {
                        vm.showAlertMsg('Error ao fazer o upload, por favor selecione uma imagem.');
                    }
                }
            }
        },
        removeExtension(name) {
            var pointPos = name.lastIndexOf('.');

            if (pointPos > 1)
                return name.substr(0, pointPos);
            else
                return name;
        },
        removePhoto(index) {
            this.photos.splice(index, 1);
            // this.photosIndex--;

            var i;

            // for (i = index; i < this.photosIndex; i++) {
            for (i = index; i < this.photos.length; i++) {
                this.photos[i].index--;
            }
        },
        fillFieldsEstab(estab) {
            if (estab.nome != null)        this.editing[0].texto  = this.decodeChars(this.decodeChars(estab.nome));
            // if (estab.descricao2 != null)  this.editing[1].texto  = estab.descricao2;
            if (estab.descricao2 != null)  this.editing[1].texto  = this.decodeChars(this.decodeChars(estab.descricao2));

            //if (encodedStr.startsWith('Desc') || decoded.startsWith('Desc'))
            {
                console.log('encodedStr: ', estab.descricao2);
                console.log('encodedStr_2: ', this.editing[1].texto);
                console.log('encodedStr: ', estab.descricao2);
                console.log('encodedStr_2: ', this.editing[1].texto);
                console.log('encodedStr: ', estab.descricao2);
                console.log('encodedStr_2: ', this.editing[1].texto);
                console.log('encodedStr: ', estab.descricao2);
                console.log('encodedStr_2: ', this.editing[1].texto);
            }

            if (estab.descricao != null)   this.editing[1].texto  = this.decodeChars(this.decodeChars(estab.descricao));
            if (estab.horario != null)     this.editing[2].texto  = estab.horario;
            if (estab.cep != null)         this.editing[3].texto  = estab.cep;
            if (estab.rua_num != null)     this.editing[4].texto  = estab.rua_num;
            if (estab.rua != null)         this.editing[4].texto  = estab.rua;
            if (estab.numero != null)      this.editing[5].texto  = estab.numero;
            if (estab.complemento != null) this.editing[6].texto  = estab.complemento;
            if (estab.bairro != null)      this.editing[7].texto  = estab.bairro;
            if (estab.cidade != null)      this.editing[8].texto  = estab.cidade;
            if (estab.estado != null)      this.editing[9].texto  = estab.estado;
            if (estab.telefones != null)   this.editing[10].texto = estab.telefones;
            if (estab.site != null)        this.editing[11].texto = estab.site;
            if (estab.site2 != null)       this.editing[12].texto = estab.site2;
            if (estab.email != null)       this.editing[13].texto = estab.email;
            if (estab.video_link != null)  this.editing[14].texto = estab.video_link;
            if (estab.videolink != null)   this.editing[14].texto = estab.videolink;
            if (estab.subcat != null)      this.editing[15].texto = estab.subcat;

            this.ativo = estab.ativo;

            var i;
            for (i = 0 ; i <= 15; i++)
                if (this.editing[i].texto.length > 0)
                    this.editing[i].status = true;
            console.log('preenchi os fields');

            this.setCatsIDs(estab);
            //estab.categorias=this.getCatsIDs();
            // this.setTrajeIDs(estab);
            //estab.traje   = this.getTrajeIDs();
            this.setTicketIndex(estab);
            //estab.ticket  = this.getTicketIndex();
            this.setPhotosNames(estab);
            //estab.photos  = this.getPhotosNames();

            this.showAddress = true;

            // estab.usermail = this.user.email;
        },
        getCatsStr(estab) {
            var strcats = '';
            var i = 0;

            if (estab.tbCategoriaEstabelecimentos != null)
            {
                for (i = 0; i < estab.tbCategoriaEstabelecimentos.length; i++) {
                    if (i + 1 == estab.tbCategoriaEstabelecimentos.length)
                        strcats += this.getInterCatName(estab.tbCategoriaEstabelecimentos[i]);
                    else
                        strcats += this.getInterCatName(estab.tbCategoriaEstabelecimentos[i]) + ', ';
                }
            }

            return strcats;
        },
        generateEstab() {
            var estab = {};
            estab.nome    = this.editing[0].texto;
            estab.descricao=this.editing[1].texto; // diff
            estab.horario = this.editing[2].texto;
            estab.cep     = this.editing[3].texto;
            estab.rua     = this.editing[4].texto; // diff
            estab.numero  = this.editing[5].texto;
            estab.complemento=this.editing[6].texto;
            estab.bairro  = this.editing[7].texto;
            estab.cidade  = this.editing[8].texto;
            estab.estado  = this.editing[9].texto;
            estab.telefones= this.editing[10].texto;
            estab.site    = this.editing[11].texto;
            estab.site2   = this.editing[12].texto;
            estab.email   = this.editing[13].texto;
            estab.videolink = this.editing[14].texto; // diff
            estab.subcat  = this.editing[15].texto;
            estab.ticket  = this.getTicketIndex();
            estab.traje   = this.getTrajeIDs();
            estab.categorias=this.getCatsIDs();
            estab.photos  = this.getPhotosNames(); // diff
            estab.usermail = this.user.email;

            estab.id       = this.new_estab.id;
            estab.ativo    = this.ativo;

            //User admin fica nao aprovado tambem
            //if (this.user.tipo > 0)
            //    estab.aprovado = true;
            //else
                estab.aprovado = false;

            return estab;
        },
        // Aprovado vs Em analise,
        setEstabAprovado(estab) {
            estab.aprovado = !estab.aprovado;
        },
        verificaCamposLogin () {
            this.msg_erros = []

            // if (!this.valid.termos) {
            //     var msg = this.getInterText(this.inter_ind.favor_preencha)
            //     console.log(msg)
            //     //alert(msg);
            //     this.msg_erros.push(msg);
            // }
        },
        verificaCamposEstab (i) {
            this.msg_erros = [ ];

            if (i == 0) {
                if (!this.user.sucess) {
                    var msg = 'Usuario nao identificado, faça o login.';
                    // alert(msg);
                    this.msg_erros.push(msg);
                }

                if (this.editing[0].texto.length < 2) {
                    var msg = 'Informe o nome';
                    console.log(msg);
                    //alert(msg);
                    this.valid.nome = false;
                    this.msg_erros.push(msg);
                }
                else
                    this.valid.nome = true;

                if (this.editing[1].texto.length < 2) {
                    var msg = 'Informe a descrição';
                    console.log(msg);
                    //alert(msg);
                    this.valid.descricao = false;
                    this.msg_erros.push(msg);
                }
                else
                    this.valid.descricao = true;

                if (this.editing[2].texto.length < 2) {
                    var msg = 'Informe o horário';
                    console.log(msg);
                    //alert(msg);
                    this.valid.horario = false;
                    this.msg_erros.push(msg);
                }
                else
                    this.valid.horario = true;

                if (this.quantCatsSelected == 0) {
                    var msg = 'Selecione pelo menos uma categoria';
                    console.log(msg);
                    this.valid.categorias = false;
                    this.msg_erros.push(msg);
                }
                else
                    this.valid.categorias = true;

                if (this.editing[4].texto.length < 2) {
                    var msg = 'Informe a rua';
                    console.log(msg);
                    //alert(msg);
                    this.valid.rua = false;
                    this.msg_erros.push(msg);
                }
                else
                    this.valid.rua = true;

                if (this.editing[7].texto.length < 2) {
                    var msg = 'Informe o bairro';
                    console.log(msg);
                    //alert(msg);
                    this.valid.bairro = false;
                    this.msg_erros.push(msg);
                }
                else
                    this.valid.bairro = true;

                if (this.editing[8].texto.length < 2) {
                    var msg = 'Informe a cidade';
                    console.log(msg);
                    //alert(msg);
                    this.valid.cidade = false;
                    this.msg_erros.push(msg);
                }
                else
                    this.valid.cidade = true;

                if (this.editing[9].texto.length < 2) {
                    var msg = 'Informe a estado';
                    console.log(msg);
                    //alert(msg);
                    this.valid.estado = false;
                    this.msg_erros.push(msg);
                }
                else
                    this.valid.estado = true;
            } else if (i == 1) {
                var i;
                for (i = 0; i < this.photos.length; i++) {
                    if (!this.photos[i].uploaded) {
                        var msg = 'Aguarde o término do envio das fotos.';
                        console.log(msg);
                        // alert(msg);
                        this.msg_erros.push(msg);
                        break;
                    }
                }

                if (this.photos.length == 0) {
                    var msg = 'Insira pelo menos uma foto';
                    console.log(msg);
                    // alert(msg);
                    this.msg_erros.push(msg);
                }
            }

            if (this.msg_erros.length == 0)
                return true;
            else
                return false;

        },
        sendAprovado(estab) {
            if (this.currentTab != 4)
                return;

            if (!confirm('Aprovar Estabelecimento?')) {
                return;
            }

            var vm = this;

            var data =
                {
                    userId: this.user.id,
                    estabId: estab.id,
                };

            var url = this.baseUrlApi + 'aproveEstab';

            axios.post(url, data)
                .then(function (response) {
                    vm.loading.form = false;
                    console.log("Response.data ", response.data);
                    console.log("Response.status " + response.status);
                    if (response.status == 200) {
                        console.log("Status::200::Tudo certo::response.data.id", response.data.id);

                        if (response.data.id > 0) {
                            vm.showAlertMsg('Estabelecimento aprovado com sucesso!');
                            estab.aprovado = true;
                        } else {
                            vm.showAlertMsg('Erro ao aprovar o estabelecimento.');
                        }
                    }
                    else if (response.status == 208) {
                        console.log("Status::208::Usuario não existente");
                        vm.showAlertMsg('Status::208::Usuario não existente');
                    }
                    else {
                        vm.showAlertMsg(response.status + ' Erro ao realizar a ação. Por favor tente novamente. status: ' + response.status);
                    }
                })
                .catch(function (error) {
                    vm.loading.form = false;
                    vm.showAlertMsg('Erro ao realizar a ação. Por favor tente novamente.');
                    console.log("ERROR::" + error);
                });
        },
        submitformEstab(add) {
            this.msg_erros = [];
    
            if (!add) {
                if (!confirm('Deseja remover o estabelecimento?')) {
                    return;
                }
            }
    
            if (!this.user.sucess) {
                var msg = 'Usuario nao identificado, faça o login.';
                this.msg_erros.push(msg);
            }
    
            var i;
            for (i = 0; i < this.photos.length; i++) {
                if (!this.photos[i].uploaded) {
                    var msg = 'Aguarde o término do envio das fotos.';
                    console.log(msg);
                    this.msg_erros.push(msg);
                    break;
                }
            }
    
            if (this.editing[0].texto.length < 2) {
                var msg = 'Informe o nome do estabelecimento';
                console.log(msg);
                this.msg_erros.push(msg);
            }
    
            if (this.editing[1].texto.length < 2) {
                var msg = 'Informe a descrição do estabelecimento';
                console.log(msg);
                this.msg_erros.push(msg);
            }
    
            if (this.photos.length == 0) {
                var msg = 'Insira pelo menos uma foto';
                console.log(msg);
                this.msg_erros.push(msg);
            }
    
            var vm = this;
    
            this.new_estab = this.generateEstab();
    
            // Salvar a descrição com quebras de linha convertidas para <br>
            this.new_estab.descricao_trans = this.editing[1].texto.replace(/\n/g, '<br>').replace(/ /g, '&nbsp;');
    
            if (this.new_estab.categorias.length == 0) {
                var msg = 'Selecione pelo menos uma categoria';
                console.log(msg);
                this.msg_erros.push(msg);
            }
    
            if (this.msg_erros.length > 0)
                return;
    
            console.log('new estab: ', this.new_estab);
    
            console.log('user mail: ' + this.user.email);
    
            this.loading.form = true;
    
            var url = '';
            if (add)
                url = this.baseUrlApi + 'newEstab';
            else
                url = this.baseUrlApi + 'rmEstab';
            console.log("Enviando post com o user");
            console.log(url);
    
            axios.post(url, this.new_estab)
                .then(function (response) {
                    vm.loading.form = false;
                    console.log("Response.data ", response.data);
                    console.log("Response.status " + response.status);
                    if (response.status == 200) {
                        console.log("Status::200::Tudo certo");
                        vm.currentTab = 1;
                        console.log('submitformEstab::currentTab: ', vm.currentTab);
                        if (vm.new_estab.id > 0) {
                            if (add)
                                vm.showAlertMsg('Estabelecimento Atualizado com Sucesso!');
                            else
                                vm.showAlertMsg('Estabelecimento removido com Sucesso!');
    
                            vm.atualizaEstabUpdated(vm.new_estab, add);
    
                        } else {
                            console.log('Estabelecimento Cadastrado com Sucesso!');
                            vm.showAlertMsg('Estabelecimento Cadastrado com Sucesso!');
                            var info = {
                                idEstabelecimento: response.data.id,
                                favType: 1, // 1 == OWNER
                                avaliacao: 0,
                                owner: true,
                            };
                            console.log('submitformEstab::Info: ', info);
                            console.log('vm.user.estabelecimentos ', vm.user.estabelecimentos);
    
                            if (vm.user.estabelecimentos == null) {
                                vm.user.estabelecimentos = [];
                            }
    
                            vm.user.estabelecimentos.push(info);
                            console.log('submitformEstab::vm.estabs_full: ', vm.estabs_full);
                            console.log('submitformEstab::vm.new_estab: ', vm.new_estab);
                            vm.new_estab.id = response.data.id;
                            vm.new_estab.tbFotos = vm.new_estab.photos;
                            for (let j = 0; j < vm.new_estab.tbFotos.length; j++) {
                                if (!vm.new_estab.tbFotos[j].file.includes('.jpg'))
                                    vm.new_estab.tbFotos[j].file = vm.new_estab.tbFotos[j].file + '.jpg';
                            }
                            vm.new_estab.descricao2  = vm.new_estab.descricao; // diff
                            vm.new_estab.rua_num     = vm.new_estab.rua; // diff
                            vm.new_estab.video_link  = vm.new_estab.videolink; // diff
                            vm.estabs_full.push(vm.new_estab);
                            console.log('submitformEstab::push realizado');
    
                            localStorage.setItem('user', JSON.stringify(vm.user));
                        }
    
                        vm.$nextTick(function () {
                            vm.sleep(1000).then(() => {
                                if (window.history.length > 2)
                                    vm.$router.back();
                                else {
                                    if (vm.isMobile())
                                        vm.goToPagina('mMinhaPagina');
                                    else
                                        vm.goToPagina('MinhaPagina');
                                }
                            });
                        });
                    }
                    else if (response.status == 208) {
                        console.log("Status::208::Usuario não existente");
                        vm.showAlertMsg('Status::208::Usuario não existente');
                    }
                    else {
                        vm.showAlertMsg(response.status + ' Erro ao realizar a ação. Por favor tente novamente. status: ' + response.status);
                    }
                })
                .catch(function (error) {
                    vm.loading.form = false;
                    vm.showAlertMsg('Erro ao realizar a ação. Por favor tente novamente.');
                    console.log("ERROR::" + error);
                });
    
            console.log("Enviado post :: FIM submit stab");
        },
        tryExcludeUser () {
            var vm = this;

            if (!this.checkPass(this.editing[3].texto))
            {
                this.showAlertMsg(this.getInterText(this.inter_ind.favor_senha));
                return;
            }

            if (!this.checkName(this.editing[0].texto) || !this.checkEmail(this.editing[1].texto) || !this.checkPass(this.editing[3].texto) || !this.checkPassEquals(this.editing[4].texto, this.editing[5].texto))
            {
                this.showAlertMsg('Corrija os campos por favor.');
                return;
            }

            this.showConfirmMsg(this.getInterText(this.inter_ind.tem_certeza_remover), function () {
                vm.new_user.deleted = true;
                vm.showConfirm = false

                vm.submitformUser(true)
            })
            // if (!confirm('Tem certeza que deseja remover a sua conta?')) {
            //     return
            // }
            //
            // this.new_user.deleted = true;
            //
            // this.submitformUser(true)
        },
        trySubmitformUser(editing) {
            if (!this.checkName(this.editing[0].texto) || !this.checkEmail(this.editing[1].texto) || !this.checkPass(this.editing[3].texto) || !this.checkPassEquals(this.editing[4].texto, this.editing[5].texto))
            {
                this.showAlertMsg('Corrija os campos por favor.');
                return;
            }

            this.new_user.deleted = false;

            this.submitformUser(editing);
        },
        submitformUserFaceGoogleApple() {
            if (this.loginGoogle != null) {
                this.new_user.id = 0;
                this.new_user.nome  = this.loginGoogle.getName();
                this.new_user.email = this.loginGoogle.getEmail();

                this.new_user.foto  = this.loginGoogle.getImageUrl();
                // this.new_user.foto  = encodeURIComponent(this.loginGoogle.getImageUrl());

                console.log('cadastrando user google: ', this.new_user);

                // exibe janela pedindo telefone.
                this.showGetPhone = true;
                this.userNaoCadastrado = false;
                this.showLogin = false;

                // this.submitformUserUser(false);
            }
            else if (this.loginFace != null) {
                this.new_user.id = 0;
                this.new_user.nome  = this.loginFace.name;
                this.new_user.email = this.loginFace.email;
                this.new_user.foto  = this.loginFace.picture.data.url;
                // this.new_user.foto  = encodeURIComponent(this.loginFace.picture.data.url);
                // this.new_user.foto  = 'http://graph.facebook.com/' + this.loginFace.id + '/picture?type=large';

                console.log('cadastrando user face: ', this.new_user);

                // exibe janela pedindo telefone.
                this.showGetPhone = true;

                // this.submitformUserUser(false);
            }
            else if (this.loginApple != null) {
                console.log('3::apple user email:', this.loginApple.email);
                console.log('3::apple user name:', (this.loginApple.name.firstName + this.loginApple.name.lastName));

                this.new_user.id = 0;
                this.new_user.nome  = this.loginApple.name.firstName + this.loginApple.name.lastName;
                this.new_user.email = this.loginApple.email;

                // this.new_user.foto  = this.loginApple.getImageUrl();
                // this.new_user.foto  = encodeURIComponent(this.loginGoogle.getImageUrl());

                console.log('cadastrando user google: ', this.new_user);

                // exibe janela pedindo telefone.
                this.showGetPhone = true;
                this.userNaoCadastrado = false;
                this.showLogin = false;
            }
        },
        getPhoneSair() {
            this.showGetPhone = false;
        },
        submitformUserUserPhone() {
            this.loading.phone = true
            this.new_user.fone = this.editing[2].texto;

            this.submitformUserUser(false, true);
        },
        submitformUser(isEditing) {
            if (isEditing == null || isEditing == undefined)
                isEditing = false;

            this.new_user.id = this.user.id;
            this.new_user.nome = this.editing[0].texto;
            this.new_user.email = this.editing[1].texto;
            this.new_user.fone = this.editing[2].texto;
            // nao alterou a foto
            if (this.photos[0] == undefined)
                this.new_user.foto = this.user.foto;
            else
                this.new_user.foto = this.photos[0].file + '.jpg';
            var MD5 = function(d){return M(V(Y(X(d),8*d.length)));return result.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_}

            if (this.editing[3].texto.length == 0)
                this.new_user.pass = '';
            else
                this.new_user.pass = MD5(this.editing[3].texto);
            if (isEditing && this.editing[4].texto.length > 5)
                this.new_user.newPass = MD5(this.editing[4].texto);
            this.new_user.sucess = false;

            this.submitformUserUser(isEditing);
        },
        submitformUserUser(isEditing, external) {
            var vm = this;
            var url = 'unknown';

            this.loading.form = true;
            this.valid.errorSubmit = false;

            if (isEditing)
                url = this.baseUrlApi + 'changeUser';
            else
                url = this.baseUrlApi + 'newUser';

            console.log("Enviando post com o new user");
            console.log(url);
            console.log("new_user: ", this.new_user);
            console.log(this.new_user);
            axios.post(url, this.new_user)
                .then(function (response) {
                    console.log("Response.data " + response.data);
                    console.log("Response.status " + response.status);
                    if (response.status == 200) {
                        console.log("Status::200::Tudo certo");
                        vm.new_user.pass = '';
                        vm.new_user.id = response.data.id;
                        // vm.new_user.foto = vm.new_user.email + '.jpg';

                        // persists data
                        localStorage.setItem('user', JSON.stringify(vm.new_user));
                        console.log('Persisitndo data ' + localStorage.user);
                        vm.user = vm.new_user;

                        // Adding
                        if (!isEditing) {
                            vm.new_user.idioma = 0;

                            // primeiro acesso do usuario
                            vm.new_user.firstTime = true;

                            if (external) {
                                vm.new_user.sucess = true;
                                vm.user.sucess = true;
                                vm.loading.phone = false;
                                vm.showGetPhone = false;
                            }

                            // vm.$nextTick(function () {
                            //     vm.sleep(3000).then(() => {
                            //         console.log('indo para pagina go')
                            //         vm.goToPagina('go');
                            //         //vm.$router.push({name: 'mHome', params: {user: vm.new_user } });
                            //     });
                            // });
                        }
                        // Editing
                        else {
                            vm.new_user.sucess = true;

                            // nao eh o primeiro acesso do usuario
                            vm.new_user.firstTime = false;

                            vm.showAlertMsg('Dados alterados com sucesso!');
                            console.log('indo para pagina back')
                            vm.$router.back();
                        }

                    }
                    else if (response.status == 208) { // 208 == ALREADY_REPORTED
                        console.log("Status::208::Usuario ja tava cadastrado");
                        // alert("Usuário já cadastrado, por favor faça o login.");
                        // vm.$nextTick(function () {
                        //     vm.goToPagina('go');
                        // });
                        // nao eh o primeiro acesso do usuario
                        vm.new_user.firstTime = false;
                    }
                    else if (response.status == 203) { // 203 == NON_AUTHORITATIVE_INFORMATION
                        console.log("Status::203::Senha Incorreta");
                        vm.showAlertMsg("Senha Atual Incorreta, por favor tente novamente.");
                    }

                    vm.loading.form = false;
                })
                .catch(function (error) {
                    vm.loading.form = false;

                    console.log("ERROR::", error);
                    console.log("ERROR.status::", error.status);
                    vm.showAlertMsg('Erro ao realizar o cadastro. Por favor tente novamente.');
                    vm.goToPagina('go');

                    // vm.$router.push({name: 'go', params: {}});
                });

            console.log("Enviado post :: FIM submit user");
        },
        submitformMsg() {
            var vm = this;

            var msg = {
                nome: this.editing[0].texto,
                email: this.editing[1].texto,
                telefone: this.editing[2].texto,
                cidade: this.editing[3].texto,
                estado: this.editing[4].texto,
                assunto: "Contato Site Advice",
                mensagem: this.editing[5].texto,
            };

            // msgStr = escape(msgStr);
            // msgStr = msgStr.EncodeXMLEscapeChars();
            // msgStr = encode(msgStr);

            var url = this.baseUrlApi + 'mensagem';

            console.log("Enviando post com a mensagem");
            console.log(url);
            console.log('msg: ', msg);
            axios.post(url, msg)
                .then(function (response) {
                    vm.loading.form = false;
                    console.log("Response.data " + response.data);
                    console.log("Response.status " + response.status);
                    if (response.status == 200) {
                        console.log("Status::200::Tudo certo");
                        vm.showAlertMsg('Mensagem enviada com sucesso!');

                        if (window.history.length > 2)
                            vm.$router.back();
                        else {
                            if (vm.isMobile())
                                vm.goToPagina('mMinhaPagina');
                            else
                                vm.goToPagina('mMinhaPagina');
                        }
                    }
                    else {
                        console.log("Status::Nao foi enviada a msg: " + response.status);
                        vm.showAlertMsg("Não foi possível enviar sua mensagem, tente novamente.");
                    }
                })
                .catch(function (error) {
                    console.log("Exeception:: " +  error);
                    vm.showAlertMsg("Não foi possível enviar sua mensagem, tente novamente.");
                });

            console.log("Enviado post :: FIM submit msg");
        },
        isiOS () {
            // console.log('navigator.platform: ', navigator.platform)
            // console.log('navigator.userAgent: ', navigator.userAgent)
            return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
        },
        isMobile() {
            console.log('screen.width: ' + screen.width);
            console.log('screen.height: ' + screen.height);
            console.log('screen.width.avail: ' + window.screen.availHeight);
            console.log('screen.height.avail: ' + window.screen.availWidth);

            var min = screen.width;
            //if (screen.height < min)
            //    min = screen.height;
            if( min <= 760 ) {
                return true;
            }
            else {
                return false;
            }
        },
        setShowLogin(state) {
            console.log('inside setShowLogin ', state);
            this.showLogin = state;

            if (state) {
                this.hideSideBar()

                // console.log('gapi.auth2: ', gapi.auth2);
                // if (gapi.auth2 == undefined) {
                //     // inicia google login
                //     this.externalLoginGoogle_startApp();
                // }


                // this.$nextTick(function () {
                //     setTimeout(function () {
                //
                //         console.log('Adicionnando evento de click do nome e e-mail.')
                //
                //         var idfocus = 'nameid';
                //         var el = document.getElementById(idfocus + '_b');
                //         el = document.getElementById(idfocus + '_bs');
                //         el.addEventListener('click', function(){
                //             console.log('entrei no bs, el: ', el)
                //             console.log('entrei no bs, idfocus: ', idfocus)
                //             el.style.visibility = 'hidden';
                //             var inputEl = document.getElementById(idfocus);
                //             console.log('entrei no bs')
                //             inputEl.style.visibility = 'visible'; // unhide the input
                //             inputEl.focus(); // focus on it so keyboard pops
                //         });
                //         idfocus = 'emailid';
                //         console.log('Adicionnando evento de click do nome e e-mail.')
                //         el = document.getElementById(idfocus + '_bs');
                //         el.addEventListener('click', function(){
                //             console.log('entrei no bs, el: ', el)
                //             console.log('entrei no bs, idfocus: ', idfocus)
                //             el.style.visibility = 'hidden';
                //             var inputEl = document.getElementById(idfocus);
                //             inputEl.style.visibility = 'visible'; // unhide the input
                //             inputEl.focus(); // focus on it so keyboard pops
                //         });
                //
                //     }, 2000);
                // });
            } else {
                this.loading.google = false;
            }

            //this.$set('showLogin', state);
            this.$forceUpdate();
        },
        setShowResponder(index) {
            if (this.showResponder == index) {
                this.showResponder = -1; // remmove exibicao
            } else {
                this.showResponder = index;
                this.showResponder2 = -1; // remmove exibicao
                this.commentRespTx = '';
                this.commentTx = '';
            }
        },
        setShowResponder2(index) {
            if (this.showResponder2 == index) {
                this.showResponder2 = -1; // remmove exibicao
            } else {
                this.showResponder2 = index;
                this.showResponder = -1; // remmove exibicao
                this.commentRespTx = '';
                this.commentTx = '';
            }
        },
        setShowRespComments(index) {
            this.commentRespTx = '';
            this.commentTx = '';
            this.showResponder = -1;
            this.showResponder2 = -1;
            if (this.showRespComments == index) {
                this.showRespComments = -1; // remmove exibicao
            } else {
                this.showRespComments = index;
            }

        },
        checkName(name) {
            //console.log("Check name" + name.length + '  ' + name);
            this.valid.nome = name.length >= 3;
            return this.valid.nome;
        },
        checkEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            this.valid.email = re.test(String(email).toLowerCase().trim());
            return this.valid.email;
        },
        checkTelefone(tel) {
            var teltrim = tel.replace(/\D/g, "");
            // console.log("Check telefone " + tel.length + '  ' + tel);
            // console.log("Check telefonetrim " + teltrim.length + '  ' + teltrim);
            // 12345678901
            // 83988031862
            this.valid.tel = teltrim.length >= 10 && teltrim.length <= 11;
            return this.valid.tel;
        },
        checkPass(pass) {
            //console.log("Check pass" + pass.length + '  ' + pass);

            return pass.length >= 8;
        },
        checkPass2(pass) {
            this.valid.pass2 = this.editing[3].texto==pass;

            return this.valid.pass2;
        },
        checkPassEquals(pass1, pass2) {
            return pass1 == pass2;
        },
        clickInput(i, status) {
            var j=0;
            //console.log("clickInput " + i);
            if (status == true) {
                for (j = 0; j < this.editing.length; j++) {
                    if (j == i)
                        this.editing[j].status = true;
                    else {
                        if (this.editing[j].texto.length==0)
                            this.editing[j].status = false;
                    }
                }
            }
            else
                this.editing[i].status = false;

            if (status == true) {
                var idfocus = '';
                switch (i) {
                    case 0:
                        idfocus = 'nameid';
                        break;
                    case 1:
                        idfocus = 'emailid';
                        break;
                    case 2:
                        idfocus = 'telefoneid';
                        break;
                    case 3:
                        idfocus = 'pass1id';
                        break;
                    case 4:
                        idfocus = 'pass2id';
                        break;
                }

                // $('#' + idfocus).trigger('click');

                $('#' + idfocus).focus();
                document.getElementById(idfocus).focus();
                this.$nextTick(function () {
                  // console.log('vou focar');
                     $('#' + idfocus).focus();
                    document.getElementById(idfocus).focus();
                });
            }
        },
        clickTraje(i) {
            this.traje[i].status = !this.traje[i].status;
        },
        clickTicket(i) {
            var j = 0;
            for (j = 0 ; j < this.ticket.length ; j++)
                if (i != j)
                    this.ticket[j].status = false;

            this.ticket[i].status = true;
        },
        setTicketIndex(estab) {
            var j = estab.investimento;
            if (j === undefined)
                j = estab.ticket
            console.log('Investimento: ', j);

            if (j > 7)
                j = 7;

            // se j for -1 não seta.
            if (j >=0)
                this.ticket[j].status = true;
        },
        getTicketIndex() {
            var j = 0;
            for (j = 0 ; j < this.ticket.length ; j++)
                if (this.ticket[j].status == true)
                    return j;

            return -1;
        },
        getSubCats(idCat, indexSubCat, idioma) {
            let i = 0;

            if (idioma === undefined) {
                idioma = 0;
            }

            // console.log('indexSubCat== ' + indexSubCat)
            // console.log('idCat, ', idCat)
            // console.log('idioma, ', idioma)

            if (indexSubCat < 0) {
                return this.getInterCatName(this.cat)
            }

            for (i = 0 ; i < this.cats_sub.length ; i++) {
                if (idCat == this.cats_sub[i].fatherId) {
                    // console.log('retornando: ', this.cats_sub[i].subs[indexSubCat]);
                    switch (idioma) {
                        case 1:
                            return this.cats_sub[i].subs_en[indexSubCat];
                        case 2:
                            return this.cats_sub[i].subs_es[indexSubCat];
                        default:
                            return this.cats_sub[i].subs[indexSubCat];
                    }
                }
            }

            return '';
        },
        hasSubCatsID(id) {
            let i = 0;

            for (i = 0 ; i < this.cats_sub.length ; i++) {
                    if (id == this.cats_sub[i].fatherId)
                        return true;
            }

            return false;
        },
        hasSubCatsTicket(estab) {
            let i, j;

            var idsTicket = [56, // restaurantes
                        57, // Bares
                        58, // Lanches
                        74, // Cafeterias
                        75 // Gelatos
            ]; // Cafeteria

            if (estab.tbCategoriaEstabelecimentos != null)
            {
                for (i = 0; i < estab.tbCategoriaEstabelecimentos.length; i++) {
                    for (j = 0; j < idsTicket.length; j++) {
                        if (estab.tbCategoriaEstabelecimentos[i].id == idsTicket[j]) {
                            return true;
                        }
                    }
                }
            }

            return false;
        },
        hasSubCats() {
            let j = 0;
            let i = 0;

            for (i = 0 ; i < this.cats_sub.length ; i++) {
                for (j = 0; j < this.cats_full.length; j++) {
                    if (this.cats_full[j].deleted == true && this.cats_full[j].id == this.cats_sub[i].fatherId)
                        return true;
                }
            }

            return false;
        },
        hasCatsSiteVenda() {
            let j = 0;
            let i = 0;

            var catsSiteVenda = [63, // Hospdeagem
                                 77]; // Passeios

            for (i = 0 ; i < catsSiteVenda.length ; i++) {
                for (j = 0; j < this.cats_full.length; j++) {
                    if (this.cats_full[j].deleted == true && this.cats_full[j].id == catsSiteVenda[i])
                        return true;
                }
            }

            return false;
        },
        setCatsIDs(estab) {
            var j;
            var i;
            let estabCat = []
            if (estab.tbCategoriaEstabelecimentos !== undefined) {
                estabCat = estab.tbCategoriaEstabelecimentos
            } else {
                for (i = 0; i < estab.categorias.length; i++) {
                    let cat = {
                        id: estab.categorias[i],
                    };
                    estabCat.push(cat)
                }
            }

            for (j = 0 ; j < this.cats_full.length; j++) {
                this.cats_full[j].deleted = false;
                for (i = 0; i < estabCat.length; i++) {
                    if (estabCat[i].id === this.cats_full[j].id) {
                        this.cats_full[j].deleted = true;
                        break;
                    }
                }
            }
            this.showCats = true;
        },
        getCatsIDs() {
            var vec = [];
            var j = 0;
            for (j = 0 ; j < this.cats_full.length ; j++)
                if (this.cats_full[j].deleted == true)
                    vec.push(this.cats_full[j].id);

            return vec;
        },
        getCatsFULL() {
            var vec = [];
            var j = 0;
            for (j = 0 ; j < this.cats_full.length ; j++)
                if (this.cats_full[j].deleted == true)
                    vec.push(this.cats_full[j]);

            return vec;
        },
        setTrajeIDs(estab) {
            var j;
            var i;
            for (j = 0 ; j < this.traje.length ; j++) {
                for (i = 0 ; i < estab.tbTrajeEstabelecimentos.length ; i++) {
                    if (this.traje[j].id == estab.tbTrajeEstabelecimentos[i].id) {
                        this.traje[j].status = true;
                    }
                }
            }
        },
        getTrajeIDs() {
            var vec = [];
            var j = 0;
            for (j = 0 ; j < this.traje.length ; j++)
                if (this.traje[j].status == true)
                    vec.push(this.traje[j].id);

            return vec;
        },
        setPhotosNames(estab) {
            this.photos = [];
            var j;
            for (j = 0 ; j < estab.tbFotos.length ; j++) {
                var photo = {
                    data: null,
                    file: estab.tbFotos[j].file,
                    loading: false,
                    uploaded: true,
                    id: estab.tbFotos[j].id,
                    destaque: false
                };
                this.photos.push(photo);
            }
            // this.photosIndex = estab.tbFotos.length;
        },
        getPhotosNames() {
            var vec = [];
            var j = 0;
            for (j = 0 ; j < this.photos.length ; j++)
                if (this.photos[j].uploaded == true) {
                    console.log(this.photos[j].id + '::adicioando foto: ' + this.photos[j].file);
                    // Esse photo nao eh para ter o data, o loading, nem o uploaded. Pois tem que ser igual ao advice.model.Foto
                    var photo = {
                        id: this.photos[j].id,
                        file: this.photos[j].file,
                        ordem: j
                    };
                    vec.push(photo);
                }

            return vec;
        },
        clickInput2_2(i) {
            var j=0;
            //console.log("clickInput " + i);
            this.editing[i].status = !this.editing[i].status;
            if (this.editing[i].status == true) {
                this.showCats = false;
                for (j = 0; j < this.editing.length; j++) {
                    if (j != i) {
                        // console.log('this.editing[j].texto.length ' + this.editing[j].texto.length);
                        if (this.editing[j].texto.length == 0) {
                            this.editing[j].status = false;
                            // console.log('setando para false ' + j);
                        }
                    }
                }
            }

            if (this.editing[i].status == true) {
                var idfocus = this.getId(i);

                this.$nextTick(function () {
                    $(idfocus).focus();
                });
            }
        },
        getId(i) {
            switch (i) {
                case 0:
                    return '#zeroID';
                case 1:
                    return '#umID';
                case 2:
                    return '#doisID';
                case 3:
                    return '#tresID';
                case 4:
                    return '#quatroID';
                case 5:
                    return '#cincoID';
                case 6:
                    return '#seisID';
                case 7:
                    return '#seteID';
                case 8:
                    return '#oitoID';
                case 9:
                    return '#noveID';
                case 10:
                    return '#dezID';
                case 11:
                    return '#onzeID';
                case 12:
                    return '#dozeID';
                case 13:
                    return '#trezeID';
                case 14:
                    return '#catorzeID';
                case 15:
                    return '#quinzeID';
                default:
                    return '';
            }
        },
        clickInput3(editing, i, status) {
            var j=0;
            //console.log("clickInput " + i);
            if (status == true) {
                this.showCats = false;
                for (j = 0; j < editing.length; j++) {
                    if (j == i)
                        editing[j].status = true;
                    else {
                        if (editing[j].texto.length==0)
                            editing[j].status = false;
                    }
                }
            }
            else
                editing[i].status = false;

            if (status == true) {
                var idfocus = '';
                switch (i) {
                    case 0:
                        idfocus = '#nameid';
                        break;
                    case 1:
                        idfocus = '#emailid';
                        break;
                    case 2:
                        idfocus = '#pass1id';
                        break;
                    case 3:
                        idfocus = '#pass2id';
                        break;
                }

                this.$nextTick(function () {
                    $(idfocus).focus();
                });
            }
        },
        showPopEscritorio() {
            this.showPopupEscritorio = !this.showPopupEscritorio;
            console.log('setando: showPopEscritorio() para ', this.showPopupEscritorio)
        },
        showSearch() {
            let search = document.getElementById("search_s_id")
            var vm = this
            console.log('search: ', search)

            // se for mostrar o search deixa a tela sem ajustar o viewport dinamicamente.
            if (!this.showingSearch) {
                this.configureViewPort(this.showingSearch);

                this.showingSearch = true;
            } else {
                // if (search !== null) {
                //     search.style.animation = "run 0.3s linear 0s 1 normal;";
                // }
                if (search !== null) {
                    console.log('Vou reverter a animacao')
                    // search.style.marginLeft = "50vw"
                    // search.style.animation = "run_back 0.3s linear 0s 1 normal;";
                    search.className = "animOutside";

                    setTimeout(function () {
                        vm.showingSearch = false;
                    }, 500);

                } else {
                    this.showingSearch = false;
                }
            }

            // this.showingSearch = !this.showingSearch;
            //console.log('show search: ' + this.showingSearch);
            //console.log('show search:document1 ' + this.$refs);

            if (vm.showingSearch) {
                this.$nextTick(function () {
                    vm.$refs.search_i.focus();
                });
            }
        },
        clearCategorias() {
            this.atualizaEstabs(0, true);
            this.show10Mais = false;
        },
        logout() {
            this.user.sucess = false;
            this.user.email = '';
            this.user.foto = '';
            this.user.tipo = 0;
            this.cookies_geral.showCookies = true;
            // this.user.showMsg1 = true;
            // this.user.showMsg2 = true;
            // this.user.showMsg3 = true;
            localStorage.setItem('user', JSON.stringify(this.user));
            this.showPopupEscritorio = false;
            // this.$router.push({name: 'go' });
            this.goToPagina('go');
        },
        decodeURIComponentSafe(uri, mod) {
            var out = new String(),
                arr,
                i = 0,
                l,
                x;
            typeof mod === "undefined" ? mod = 0 : 0;
            console.log('decodeURIComponentSafe::uri ', uri);
            arr = uri.split(/(%(?:d0|d1)%.{2})/);
            for (l = arr.length; i < l; i++) {
                try {
                    x = decodeURIComponent(arr[i]);
                } catch (e) {
                    x = mod ? arr[i].replace(/%(?!\d+)/g, '%25') : arr[i];
                }
                out += x;
            }
            return out;
        },
        Utf8ArrayToStr(array) {
            var out, i, len, c;
            var char2, char3;

            out = "";
            len = array.length;
            i = 0;
            while(i < len) {
                c = array[i++];
                switch(c >> 4)
                {
                    case 0: case 1: case 2: case 3: case 4: case 5: case 6: case 7:
                    // 0xxxxxxx
                    out += String.fromCharCode(c);
                    break;
                    case 12: case 13:
                    // 110x xxxx   10xx xxxx
                    char2 = array[i++];
                    out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
                    break;
                    case 14:
                        // 1110 xxxx  10xx xxxx  10xx xxxx
                        char2 = array[i++];
                        char3 = array[i++];
                        out += String.fromCharCode(((c & 0x0F) << 12) |
                            ((char2 & 0x3F) << 6) |
                            ((char3 & 0x3F) << 0));
                        break;
                }
            }

            return out;
        },
        utf8ArrayToStr2(array) {
            var out, i, len, c;
            var char2, char3;

            out = "";
            len = array.length;
            i = 0;

            // XXX: Invalid bytes are ignored
            while(i < len) {
                c = array[i++];
                if (c >> 7 == 0) {
                    // 0xxx xxxx
                    out += String.fromCharCode(c);
                    continue;
                }

                // Invalid starting byte
                if (c >> 6 == 0x02) {
                    continue;
                }

                // #### MULTIBYTE ####
                // How many bytes left for thus character?
                var extraLength = null;
                if (c >> 5 == 0x06) {
                    extraLength = 1;
                } else if (c >> 4 == 0x0e) {
                    extraLength = 2;
                } else if (c >> 3 == 0x1e) {
                    extraLength = 3;
                } else if (c >> 2 == 0x3e) {
                    extraLength = 4;
                } else if (c >> 1 == 0x7e) {
                    extraLength = 5;
                } else {
                    continue;
                }

                // Do we have enough bytes in our data?
                if (i+extraLength > len) {
                    var leftovers = array.slice(i-1);

                    // If there is an invalid byte in the leftovers we might want to
                    // continue from there.
                    for (; i < len; i++) if (array[i] >> 6 != 0x02) break;
                    if (i != len) continue;

                    // All leftover bytes are valid.
                    return {result: out, leftovers: leftovers};
                }
                // Remove the UTF-8 prefix from the char (res)
                var mask = (1 << (8 - extraLength - 1)) - 1,
                    res = c & mask, nextChar, count;

                for (count = 0; count < extraLength; count++) {
                    nextChar = array[i++];

                    // Is the char valid multibyte part?
                    if (nextChar >> 6 != 0x02) {break;};
                    res = (res << 6) | (nextChar & 0x3f);
                }

                if (count != extraLength) {
                    i--;
                    continue;
                }

                if (res <= 0xffff) {
                    out += String.fromCharCode(res);
                    continue;
                }

                res -= 0x10000;
                var high = ((res >> 10) & 0x3ff) + 0xd800,
                    low = (res & 0x3ff) + 0xdc00;
                out += String.fromCharCode(high, low);
            }

            return {result: out, leftovers: []};
        },
        Utf8ArrayToStr3(array) {
            var out, i, len, c;
            var char2, char3, char4;

            out = "";
            len = array.length;
            i = 0;
            while (i < len) {
                c = array[i++];
                switch (c >> 4) {
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                        // 0xxxxxxx
                        out += String.fromCharCode(c);
                        break;
                    case 12:
                    case 13:
                        // 110x xxxx   10xx xxxx
                        char2 = array[i++];
                        out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
                        break;
                    case 14:
                        // 1110 xxxx  10xx xxxx  10xx xxxx
                        char2 = array[i++];
                        char3 = array[i++];
                        out += String.fromCharCode(((c & 0x0F) << 12) |
                            ((char2 & 0x3F) << 6) |
                            ((char3 & 0x3F) << 0));
                        break;
                    case 15:
                        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
                        char2 = array[i++];
                        char3 = array[i++];
                        char4 = array[i++];
                        out += String.fromCodePoint(((c & 0x07) << 18) | ((char2 & 0x3F) << 12) | ((char3 & 0x3F) << 6) | (char4 & 0x3F));

                        break;
                }

                return out;
            }

        },
        utf8_from_str(s) {
            for(var i=0, enc = encodeURIComponent(s), a = []; i < enc.length;) {
                if(enc[i] === '%') {
                    a.push(parseInt(enc.substr(i+1, 2), 16))
                    i += 3
                } else {
                    a.push(enc.charCodeAt(i++))
                }
            }
            return a
        },
        utf8_to_str(a) {
            for(var i=0, s=''; i<a.length; i++) {
                var h = a[i].toString(16)
                if(h.length < 2) h = '0' + h
                s += '%' + h
            }
            return decodeURIComponent(s)
        },
        tryLogin() {
            this.verificaCamposLogin()
            if (this.msg_erros.length > 0) {
                return
            }

            this.tryLogin2(this.editing[1].texto, this.editing[0].texto);
        },
        validadeEmail (idUser, verificationCode) {
            var url = this.baseUrlApi + 'validate';
            var vm = this;
            var verification = {
                id: idUser,
                verificationCode: verificationCode
            }
            this.user.id = idUser;
            this.loading.user = true;
            console.log("Enviando post do validation " + verification);
            console.log('validadeEmail::url: ', url);
            console.log('validadeEmail::ver: ', verification);
            axios.post(url, verification)
                .then(function (response) {
                    vm.loading.user = false;
                    console.log("Response.data " + response.data);
                    console.log("Response.status " + response.status);
                    if (response.status == 200) { // OK
                        console.log("Status::200::Usuario verificado com sucesso.");
                        console.log('usuario recebido: ');
                        console.log(response.data);

                        vm.user = response.data;
                        vm.user.nome = vm.utf8_to_str(vm.utf8_from_str(vm.user.nome));
                        vm.user.idioma = 0;
                        vm.user.sucess = true; // logou.

                        // persists data
                        localStorage.setItem('user', JSON.stringify(vm.user));
                        console.log('Persisitndo data ' + localStorage.user);
                    } else if (response.status == 307) { // TEMPORARY_REDIRECT
                        vm.user.sucess = false;
                        console.log("Status::307::usuário nao validou email");
                        console.log("Status::307::" + response.data.msg);
                        vm.showAlertMsg(response.data.msg);
                    } else if (response.status == 208) { // 200 E OITO. ALREADY_REPORTED
                        vm.user.sucess = false;
                        vm.senhaErrada = true;
                        console.log("Status::208::Usuario ou senha errados");
                    } else {
                        console.log("Entrei no else");
                    }
                })
                .catch(function (error) {
                    vm.loading.user = false;
                    vm.showAlertMsg('Erro ao realizar o login. Por favor tente novamente.');
                    console.log("ERROR::" + error);
                });

            console.log("Enviado post :: FIM validate email");
        },
        // external eh para quando tem um login externo, tipo facebook ou google
        tryLogin2(user, senha, external) {
            var url = this.baseUrlApi + 'login';
            var vm = this;
            var MD5 = function(d){return M(V(Y(X(d),8*d.length)));return result.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_}
            this.user.id = 0;
            this.user.email = user.trim();
            if (external == undefined) {
                this.user.pass = MD5(senha);
            } else {// ser tiver um login external, entao manda a senha igual ao usuario
                this.user.pass = this.changeUser(senha);
            }

            this.senhaErrada = false;
            this.loading.user = true;
            this.userNaoCadastrado = false;
            console.log("Enviando post do login " + user);
            console.log(url);
            console.log(this.user);
            axios.post(url, this.user)
                .then(function (response) {
                    vm.loading.form = false;
                    vm.loading.user = false;
                    console.log("tryLogin2::Response.data ", response.data);
                    console.log("tryLogin2::Response.status " + response.status);
                    if (response.status == 200) { // OK
                        console.log("tryLogin2::Status::200::Usuario logado com sucesso. certo");
                        // response.setCharacterEncoding("UTF-8");
                        //response.setCharacterEncoding("ISO-8859-1");

                        console.log('usuario recebido: ');
                        console.log(response.data);

                        //vm.user = JSON.parse(response.data.toString('latin1'));
                        var tmpUser = vm.user;
                        vm.user = response.data;
                        if (tmpUser.showMsg1 !== undefined) {
                            vm.user.showMsg1 = tmpUser.showMsg1;
                            vm.user.showMsg2 = tmpUser.showMsg2;
                            vm.user.showMsg3 = tmpUser.showMsg3;
                        }
                        else {
                            vm.user.showMsg1 = true;
                            vm.user.showMsg2 = true;
                            vm.user.showMsg3 = true;
                        }
                        //console.log('data latin ' + response.data.toString('latin1'));
                        //vm.user.nome = vm.user.nome.toString('ISO-8859-1');
                        //vm.user.nome = vm.decodeURIComponentSafe(vm.user.nome, 1);
                        //console.log('teste 9: ' + vm.utf8_to_str(vm.user.nome));
                        //console.log('teste10: ' + vm.utf8_to_str(vm.user.nome.split('')));

                        vm.user.nome = vm.utf8_to_str(vm.utf8_from_str(vm.user.nome));
                        vm.user.idioma = 0;


                        //vm.user.nome = vm.Utf8ArrayToStr(vm.user.nome.split(''));
                        // try {
                        //     vm.user.nome = decodeURIComponent(escape(vm.user.nome));
                        // } catch (e) {
                        //     //vm.user.nome = unescape(vm.user.nome);
                        // }
                        vm.user.sucess = true;
                        vm.setShowLogin(false);

                        vm.showAlertMsg('Bem vindo ' + vm.user.nome);

                        // persists data
                        localStorage.setItem('user', JSON.stringify(vm.user));
                        console.log('Persisitndo data ' + localStorage.user);
                    } else if (response.status ==206) { // PARTIAL_CONTENT
                        vm.user.sucess = false;

                        console.log("Status::206::usuário nao validou email");
                        console.log("Status::206::" + response.data.msg);
                        // alert(response.data.msg);

                        vm.showAlertMsg(vm.getInterText(vm.inter_ind.favor_verifique));
                    } else if (response.status == 208) { // 200 E OITO. ALREADY_REPORTED
                        vm.user.sucess = false;

                        if (external) {
                            // Usario tenta logar pelo google e ainda nao ta cadastrado
                            vm.userNaoCadastrado = true;
                            console.log("Status::208::Ainda nao cadastrado");
                            // faz o cadastro
                            vm.submitformUserFaceGoogleApple();
                        } else {
                            vm.senhaErrada = true;
                            console.log("Status::208::Usuario ou senha errados");
                        }
                    } else {
                        console.log('error no login: ');
                        console.log(response.data);
                    }
                })
                .catch(function (error) {
                    vm.loading.form = false;
                    vm.loading.user = false;
                    // alert('Erro ao realizar o login. Por favor tente novamente.');
                    vm.showAlertMsg('Erro ao realizar o login. Por favor tente novamente.');
                    console.log("trylogin::ERROR:: " + error);
                });

            console.log("Enviado post :: FIM trylogin2");
        },
        rmCommentary(idComment) {
            if (!this.user.sucess) {
                this.showAlertMsg(this.getInterText(this.inter_ind.favor_login));
                // alert(this.getInterText(this.inter_ind.favor_login));
                return;
            }

            if (!confirm('Deseja remover o comentário?')) {
                return;
            }

            var vm = this;
            var url = this.baseUrlApi + 'rmCommentary';
            vm.loading.commentaries = true;

            var commentary = {
                id: idComment,
                idEstabelecimento: 0,
                idUsuario: this.user.id,
                idRespComentario: 0,
                type: 0,
                texto: 0,
            };

            console.log(url);
            console.log('commentary: ', commentary);
            axios.post(url, commentary)
                .then(function (response) {
                    vm.loading.commentaries = false;

                    console.log("Response.data " + response.data);
                    console.log("Response.status " + response.status);
                    if (response.status == 200) {
                        console.log("Status::200::Comentarios adicionados com sucesso.");
                        console.log('comentários recebidos no add: ');
                        console.log(response.data);
                        vm.commentTx = '';
                        vm.commentRespTx = '';

                        var i = 0;
                        for (i = 0; i< vm.commentaries.length; i++) {
                            if (vm.commentaries[i].id == idComment)
                                vm.commentaries.splice(i, 1);
                            else {
                                var j = 0;
                                for (j = 0; j< vm.commentaries[i].resps.length; j++) {
                                    if (vm.commentaries[i].resps[j].id == idComment) {
                                        vm.commentaries[i].resps.splice(j, 1);
                                    }
                                }
                            }
                        }
                    }
                    else {
                        console.log('Erro ao buscar os comentarios. Status: ' + response.status);
                    }
                })
                .catch(function (error) {
                    vm.loading.commentaries = false;
                    console.log('Erro ao buscar os comentarios. Exception: ' + error);
                });
        },
        addCommentary(idRespComent, indexFather, idEstab = -1) {
            if (!this.user.sucess) {
                this.showAlertMsg(this.getInterText(this.inter_ind.favor_login))
                // alert(this.getInterText(this.inter_ind.favor_login));
                return;
            }

            if (this.commentTx.length < 5 && idRespComent == 0) {
                this.showAlertMsg(this.getInterText(this.inter_ind.comentario_caracteres));
                // alert(this.getInterText(this.inter_ind.comentario_caracteres));
                return;
            }

            if (this.commentRespTx.length < 5 && idRespComent > 0) {
                this.showAlertMsg(this.getInterText(this.inter_ind.comentario_caracteres));
                // alert(this.getInterText(this.inter_ind.comentario_caracteres));
                return;
            }

            var vm = this;
            var url = this.baseUrlApi + 'addCommmentary';
            vm.loading.commentaries = true;

            var textComment = idRespComent == 0 ? this.commentTx : this.commentRespTx;

            var idEstabOk = idEstab > 0 ? idEstab : this.idEstab;

            var commentary = {
                id: 0,
                idEstabelecimento: idEstabOk,
                idUsuario: this.user.id,
                idRespComentario: idRespComent,
                type: 1,
                texto: textComment,
            };

            console.log(url);
            console.log('commentary: ', commentary);
            axios.post(url, commentary)
                .then(function (response) {
                    vm.loading.commentaries = false;

                    console.log("addCommentary::Response.data ", response.data);
                    console.log("addCommentary::Response.status ", response.status);
                    if (response.status == 200) {
                        console.log("addCommentary::Status::200::Comentarios adicionados com sucesso.");
                        console.log('comentários recebidos no add: ');
                        console.log(response.data);
                        vm.commentTx = '';
                        vm.commentRespTx = '';
                        console.log('idRespComent: ' + idRespComent);
                        let responseComment = response.data
                        responseComment.tx_trans = responseComment.texto;
                        if (idRespComent == 0) {
                            vm.commentaries.unshift(responseComment);
                        } else {
                            console.log('indexFather: ' + indexFather);
                            vm.setShowRespComments(indexFather);
                            vm.setShowResponder(-1);
                            vm.commentaries[indexFather].resps.unshift(responseComment);
                        }
                    }
                    else {
                        console.log('Erro ao buscar os comentarios. Status: ' + response.status);
                    }
                })
                .catch(function (error) {
                    vm.loading.commentaries = false;
                    console.log('Erro ao buscar os comentarios. Exception: ' + error);
                });
        },
        translateDesc(targetLang, sourceText) {
            var sourceLang = 'pt';
            var vm = this;

            if (targetLang == 'pt') {
                this.estab.descricao_trans = this.estab.descricao2;
                console.log('descricao_trans: ', this.estab.descricao_trans)
                console.log('descricao_trans: ', this.estab.descricao_trans)
                console.log('descricao_trans: ', this.estab.descricao_trans)
                console.log('descricao_trans: ', this.estab.descricao_trans)
                console.log('descricao_trans: ', this.estab.descricao_trans)
                console.log('descricao_trans: ', this.estab.descricao_trans)
                return;
            }

            // var urlconverter = 'https://jsonp.afeld.me/?url='
            var urlconverter = 'https://server.domm.com.br:8445/JoalheriaServer/restapi/search/proxyGet?encUrl='

            /* Option 2 */
            var urlsite = "https://translate.googleapis.com/translate_a/single?client=gtx&sl="
                + sourceLang + "&tl=" + targetLang + "&dt=t&q=" + encodeURIComponent(sourceText);

            var url = urlconverter + encodeURIComponent(urlsite);

            // console.log('sourceText: ', sourceText);
            // console.log('encodeURI(sourceText): ', encodeURI(sourceText));
            // console.log('encodeURIComponent(urlsite): ', encodeURIComponent(urlsite));
            // console.log('url: ', url);
            // console.log('urlsite: ', urlsite);

            this.loading.desc = true

            axios.get(url, {
                headers: {
                    // 'User-Agent': 'axios/'+(this.userAgent++),
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            })
                .then(function (response) {
                    // console.log("translateDesc.status " + response.status);
                    if (response.status == 200) {
                        var result = response.data;
                        var r_v = result[0];
                        // console.log('r_v.length', r_v.length);
                        var translatedText = '';
                        for (let i = 0; i < r_v.length; i++) {
                            // console.log(r_v[i][0]);
                            translatedText += r_v[i][0];
                        }
                        // var translatedText = result[0][0][0];

                        vm.estab.descricao_trans = translatedText;
                        vm.renderDescription = false;
                        // https://michaelnthiessen.com/force-re-render/
                        vm.$nextTick(function () {
                            vm.renderDescription = true;
                        });

                        vm.loading.desc = false

                        console.log('translatedDesc: ', translatedText);
                        // console.log('vm.estab.descricao_trans: ', vm.estab.descricao_trans);
                    }
                })
                .catch(function(error) {
                    vm.loading.desc = false
                    console.log('Error Catch' + error);
                });
        },
        translateCommentaries(lang) {
            if (lang == 'pt') {
                for (let i = 0 ; i < this.commentaries.length; i++) {
                    this.commentaries[i].tx_trans = this.commentaries[i].texto;
                    for (let j = 0 ; j < this.commentaries[i].resps.length; j++) {
                        this.commentaries[i].resps[j].tx_trans = this.commentaries[i].resps[j].texto;
                    }
                }
                return;
            }

            // Chama a API de traducao, que demora mais para dar o resultado.
            for (let i = 0 ; i < this.commentaries.length; i++) {
                this.translateComment(lang, this.commentaries[i].texto, i);
                for (let j = 0 ; j < this.commentaries[i].resps.length; j++) {
                    this.translateComment(lang, this.commentaries[i].resps[j].texto, i, j);
                }
            }
        },
        translateComment(targetLang, sourceText, i, j) {
            var sourceLang = 'pt';
            var vm = this;

            // var urlconverter = 'https://jsonp.afeld.me/?url='
            var urlconverter = 'https://server.domm.com.br:8445/JoalheriaServer/restapi/search/proxyGet?encUrl='
            /* Option 2 */
            var urlsite = "https://translate.googleapis.com/translate_a/single?client=gtx&sl="
                + sourceLang + "&tl=" + targetLang + "&dt=t&q=" + encodeURIComponent(sourceText);
            var url = urlconverter + encodeURIComponent(urlsite);

            axios.get(url, {
                headers: {
                    // 'User-Agent': 'axios/'+(this.userAgent++)
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            })
                .then(function (response) {
                    console.log("translateComent.status " + response.status);
                    if (response.status == 200) {
                        var result = response.data;
                        var r_v = result[0];
                        // console.log('r_v.length', r_v.length);
                        var translatedText = '';
                        for (let i = 0; i < r_v.length; i++) {
                            // console.log(r_v[i][0]);
                            translatedText += r_v[i][0];
                        }
                        // var translatedText = result[0][0][0];

                        console.log('translatedComment: ', translatedText, i, j);

                        if (j == undefined)
                            vm.commentaries[i].tx_trans = translatedText;
                        else
                            vm.commentaries[i].resps[j].tx_trans = translatedText;

                        vm.renderCommentaries = false;
                        // https://michaelnthiessen.com/force-re-render/
                        vm.$nextTick(function () {
                            vm.renderCommentaries = true;
                        });
                    }
                });
        },
        getCommentaries(idUser, idEstab) {
            console.log('Entrei no getCommentaries()', idUser, idEstab);
            var vm = this;
            var url = this.baseUrlApi + 'getCommentaries';
            vm.loading.commentaries = true;

            var commentary = {
                id: 0,
                idEstabelecimento: idEstab,
                idUsuario: idUser,
                type: 1,
                texto: '',
            };

            // console.log(url);
            // console.log('commentary: ', commentary);
            axios.post(url, commentary)
                .then(function (response) {
                    vm.loading.commentaries = false;

                    console.log("Response.data " + response.data);
                    console.log("Response.status " + response.status);
                    if (response.status == 200) {
                        console.log("Status::200::Comentarios recebidos com sucesso.");
                        console.log('comentários recebidos: ');
                        console.log(response.data);
                        vm.commentaries = response.data;

                        // Cria a variavel tx_trans logo, ela que vai ser utilizada na exibição do comentario.
                        for (let i = 0 ; i < vm.commentaries.length; i++) {
                            vm.commentaries[i].tx_trans = vm.commentaries[i].texto;
                            for (let j = 0 ; j < vm.commentaries[i].resps.length; j++) {
                                vm.commentaries[i].resps[j].tx_trans = vm.commentaries[i].resps[j].texto;
                            }
                        }

                        if (vm.user.idioma > 0) {
                            vm.$nextTick(function () {
                                vm.changeIdioma(vm.user.idioma);
                            });
                        }
                    }
                    else {
                        console.log('Erro ao buscar os comentarios. Status: ' + response.status);
                    }
                })
                .catch(function (error) {
                    vm.loading.commentaries = false;
                    console.log('Erro ao buscar os comentarios. url: ' + url);
                    console.log('Erro ao buscar os comentarios. Exception: ' + error);
                });
        },
        getCurrency (value) {
            if (value !== undefined) {
                return value.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}).substring(3);
            }
            return ''
        },
        getEstabsCatsHome(estabSimple) {
            console.log('Entrei no getEstabsCatsHome()');

            // var url1 = this.baseUrlApi + 'estabelecimentos';
            // var url2 = this.baseUrlApi + 'categorias';
            var url = this.baseUrlApi + 'estabsCates';

            var vm = this;
            vm.loading.cats = true;
            vm.loading.estabs = true;

            vm.stabsCatsTries++

            axios.get(url)
                .then(function (response) {
                    console.log('getEstabsCatsHome::response: ' + response.data.length);
                    console.log('getEstabsCatsHome::status code: ', response.status);

                    if (response.data.length == 2 && response.status === 200) {
                        vm.estabs_full = response.data[0];
                        vm.cats_full = response.data[1];

                        if (estabSimple != undefined && estabSimple != null) {
                            let estab = vm.getEstab(estabSimple)
                            vm.idEstab = estab.id;
                        }

                        console.log('Estabelecimentos:');
                        console.log(vm.estabs_full);
                        console.log('Categorias:');
                        console.log(vm.cats_full);

                        vm.adjustCaracterEncoding();
                        vm.atualizaParametros();

                        vm.loading.cats = false;
                        vm.loading.estabs = false;
                    } else {
                        if (vm.stabsCatsTries < vm.maxTries) {
                            setTimeout(function () {
                                vm.getEstabsCatsHome()
                            }, 2000);
                        } else {
                            vm.loading.cats = false;
                            vm.loading.estabs = false;
                        }
                    }
                })
                .catch(function(error) {
                    console.log('Error Catch: ' + error);
                    if (vm.stabsCatsTries < vm.maxTries) {
                        setTimeout(function () {
                            vm.getEstabsCatsHome(estabSimple)
                        }, 2000);
                    } else {
                        vm.loading.cats = false;
                        vm.loading.estabs = false;
                    }
                });
        },
        getEstabsCats() {
            console.log('Entrei no getEstabsCats()');

            // var url1 = this.baseUrlApi + 'estabelecimentos';
            // var url2 = this.baseUrlApi + 'categorias';
            var url = this.baseUrlApi + 'estabsCates';
            var vm = this;

            vm.loading.cats = true;
            vm.loading.estabs = true;

            axios.get(url)
                .then(function (response) {
                    console.log('estabsCates::mixin::response length: ' + response.data.length);
                    // vm.estabs_full = r1.data;
                    // vm.cats_full = r2.data;

                    console.log('estabsCates::status code: ', response.status);

                    if (response.data.length == 2 && response.status === 200) {
                        vm.estabs_full = response.data[0];
                        vm.cats_full = response.data[1];

                        console.log('estabsCates::mixin::Estabelecimentos:');
                        console.log(vm.estabs_full);
                        console.log('estabsCates::mixin::Categorias:');
                        console.log('cats: ', vm.cats_full);

                        // atualiza lista de cidades.
                        console.log('Cidades:');
                        vm.getCities();
                        console.log(vm.city_full);

                        vm.loading.cats = false;
                        vm.loading.estabs = false;
                    } else {
                        console.log('estabsCates::error carregando json')
                        if (vm.stabsCatsTries < vm.maxTries) {
                            setTimeout(function () {
                                vm.getEstabsCats()
                            }, 2000);
                        } else {
                            vm.loading.cats = false;
                            vm.loading.estabs = false;
                        }
                    }
                })
                .catch(function(error) {
                    vm.loading.cats = false;
                    vm.loading.estabs = false;
                    console.log('Error Catch' + error);

                    if (vm.stabsCatsTries < vm.maxTries) {
                        setTimeout(function () {
                            vm.getEstabsCats()
                        }, 2000);
                    } else {
                        vm.loading.cats = false;
                        vm.loading.estabs = false;
                    }
                });
        },
        getAnuncios () {
            // console.log('Entrei no getAnuncios()');

            var url = this.baseUrlApi + 'anuncios';
            var vm = this;

            vm.loading.anuncios = true;
            vm.anunciosTries++;

            axios.get(url)
                .then(function (response) {
                    // console.log('estabsCates::mixin::response: ' + response.data);
                    vm.anuncios = response.data

                    // console.log('getAnuncios::mixin::');
                    // console.log(vm.anuncios);
                    vm.loading.anuncios = false;
                })
                .catch(function(error) {
                    console.log('Error Catch' + error);

                    if (vm.anunciosTries < vm.maxTries) {
                        setTimeout(function () {
                            vm.getAnuncios()
                        }, 2000);
                    } else {
                        vm.loading.anuncios = false;
                    }
                });
        },
        sleep (time) {
            return new Promise((resolve) => setTimeout(resolve, time));
        },
        mascara(t, mask){
            var i = t.length;
            var saida = mask.substring(1,0);
            var texto = mask.substring(i)
            if (texto.substring(0,1) != saida){
                t += texto.substring(0,1);
            }
            t = t.substring(0, mask.length);
            return t;
        },
        mphone(v) {
            var r = v.texto.replace(/\D/g,"");
            r = r.replace(/^0/,"");
            if (r.length > 10) {
                // 11+ digits. Format as 5+4.
                r = r.replace(/^(\d\d)(\d{5})(\d{4}).*/,"($1) $2-$3");
            }
            else if (r.length > 5) {
                // 6..10 digits. Format as 4+4
                r = r.replace(/^(\d\d)(\d{4})(\d{0,4}).*/,"($1) $2-$3");
            }
            else if (r.length > 2) {
                // 3..5 digits. Add (..)
                r = r.replace(/^(\d\d)(\d{0,5})/,"($1) $2");
            }
            else {
                // 0..2 digits. Just add (
                r = r.replace(/^(\d*)/, "($1");
            }
            v.texto = r;
            return r;
        },
        trimAll(str){
            return str.replace(/\s/g,'');
        },
        getCity(i) {
            switch (i) {
                case 0: // portugues
                    return 'Português';
                case 1: // ingles
                    return 'English';
                case 2: // espanhol
                    return 'Español';
                default:
                    return 'Português';
            }
        },
        getIdioma(i) {
            switch (i) {
                case 0: // portugues
                    return 'Português';
                case 1: // ingles
                    return 'English';
                case 2: // espanhol
                    return 'Español';
                default:
                    return 'Português';
            }
        },
        setShowCookies(state) {
            console.log('setShowCookies')
            this.cookies_geral.showCookies = state;
            localStorage.setItem('cookies_geral', JSON.stringify(this.cookies_geral))
            console.log('setShowCookies: ', JSON.stringify(this.cookies_geral))
        },
        changeIdioma(i) {
            this.user.idioma = i;
            localStorage.setItem('user', JSON.stringify(this.user));
            console.log('Persisitndo data ' + localStorage.user);
            console.log('change idioma: ' + this.user.idioma);

            var lang = 'pt';
            switch (i) {
                case 0: // portugues
                    lang = 'pt'; break;
                case 1: // ingles
                    lang = 'en'; break;
                case 2: // espanhol
                    lang = 'es'; break;
            }
            console.log('this.name: ' + this.name);
            if (this.name == 'mEstabelecimento' || this.name == 'Estabelecimento' || this.name == 'MinhaPagina' || this.name == 'mMinhaPagina') {
                // this.trans2(lang);
                if (this.name == 'mEstabelecimento' || this.name == 'Estabelecimento')
                    this.translateDesc(lang, this.estab.descricao2);

                this.translateCommentaries(lang);
            }

            if (this.city_full.length > 0) {
                this.city_full.shift(); // remove primeiro elemento
                this.city_full.unshift({nome: this.getInterText(this.inter_ind.todas_cidades), quant: 0}); // insere na primeira posicao
                // this.city_full[0].nome = this.getInterText(this.inter_ind.todas_cidades);
            }

            // console.log('subCatIndex: ', this.subCatIndex - 1)
            // console.log('idCat: ', this.idCat)

            // this.subCatText = this.getInterCatName(this.cat);
            this.subCatText = this.getSubCats(this.idCat, this.subCatIndex - 1, this.user.idioma);
            console.log('change subcatText: ', this.subCatText)

            this.hideSideBar();
        },
        getCities() {
            var i, j, cj;
            var hasCity = false;
            this.city_full = [];

            for (i = 0; i < this.estabs_full.length; i++) {
                hasCity = false;
                for (j = 0; j < this.city_full.length; j++) {
                    if (this.estabs_full[i].cidade == this.city_full[j].nome) {
                        hasCity = true;
                        cj = j;
                        break;
                    }
                }

                if (!hasCity && this.estabs_full[i].cidade.length > 2)
                    this.city_full.push( { nome: this.estabs_full[i].cidade, quant: 1 });
                else {
                    if (this.city_full[cj] != undefined)
                        this.city_full[cj].quant++;
                }

            }

            this.city_full.sort(function(a, b) {
                if (a.nome < b.nome) { return -1; }
                else { return 1; }
            });

            // insere na primeira posicao
            this.city_full.unshift( { nome: this.getInterText(this.inter_ind.todas_cidades), quant: 0 } );

            // console.log('getCities::Cidades: ', this.city_full);
        },
        getSiteUrl(site) {
            if (site.startsWith('http'))
                return site;
            else
                return '//' + site;
        },
        decodeHtml(html) {
            var txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
        },
        showShare() {
            this.share = !this.share;
        },
        goShare(i) {
            var encodeUrl = 'https%3A%2F%2Fadviceparaiba.com%2Ftabuadasmares';
            var codeUrl = 'https://adviceparaiba.com/tabuadasmares';
            let url = ''
            switch (i) {
                case 0: url = 'https://api.whatsapp.com/send/?text=' + encodeUrl;
                    this.goToURL(url, '_blank'); break;
                case 1: url = 'https://facebook.com/sharer/sharer.php?u=' + encodeUrl;
                    this.goToURL(url, '_blank'); break;
                case 2:
                    navigator.clipboard.writeText(codeUrl).then(function() {
                        window.alert('Copiado!');
                    }, function(err) {
                        console.error('Async: Could not copy text: ', err);
                    })
                    break;
                default: url = 'default'
            }
            console.log('url: ', url)
            this.share = false;
        },
        getShareLink2(type, estab) {
            var nEncodeUrl =      'https://adviceparaiba.com/s/' + estab.nomeSimple;
            var encodeUrl = 'https%3A%2F%2Fadviceparaiba.com%2Fs%2F' + estab.nomeSimple;

            // var nome = encodeURIComponent(estab.nome);
            // .replace(/ /g, '%20');
            var nome = this.decodeHtml(estab.nome);

            switch (type) {
                case 0: {
                    this.copyToClipboard(nome + ' ' + nEncodeUrl);
                    this.showAlertMsg('Link Copiado: ' + nEncodeUrl);
                    return '';
                }
                case 1: return 'whatsapp://send?text=' + encodeUrl;
                case 2: return 'https://facebook.com/sharer/sharer.php?u=' + encodeUrl;
                case 3: return 'mailto:?subject=' + nome + '&body=' + encodeUrl;
                case 4: return 'https://www.addtoany.com/add_to/sms?linkurl=' + encodeUrl + '&linkname=' + nome;
                case 5: return 'https://twitter.com/intent/tweet/?text=' + nome + '&url=' + encodeUrl;
                case 6:
                    if (this.isMobile())
                        return 'fb-messenger://share/?link=' + encodeUrl + '&app_id=5303202981';
                    else
                        return 'https://www.facebook.com/dialog/send?app_id=5303202981&display=popup&link=' + encodeUrl + '&url=' + encodeUrl;
                default: return nEncodeUrl;
            }
        },
        getShareLink(type, item) {
            var id = item.id;
            var nEncodeUrl =      'http://adviceparaiba.com/#/mEstabelecimento?id=' + id;
            var encodeUrl = 'http%3A%2F%2Fadviceparaiba.com%2F%23%2FmEstabelecimento%3Fid%3D' + id;

            //var redirect = 'http%3A%2F%2Fttt.mangabeirashopping.com.br%2Fgo%3F';
            var redirect = 'https%3a%2f%2fstatic.addtoany.com%2fmenu%2fthanks.html';
            var nome = item.nome;


            switch (type) {
                case 0: {
                    this.copyToClipboard(nome + ' ' + nEncodeUrl);
                    this.showAlertMsg('Link Copiado: ' + nEncodeUrl);
                    return '';
                    //return 'https://www.addtoany.com/add_to/copy_link?linkurl=' + encodeUrl + '&linkname=' + nome;
                }
                case 1: return 'whatsapp://send?text=' + nome + '%20' + encodeUrl;
                case 2: return 'https://facebook.com/sharer/sharer.php?u=' + encodeUrl;
                case 3: return 'mailto:?subject=' + nome + '&body=' + encodeUrl;
                case 4: return 'https://www.addtoany.com/add_to/sms?linkurl=' + encodeUrl + '&linkname=' + nome;
                case 5: return 'https://twitter.com/intent/tweet/?text=' + nome + '&url=' + encodeUrl;
                case 6:
                    if (this.isMobile())
                        return 'fb-messenger://share/?link=' + encodeUrl + '&app_id=5303202981';
                    else
                        return 'https://www.facebook.com/dialog/send?app_id=5303202981&display=popup&link=' + encodeUrl + '&redirect_uri=' + redirect + '&url=' + encodeUrl;
                default: return 'http://ttt.mangabeirashopping.com.br';
            }
        },
        onresize() {
            //console.log('resize2 ' + window.innerHeight );
            var target = document.getElementById('sidebar');
            // console.log('target.sidebar.heigth :' + target.style.height);
            target.style.height = window.innerHeight + 'px';
        },
        calcBehindTime(comData) {
            var ret = '';
            //var currentdate = new Date('2015-04-30T12:25:40Z');
            var currentdate = new Date();
            var data2       = new Date(comData);

            // console.log('date1 : ', currentdate.toDateString());
            // console.log('date2 : ', comData);
            // console.log('date2 : ', data2);
            // console.log('date2 : ', data2.toDateString());

            var qMin =         60; // qtd de seg em 1 minuto
            var qHora =      3600; // qtd de seg em 1 hora   (60*60)
            var qDia =      86400; // qtd de seg em 1 dia    (60*60*24)
            var qSemana =  604800; // qtd de seg em 1 semana (60*60*24*7)
            var qMes =    2592000; // qtd de seg em 1 mes    (60*60*24*30)
            var qAno =   31536000; // qtd de seg em 1 ano    (60*60*24*365)

            var diff = currentdate.getTime() - data2.getTime();
            diff /= 1000;

            // console.log('diff : ', diff);
            if (diff < 10)
                ret = this.getInterText(this.inter_ind.agora);
            else if (diff < qMin)
                ret = parseInt(diff) + this.getInterText(this.inter_ind.seg_atras);
            else if (diff < qHora)
                ret = parseInt(diff/qMin) + this.getInterText(this.inter_ind.min_atras);
            else if (diff < qDia)
                ret = parseInt(diff/(qHora)) + 'h ' + this.getInterText(this.inter_ind.atras);
            else if (diff < qSemana)
                ret = parseInt(diff/(qDia)) + this.getInterText(this.inter_ind.dias_atras);
            else if (diff < qMes)
                ret = parseInt(diff/(qSemana)) + this.getInterText(this.inter_ind.semanas_atras)
            else if (diff < qAno)
                ret = parseInt(diff/(qMes)) + this.getInterText(this.inter_ind.meses_atras);
            else
                ret = parseInt(diff/(qAno)) + this.getInterText(this.inter_ind.anos_atras);

            // console.log('ret: ' + ret);

            return ret;
        },
        decodeChars(encodedStr) {
            if (!encodedStr) return '';
            // Decodificar entidades HTML
            return encodedStr.replace(/&nbsp;/g, ' ').replace(/<br\s*\/?>/g, '\n');
        },
        renderWithLineBreaks(text) {
            if (!text) return '';
            return text.replace(/\n/g, '<br>');
        },
        printItem(item) {
            console.log('Item: ', item)
            return ''
        },
        decodeChars2 (encodedStr) {
            console.log('decodeChars2_1: ', encodedStr)
            console.log('decodeChars2_2: ', decodeURIComponent(JSON.parse('\"' + encodedStr + '\"')))

            return decodeURIComponent(JSON.parse('\"' + encodedStr + '\"'))
        },
        configureViewPort(dinamic) {
            console.log('configureViewPort: ', dinamic)
            // if (this.windowWidth == 0) {

            // }
            let viewport = document.querySelector("meta[name=viewport]");

            if (dinamic) {
                viewport.setAttribute("content", "height=device-height, width=device-width, initial-scale=1.0");
            }
            else {
                var height = $(window).height();
                var width = $(window).width();
                viewport.setAttribute("content", "height=" + height + ", width=" + width + ", initial-scale=1.0");
            }

            // if (orientation == 0 || orientation == 180)
            //     viewport.setAttribute("content", "height=" + this.windowHeight + ", width=" + this.windowWidth + ", initial-scale=1.0");
            // else
            //     viewport.setAttribute("content", "height=" + this.windowWidth + ", width=" + this.windowHeight + ", initial-scale=1.0");

            // viewport.setAttribute("content", "height=" + viewheight + ", width=" + viewwidth + ", initial-scale=1.0");
            // viewport.setAttribute("content", "height=device-height, width=device-width, initial-scale=1.0");
            // var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            // var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            // $("html, body").css({"width":w,"height":h});
        },
        changeCheckState(i) {
            if (i==0) {
                this.valid.enterAuto = !this.valid.enterAuto;
            }
            if (i==1) {
                this.valid.termos = !this.valid.termos;
            }
            //console.log('changeCheckState' + i );
        },
        googleTranslateElementInit() {
            new google.translate.TranslateElement({
                pageLanguage: 'auto',
                autoDisplay: false,
                layout: google.translate.TranslateElement.InlineLayout.SIMPLE
            }, 'google_translate_element');
        },
        myBack() {
            console.log('myBack ');
            console.log('myBack ');
            console.log('myBack ');
            console.log('myBack ');
            console.log('myBack ');
            console.log('myBack::window.history.length ', window.history.length);
            alert('browser-back');
            // if (window.history.length > 2)
            //     vm.$router.back();
            // else {
            //     if (vm.isMobile())
            //         vm.$router.push({name: 'mMinhaPagina'});
            //     else
            //         vm.$router.push({name: 'mMinhaPagina'});
            // }
        },
        myBack2() {
            console.log('myBack2 ');
            window.popStateDetected = true;
            console.log("myBack2::window.popStateDetected: ", window.popStateDetected);
        },
        scrollEstabs(cat, right, index, inc) {
            var divname = 'scrollhorizontal' + index;
            var el = $('#' + divname);
            var el2 = document.getElementById(divname);
            var offsetLeft;
            var vm = this;
            var maxWidth = el2.scrollWidth;
            var increStep = el2.clientWidth * (5.0 / 5.0);
            // console.log('divname: ' + divname);
            // console.log('scrollEstabs: ', el);
            // console.log('inc: ', inc);

            if (inc != undefined) {
                increStep = inc;
            }
            // console.log('increStep: ', increStep);

            if (cat.offsetLeft == undefined) {
                cat.offsetLeft = 0;
            }
            offsetLeft = cat.offsetLeft;

            // console.log('1scrollEstabs:el.offset ', el.offset());
            // console.log('1scrollEstabs:el.scrollLeft ', el.scrollLeft());
            // console.log('1scrollEstabs:el.width  ', el.width());
            // console.log('1scrollEstabs:el.clientHeight  ', el.clientHeight);
            // console.log('1scrollEstabs:el.scrollHeight  ', el.scrollHeight);
            //
            // console.log('2scrollEstabs:el.width  ', el2.width);
            // console.log('2scrollEstabs:el.clientWidth  ', el2.clientWidth);
            // console.log('2scrollEstabs:el.scrollWidth  ', el2.scrollWidth);

            if (right) {
                offsetLeft += increStep;
                if (offsetLeft > maxWidth)
                    offsetLeft = maxWidth;
            }
            else {
                offsetLeft -= increStep;
                if (offsetLeft < 0)
                    offsetLeft = 0;
            }

            // console.log('scrolCategorias.offsetLeft ', offsetLeft);
            cat.offsetLeft = offsetLeft;
            //console.log('offsetLeft  ', offsetLeft);


            if (increStep < 50) {
                // faz rapido
                el.scrollLeft(offsetLeft);

                vm.$nextTick(function () {
                    setTimeout(function () {
                        var ell = $('#scrollleft' + index);
                        var elr = $('#scrollright' + index);

                        if ((ell.is(':hover') && !right) || (elr.is(':hover') && right)) {
                            vm.scrollEstabs(cat, right, index, 15);
                        }
                    }, 100);
                });

            } else {
                // faz suave
                el.animate({'scrollLeft': offsetLeft}, 500);
                //el.scrollLeft(offsetLeft);
            }
        },

        selectCat(index) {
            console.log('selecCat index ' + index);
            if (this.cats_full[index].deleted == false) {
                if (this.quantCatsSelected < 3) {
                    this.cats_full[index].deleted = true;
                    this.quantCatsSelected++;
                }
            }
            else {
                this.quantCatsSelected--;
                this.cats_full[index].deleted = false;
            }
        },
        initQuantCats() {
            let i;
            for (i = 0; i< this.cats_full.length; i++) {
                if (this.cats_full[i].deleted == true)
                    this.quantCatsSelected++;
            }
        },
        getCat(id) {
            let i;
            for (i = 0; i< this.cats_full.length; i++) {
                if (this.cats_full[i].id == id) {
                    return this.cats_full[i];
                }
            }

            return {};
        },
        getSubCat(id) {
            let i;
            for (i = 0; i < this.cats_sub.length; i++) {
                if (this.cats_sub[i].fatherId == id) {
                    switch (this.user.idioma) {
                        case 1:
                            return this.cats_sub[i].subs_en;
                        case 2:
                            return this.cats_sub[i].subs_es;
                        default:
                            return this.cats_sub[i].subs;
                    }
                }
            }

            return [];
        },
        prepareImagesLoading () {
            var images = $('img')  // Get all images. (you'll want to modify the selector to work with only the desired images)
            var vm = this

            console.log('prepareImagesLoading::images: ', images.length)
            for (let i = 0; i < images.length; i++) {
                console.log(i + '::prepareImagesLoading::img: ', images[i].src)

                // images[i].onload = function() {       // Add a load event hander that removes
                //     console.log('imagem carregada ', this.src)
                //     images = images.not(this); //    each image from images once loaded.
                //     console.log('lista imagens:',  images.length)
                // };
                images[i].onerror = function() {
                    vm.tryReloadImages(this)
                }
            }


        },
        tryReloadImages(img) {
            console.log('tryReloadImages::img: ', img)
            // aguarda 1seg e tenta novamente.
            setTimeout(function() { // After 2 seconds, iterate over each remaining
                console.log('tryReloadImages::nao carregada::img: ', img.src)
                console.log('recarregando imagem ', img.src)
                let parT = img.src.indexOf('?t=')
                if (parT > 0) {
                    img.src = img.src.substring(0, parT) + '?t=' + (new Date().getTime())
                } else {
                    img.src = img.src + '?t=' + (new Date().getTime())
                }
            }, 1000)
        },
        tryReloadImagesOld() {
            setTimeout(function(){        // After 10 seconds, iterate over each remaining
                console.log('total nao carregado: ', images.length)
                for (let i = 0; i < images.length; i++) {
                    console.log(i + '::nao carregadas::img: ', images[i].src)
                }

                images.each(function() {  //     image, reloading each one
                    console.log('recarregando imagem ', this.src)
                    this.src = this.src + '?t=' + (new Date().getTime())
                });
            },10000);  // run after 10 seconds
        },
        shuffle(array) {
            let currentIndex = array.length,  randomIndex;

            // While there remain elements to shuffle.
            while (currentIndex > 0) {

                // Pick a remaining element.
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex--;

                // And swap it with the current element.
                [array[currentIndex], array[randomIndex]] = [
                    array[randomIndex], array[currentIndex]];
            }

            return array;
        }
    },

    created() {
        // console.log("created advMixin::vou ler o local storage.");
        // console.log("created advMixin::window.popStateDetected: ", window.popStateDetected);

        console.log('location.href: ', location.href);
        if (location.protocol !== 'https:' && !location.href.includes('192.168.15')) {
            location.replace(`https:${location.href.substring(location.protocol.length)}`);
        }

        if (localStorage.getItem('user')) {
            // this.user = localStorage.getItem('user');
            this.user = JSON.parse(localStorage.getItem('user'));
            try {
                this.user.nome = decodeURIComponent(escape(this.user.nome));
            } catch (e) {
                this.user.nome = unescape(this.user.nome);
            }
        } else {
            localStorage.setItem('user', JSON.stringify(this.new_user));
        }

        if (localStorage.getItem('cookies_geral')) {
            this.cookies_geral = JSON.parse(localStorage.getItem('cookies_geral'));
        }

        // Funcao para fechar a janela do popup do Minha Pagina
        var vm = this;
        $(document).mouseup(function(e)
        {

            if (vm.showPopupEscritorio) {
                // console.log('vm.showPopupEscritorio1: ', vm.showPopupEscritorio)
                var container = $("#popup_escritorio");
                // console.log('Entrei no mouseup, container::', container);
                // console.log('e.target::', e.target);
                // console.log('e.target.id::', e.target.id);
                // console.log('1::container.has(e.target).length: ', container.has(e.target).length)
                // console.log('2::container.is(e.target): ', container.is(e.target))
                if (!container.is(e.target) && container.has(e.target).length === 0) {
                    if (e.target.id.startsWith('botao_profile')) {
                        console.log('cliquei no botao profile')
                        vm.showPopupEscritorio = true;
                    } else {
                        vm.showPopupEscritorio = false;
                    }

                }

                // console.log('3::vm.showPopupEscritorio2: ', vm.showPopupEscritorio)
                return false;
            }
            if (vm.showAvaliacao) {
                var container = $("#popup_avaliacao");
                console.log('Entrei no mouseup::', container);
                // if the target of the click isn't the container nor a descendant of the container
                if (!container.is(e.target) && container.has(e.target).length === 0) {
                    vm.showAvaliacao = false;
                }
            }
        });

        if (this.$route.params.idCat != null) {
            this.idCat = this.$route.params.idCat;
            console.log('created::idCat ' + this.idCat);
        }

        // embaralha o advertisements
        this.shuffle(this.ads);

        // window.addEventListener('orientationchange', function(){
        //     vm.configureViewPort(window.orientation);
        // });

        // $(document).mouseup(function (e)
        // {
        //     var container = new Array();
        //     container.push($('#popup_escritorio'));
        //     container.push($('#item_2'));
        //
        //     $.each(container, function(key, value) {
        //         if (!$(value).is(e.target) // if the target of the click isn't the container...
        //             && $(value).has(e.target).length === 0) // ... nor a descendant of the container
        //         {
        //             vm.showPopupEscritorio = false;
        //             //$(value).hide();
        //         }
        //     });
        // });
    },

    mounted() {
        console.log('mounted advMixin 123');
        // console.log("mounted advMixin::window.popStateDetected: ", window.popStateDetected);
        // this.onresize();
        //$( window ).resize(this.onresize);

        // document.addEventListener("backbutton", this.myBack, false);

        // comentei essa chamada do myBack2 11/06/2021.
        // window.addEventListener('popstate', this.myBack2);
        // window.onpopstate = this.myBack;

        // this.configureViewPort(window.orientation);

        // var teste = 'http://youtube.com/watch?v' + '\\u' + '003do9er8hCkcNc';
        // console.log('teste11: ' + teste);
        // teste = teste.replace('\\u003d','=');
        // console.log('teste22: ' + teste);

        console.log('prepareImagesLoading::vou chamar')

        this.prepareImagesLoading()
    },
    beforeDestroy () {
        // document.removeEventListener("backbutton", this.myBack);
        // window.removeEventListener('popstate', this.myBack2);
    }
};




// WEBPACK FOOTER //
// ./src/scripts/advMixin.js